var vc = Object.defineProperty;
var bc = (e, t, n) => t in e ? vc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var is = (e, t, n) => bc(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as i, jsxs as p, Fragment as ce } from "react/jsx-runtime";
import * as st from "@radix-ui/react-accordion";
import { ChevronDown as Vo, ChevronRight as Eo, ChevronLeft as xc, SearchIcon as wc, Calendar as Ro, Check as Lo, Circle as kc, ChevronUp as Nc } from "lucide-react";
import * as S from "react";
import K, { useReducer as Sc, useCallback as De, useEffect as Ae, useMemo as Zt, useState as se, useRef as Ee, createContext as Nt, useLayoutEffect as Tc, useContext as me, useId as $r, Fragment as Bo, createElement as Cc, useInsertionEffect as Pc, forwardRef as Mc, Component as Dc } from "react";
import { clsx as Ic } from "clsx";
import { extendTailwindMerge as Ac } from "tailwind-merge";
import { cva as Ve } from "class-variance-authority";
import { create as Fo } from "zustand";
import { Slot as En } from "@radix-ui/react-slot";
import * as bt from "@radix-ui/react-tooltip";
import * as zo from "@radix-ui/react-separator";
import { DayPicker as Vc } from "react-day-picker";
import * as Hr from "recharts";
import { Command as ot } from "cmdk";
import * as X from "@radix-ui/react-dialog";
import * as tt from "@radix-ui/react-scroll-area";
import * as jt from "@radix-ui/react-popover";
import { format as It } from "date-fns";
import * as Z from "@radix-ui/react-dropdown-menu";
import Ec, { BasePlugin as Rc } from "@uppy/core";
import { UppyContextProvider as Lc, useUppyContext as Bc } from "@uppy/react";
import { useDropzone as Fc } from "react-dropzone";
import * as jo from "@radix-ui/react-label";
import { useFormContext as zc, FormProvider as jc, Controller as _c } from "react-hook-form";
import * as ss from "@radix-ui/react-checkbox";
import Oc from "react-dom";
import * as pr from "@radix-ui/react-radio-group";
import * as ie from "@radix-ui/react-select";
import * as os from "@radix-ui/react-switch";
import { flexRender as Vt, useReactTable as $c, getExpandedRowModel as Hc, getPaginationRowModel as Uc, getSortedRowModel as Wc, getCoreRowModel as Gc } from "@tanstack/react-table";
import { useVirtualizer as Kc } from "@tanstack/react-virtual";
import { toast as as, Toaster as Xc } from "sonner";
import * as at from "@radix-ui/react-tabs";
const Yc = Ac({
  extend: {
    classGroups: {
      "font-size": [
        "text-size-display-xl",
        "text-size-display-lg",
        "text-size-h1",
        "text-size-h2",
        "text-size-h3",
        "text-size-h4",
        "text-size-body-lg",
        "text-size-body-sm",
        "text-size-caption",
        "text-size-label",
        "text-size-section-label"
      ],
      shadow: [
        "shadow-small-grey",
        "shadow-small-orange",
        "shadow-md-grey",
        "shadow-md-orange",
        "shadow-system"
      ]
    }
  }
});
function m(...e) {
  return Yc(Ic(...e));
}
const Cy = st.Root, Zc = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  st.Item,
  {
    ref: n,
    className: m(" ", e),
    ...t
  }
));
Zc.displayName = "AccordionItem";
const qc = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(st.Header, { className: "flex", children: /* @__PURE__ */ p(
  st.Trigger,
  {
    ref: r,
    className: m(
      "flex flex-1 cursor-pointer items-center gap-2 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ i(Vo, { className: "w-4 h-4 mb-1 transition-transform duration-200 stroke-current shrink-0" })
    ]
  }
) }));
qc.displayName = st.Trigger.displayName;
const Jc = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(
  st.Content,
  {
    ref: r,
    className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
    ...n,
    children: /* @__PURE__ */ i("div", { className: m("pb-4 pt-0", e), children: t })
  }
));
Jc.displayName = st.Content.displayName;
const Qc = S.forwardRef(({ className: e, number: t, hasError: n, ...r }, s) => {
  const a = t.toString().padStart(2, "0");
  return /* @__PURE__ */ i(
    "div",
    {
      ref: s,
      className: m(
        "flex items-center justify-center text-lg tracking-tightest text-ink-primary font-sentric font-extrabold opacity-10 dark:opacity-30 shrink-0 w-8",
        n && "text-ink-accent opacity-75 dark:opacity-100",
        e
      ),
      ...r,
      children: /* @__PURE__ */ i("div", { children: a })
    }
  );
});
Qc.displayName = "AccordionItemNumber";
const j = Fo((e) => ({
  isTunecore: !1,
  setIsTunecore: (t) => {
    typeof document < "u" && (t ? document.documentElement.setAttribute("data-theme", "tunecore") : document.documentElement.removeAttribute("data-theme")), e({ isTunecore: t });
  }
}));
function ed(e) {
  const t = m("text-ink-primary", e ? "font-tunecore" : "font-sentric");
  return e ? {
    h1: m(t, "text-[2rem] font-black leading-[1.167] tracking-[-0.025rem]"),
    h2: m(t, "text-[1.3rem] lg:text-[1.5rem] shrink font-black"),
    h3: m(t, "text-[1.875rem] font-black"),
    h4: m(t, "text-[1rem] font-bold"),
    // Display sizes are a new-design-system-only addition (hero/landing
    // surfaces); tunecore has no equivalent spec, so these are size-only
    // placeholders — revisit if/when a tunecore surface needs them.
    displayLg: m(t, "text-[3.05rem] font-normal"),
    displayXl: m(t, "text-[4rem] font-normal")
  } : {
    // Sentric Design System v1.0 (June 2026) type scale — values confirmed
    // against live Figma text styles, not just the PDF doc. H3 and H4 are
    // both Semibold (600) despite the PDF and Figma's own printed dev-spec
    // labels both stating 500 — confirmed against the underlying Figma
    // style data (font-name "Semibold", weight 600), same stale-label
    // pattern as Body LG's printed "18px" vs its real 20px.
    h1: m(t, "text-size-h1 font-normal leading-[1.15] tracking-[-0.01em]"),
    h2: m(t, "text-size-h3 lg:text-size-h2 shrink font-normal leading-[1.15] tracking-[-0.01em]"),
    h3: m(t, "text-size-h3 font-semibold leading-[1.2] tracking-[-0.01em]"),
    h4: m(t, "text-size-h4 font-semibold leading-[1.25] tracking-[-0.01em]"),
    // Hero/landing surfaces only (Figma: "Hero headlines, landing page
    // primary" / "Section heroes, feature intros") — still H1-level
    // semantically, so both render as <h1> via the Component map below.
    displayLg: m(t, "text-size-display-lg font-normal leading-[1.08] tracking-[-0.01em]"),
    displayXl: m(t, "text-size-display-xl font-normal leading-[1.05] tracking-[-0.01em]")
  };
}
function _o(e, t) {
  return ed((t == null ? void 0 : t.isTunecore) ?? !1)[e];
}
const Oo = K.forwardRef(({
  children: e,
  as: t = "h1",
  className: n = "",
  ...r
}, s) => {
  const a = j((c) => c.isTunecore), o = t === "displayLg" || t === "displayXl" ? "h1" : t, l = _o(t, { isTunecore: a });
  return /* @__PURE__ */ i(o, { ref: s, className: m(l, n), ...r, children: e });
});
Oo.displayName = "Heading";
const td = Ve(
  "relative w-full rounded-sm border p-4",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-stroke-error bg-layer-error text-ink-error",
        warning: "border-stroke-warning bg-layer-warning text-ink-warning",
        success: "border-stroke-success bg-layer-success text-ink-success",
        info: "border-stroke-info bg-layer-info text-ink-info"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), $o = S.forwardRef(({ className: e, variant: t, ...n }, r) => {
  const s = j((o) => o.isTunecore), a = S.useMemo(() => {
    if (!s)
      return "";
    switch (t) {
      case "destructive":
        return "text-white bg-[rgba(244,67,54,0.2)] font-tunecore border-none";
      case "warning":
        return "border-yellow-400 bg-layer-inverse text-white";
      case "success":
        return "border-stroke-primary bg-layer-inverse text-white";
      case "info":
        return "border-blue-400 bg-layer-inverse text-white";
      case "default":
      case void 0:
      case null:
      default:
        return "bg-layer-inverse text-white border-stroke-subtle";
    }
  }, [s, t]);
  return /* @__PURE__ */ i(
    "div",
    {
      ref: r,
      role: "alert",
      className: m(
        td({ variant: t }),
        // TuneCore predates this radius token system and has no radius spec
        // of its own — restore the exact rounded-lg (8px) it always rendered
        // at, rather than silently inheriting Sentric's new rounded-sm (6px).
        s && "rounded-lg",
        s && a,
        e
      ),
      ...n
    }
  );
});
$o.displayName = "Alert";
const gr = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(
  Oo,
  {
    as: "h4",
    ref: r,
    className: m(
      "mb-2 font-semibold",
      e
    ),
    ...n,
    children: t
  }
));
gr.displayName = "AlertTitle";
const yr = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ i(
  "p",
  {
    ref: r,
    className: m(
      "font-sentric-alt",
      e
    ),
    ...n,
    children: t
  }
));
yr.displayName = "AlertDescription";
const nd = ({
  message: e,
  formErrors: t,
  validationIssues: n,
  title: r,
  showDebug: s = !0,
  className: a,
  variant: o = "destructive"
}) => {
  const l = j((f) => f.isTunecore), c = e != null && e.trim() !== "", u = t != null && Object.keys(t).length > 0, d = n != null && n.length > 0;
  if (!c && !u && !d)
    return null;
  const h = l ? "font-tunecore" : "font-sentric-alt";
  return /* @__PURE__ */ p($o, { variant: o, className: a, children: [
    c && !u && !d && /* @__PURE__ */ p(ce, { children: [
      /* @__PURE__ */ i(gr, { children: r != null && r.trim() !== "" ? r : "Error" }),
      /* @__PURE__ */ i(yr, { children: /* @__PURE__ */ i("p", { className: h, children: e }) })
    ] }),
    (u || d) && /* @__PURE__ */ p(ce, { children: [
      /* @__PURE__ */ i(gr, { children: r != null && r.trim() !== "" ? r : "Please fix the following issues:" }),
      /* @__PURE__ */ i(yr, { children: /* @__PURE__ */ p("div", { className: "space-y-1", children: [
        u && Object.entries(t).map(([f, g]) => {
          let y = "Unknown error";
          if (g != null && typeof g == "object" && "message" in g) {
            const v = g;
            typeof v.message == "string" && (y = v.message);
          }
          return /* @__PURE__ */ p("div", { children: [
            /* @__PURE__ */ p("p", { className: h, children: [
              "•",
              " ",
              y
            ] }),
            s && !1
          ] }, f);
        }),
        d && n.map((f) => /* @__PURE__ */ p("p", { className: h, children: [
          "•",
          " ",
          f
        ] }, f))
      ] }) })
    ] })
  ] });
}, rd = Ve(
  "inline-flex items-center justify-center rounded-lg border px-3 py-1 text-sm font-medium font-sentric-alt w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default: "border-transparent bg-layer-raised text-ink-primary",
        primary: "border-transparent bg-action-primary text-white",
        secondary: "border-transparent bg-layer-strong text-ink-primary",
        success: "border-transparent bg-layer-success text-ink-success",
        warning: "border-transparent bg-layer-warning text-ink-warning",
        danger: "border-transparent bg-layer-error text-ink-error",
        info: "border-transparent bg-layer-info text-ink-info",
        neutral: "border-transparent bg-ink-secondary text-white",
        muted: "border-transparent bg-ink-secondary text-white",
        outline: "text-ink-primary border-stroke-subtle"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Py({
  className: e,
  variant: t,
  asChild: n = !1,
  ...r
}) {
  return /* @__PURE__ */ i(
    n ? En : "span",
    {
      "data-slot": "badge",
      className: m(rd({ variant: t }), e),
      ...r
    }
  );
}
const id = {
  md: "w-4 h-4",
  lg: "w-6 h-6",
  xl: "w-8 h-8"
};
function P({
  children: e,
  height: t,
  className: n,
  width: r,
  viewBox: s = "0 0 24 24",
  disabled: a = !1,
  size: o = "md",
  ...l
}) {
  return /* @__PURE__ */ i(
    "svg",
    {
      className: m(id[o], "transition ease-out duration-200", a && "opacity-15", n),
      xmlns: "http://www.w3.org/2000/svg",
      width: r,
      height: t,
      viewBox: s,
      fill: "none",
      strokeWidth: "1.75",
      preserveAspectRatio: "xMidYMid meet",
      ...l,
      children: e
    }
  );
}
function sd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 19V5" }),
    /* @__PURE__ */ i("path", { d: "m13 6-6 6 6 6" }),
    /* @__PURE__ */ i("path", { d: "M7 12h14" })
  ] });
}
function od(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M17 12H3" }),
    /* @__PURE__ */ i("path", { d: "m11 18 6-6-6-6" }),
    /* @__PURE__ */ i("path", { d: "M21 5v14" })
  ] });
}
function ad(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "m9 18 6-6-6-6" }) });
}
function ld(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "m15 18-6-6 6-6" }) });
}
function My(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4" }),
    /* @__PURE__ */ i("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
    /* @__PURE__ */ i("path", { d: "M2 15h10" }),
    /* @__PURE__ */ i("path", { d: "m9 18 3-3-3-3" })
  ] });
}
function cd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "10", cy: "10", r: "6" }),
    /* @__PURE__ */ i("path", { d: "M14 14L20 20" })
  ] });
}
function dd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m13.5 8.5-5 5" }),
    /* @__PURE__ */ i("path", { d: "m8.5 8.5 5 5" }),
    /* @__PURE__ */ i("circle", { cx: "11", cy: "11", r: "8" }),
    /* @__PURE__ */ i("path", { d: "m21 21-4.3-4.3" })
  ] });
}
function ud(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M11 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5" }),
    /* @__PURE__ */ i("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
    /* @__PURE__ */ i("path", { d: "m15 17 5 5" }),
    /* @__PURE__ */ i("path", { d: "m20 17-5 5" })
  ] });
}
function Dy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "10", cy: "8", r: "5" }),
    /* @__PURE__ */ i("path", { d: "M2 21a8 8 0 0 1 10.434-7.62" }),
    /* @__PURE__ */ i("circle", { cx: "18", cy: "18", r: "3" }),
    /* @__PURE__ */ i("path", { d: "m22 22-1.9-1.9" })
  ] });
}
function Iy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m11 17 2 2a1 1 0 1 0 3-3" }),
    /* @__PURE__ */ i("path", { d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" }),
    /* @__PURE__ */ i("path", { d: "m21 3 1 11h-2" }),
    /* @__PURE__ */ i("path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" }),
    /* @__PURE__ */ i("path", { d: "M3 4h8" })
  ] });
}
function Ay(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2 10v3" }),
    /* @__PURE__ */ i("path", { d: "M6 6v11" }),
    /* @__PURE__ */ i("path", { d: "M10 3v18" }),
    /* @__PURE__ */ i("path", { d: "M14 8v7" }),
    /* @__PURE__ */ i("path", { d: "M18 5v13" }),
    /* @__PURE__ */ i("path", { d: "M22 10v3" })
  ] });
}
function Vy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }),
    /* @__PURE__ */ i("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }),
    /* @__PURE__ */ i("path", { d: "M12 11h4" }),
    /* @__PURE__ */ i("path", { d: "M12 16h4" }),
    /* @__PURE__ */ i("path", { d: "M8 11h.01" }),
    /* @__PURE__ */ i("path", { d: "M8 16h.01" })
  ] });
}
function Ey(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { x: "3", y: "5", width: "6", height: "6", rx: "1" }),
    /* @__PURE__ */ i("path", { d: "m3 17 2 2 4-4" }),
    /* @__PURE__ */ i("path", { d: "M13 6h8" }),
    /* @__PURE__ */ i("path", { d: "M13 12h8" }),
    /* @__PURE__ */ i("path", { d: "M13 18h8" })
  ] });
}
function Ry(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "20", height: "14", x: "2", y: "5", rx: "2" }),
    /* @__PURE__ */ i("line", { x1: "2", x2: "22", y1: "10", y2: "10" })
  ] });
}
function Ly(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("line", { x1: "12", x2: "12", y1: "2", y2: "22" }),
    /* @__PURE__ */ i("path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" })
  ] });
}
function By(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18 21a8 8 0 0 0-16 0" }),
    /* @__PURE__ */ i("circle", { cx: "10", cy: "8", r: "5" }),
    /* @__PURE__ */ i("path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" })
  ] });
}
function Fy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" }),
    /* @__PURE__ */ i("path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" }),
    /* @__PURE__ */ i("path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" }),
    /* @__PURE__ */ i("path", { d: "M10 6h4" }),
    /* @__PURE__ */ i("path", { d: "M10 10h4" }),
    /* @__PURE__ */ i("path", { d: "M10 14h4" }),
    /* @__PURE__ */ i("path", { d: "M10 18h4" })
  ] });
}
function zy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
    /* @__PURE__ */ i("path", { d: "M8 12h8" }),
    /* @__PURE__ */ i("path", { d: "M10 11v2" }),
    /* @__PURE__ */ i("path", { d: "M8 17h8" }),
    /* @__PURE__ */ i("path", { d: "M14 16v2" })
  ] });
}
function jy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2" }),
    /* @__PURE__ */ i("path", { d: "M8.5 2h7" }),
    /* @__PURE__ */ i("path", { d: "M7 16h10" })
  ] });
}
function _y(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9" }),
    /* @__PURE__ */ i("path", { d: "M20 3v4" }),
    /* @__PURE__ */ i("path", { d: "M22 5h-4" })
  ] });
}
function Oy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "4" }),
    /* @__PURE__ */ i("path", { d: "M12 2v2" }),
    /* @__PURE__ */ i("path", { d: "M12 20v2" }),
    /* @__PURE__ */ i("path", { d: "m4.93 4.93 1.41 1.41" }),
    /* @__PURE__ */ i("path", { d: "m17.66 17.66 1.41 1.41" }),
    /* @__PURE__ */ i("path", { d: "M2 12h2" }),
    /* @__PURE__ */ i("path", { d: "M20 12h2" }),
    /* @__PURE__ */ i("path", { d: "m6.34 17.66-1.41 1.41" }),
    /* @__PURE__ */ i("path", { d: "m19.07 4.93-1.41 1.41" })
  ] });
}
function $y(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M9 3v18" }),
    /* @__PURE__ */ i("path", { d: "m16 15-3-3 3-3" })
  ] });
}
function Hy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "18", height: "18", x: "3", y: "3", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M15 3v18" }),
    /* @__PURE__ */ i("path", { d: "m8 9 3 3-3 3" })
  ] });
}
function Uy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("line", { x1: "4", x2: "20", y1: "12", y2: "12" }),
    /* @__PURE__ */ i("line", { x1: "4", x2: "20", y1: "6", y2: "6" }),
    /* @__PURE__ */ i("line", { x1: "4", x2: "20", y1: "18", y2: "18" })
  ] });
}
function Wy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    /* @__PURE__ */ i("polyline", { points: "7 10 12 15 17 10" }),
    /* @__PURE__ */ i("line", { x1: "12", x2: "12", y1: "15", y2: "3" })
  ] });
}
function Gy(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "M5 12h14" }) });
}
function Ho(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m18 15-6-6-6 6" }) });
}
function Ur(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m15 18-6-6 6-6" }) });
}
function Wr(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m9 18 6-6-6-6" }) });
}
function Et(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "m6 9 6 6 6-6" }) });
}
function nt(e) {
  return /* @__PURE__ */ i(P, { strokeWidth: 2, ...e, children: /* @__PURE__ */ i("path", { d: "M20 6 9 17l-5-5" }) });
}
function Uo(e) {
  return /* @__PURE__ */ p(P, { strokeWidth: 2, ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18 6 6 18" }),
    /* @__PURE__ */ i("path", { d: "m6 6 12 12" })
  ] });
}
function hd(e) {
  return /* @__PURE__ */ i(
    P,
    {
      strokeWidth: 0.2,
      className: "transition duration-200 ease-out fill-canvas-inverse group-active:invert",
      width: 17,
      height: 14,
      viewBox: "0 0 17 14",
      ...e,
      children: /* @__PURE__ */ i("path", { d: "M10.7679 13.5L9.63085 12.5702L14.8874 7.70746H0V6.29831H14.8812L9.63085 1.42981L10.7679 0.5L17 6.29254V7.70169L10.7679 13.4942V13.5Z" })
    }
  );
}
function Ky(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "m15 18-6-6 6-6" }) });
}
function fd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }),
    /* @__PURE__ */ i("path", { d: "M21 3v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }),
    /* @__PURE__ */ i("path", { d: "M8 16H3v5" })
  ] });
}
function Xy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M12 8v5" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01", strokeLinecap: "round", strokeWidth: "2" })
  ] });
}
function Yy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M12 8v5" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01", strokeLinecap: "round", strokeWidth: "2" }),
    /* @__PURE__ */ i("path", { d: "M2 2l20 20", strokeWidth: "2" })
  ] });
}
function md(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 6h18" }),
    /* @__PURE__ */ i("path", { d: "M7 12h10" }),
    /* @__PURE__ */ i("path", { d: "M10 18h4" })
  ] });
}
function Wo(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18 6 6 18" }),
    /* @__PURE__ */ i("path", { d: "m6 6 12 12" })
  ] });
}
function pd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "5", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "19", r: "1" })
  ] });
}
function gd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m15 15 6 6" }),
    /* @__PURE__ */ i("path", { d: "m15 9 6-6" }),
    /* @__PURE__ */ i("path", { d: "M21 16v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M21 8V3h-5" }),
    /* @__PURE__ */ i("path", { d: "M3 16v5h5" }),
    /* @__PURE__ */ i("path", { d: "m3 21 6-6" }),
    /* @__PURE__ */ i("path", { d: "M3 8V3h5" }),
    /* @__PURE__ */ i("path", { d: "M9 9 3 3" })
  ] });
}
function Zy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
    /* @__PURE__ */ i("path", { d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z" })
  ] });
}
function yd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M5 12h14" }),
    /* @__PURE__ */ i("path", { d: "M12 5v14" })
  ] });
}
function qy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2" }),
    /* @__PURE__ */ i("path", { d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" }),
    /* @__PURE__ */ i("circle", { cx: "10", cy: "7", r: "4" })
  ] });
}
function Go(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 6h18" }),
    /* @__PURE__ */ i("path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" }),
    /* @__PURE__ */ i("path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" }),
    /* @__PURE__ */ i("line", { x1: "10", x2: "10", y1: "11", y2: "17" }),
    /* @__PURE__ */ i("line", { x1: "14", x2: "14", y1: "11", y2: "17" })
  ] });
}
function vd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "7", r: "4" })
  ] });
}
function bd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
    /* @__PURE__ */ i("circle", { cx: "9", cy: "7", r: "4" }),
    /* @__PURE__ */ i("path", { d: "M22 21v-2a4 4 0 0 0-3-3.87" }),
    /* @__PURE__ */ i("path", { d: "M16 3.13a4 4 0 0 1 0 7.75" })
  ] });
}
function Jy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72" }),
    /* @__PURE__ */ i("path", { d: "m14 7 3 3" }),
    /* @__PURE__ */ i("path", { d: "M5 6v4" }),
    /* @__PURE__ */ i("path", { d: "M19 14v4" }),
    /* @__PURE__ */ i("path", { d: "M10 2v2" }),
    /* @__PURE__ */ i("path", { d: "M7 8H3" }),
    /* @__PURE__ */ i("path", { d: "M21 16h-4" }),
    /* @__PURE__ */ i("path", { d: "M11 3H9" })
  ] });
}
function xd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "19", cy: "12", r: "1" }),
    /* @__PURE__ */ i("circle", { cx: "5", cy: "12", r: "1" })
  ] });
}
function Qy(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0" }),
    /* @__PURE__ */ i("path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0" }),
    /* @__PURE__ */ i("path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7" }),
    /* @__PURE__ */ i("path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8" }),
    /* @__PURE__ */ i("path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69" }),
    /* @__PURE__ */ i("path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8" }),
    /* @__PURE__ */ i("path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69" }),
    /* @__PURE__ */ i("path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7" })
  ] });
}
function e0(e) {
  return /* @__PURE__ */ i(P, { ...e, children: /* @__PURE__ */ i("path", { d: "M128 0C57.308 0 0 57.309 0 128c0 70.696 57.309 128 128 128 70.697 0 128-57.304 128-128C256 57.314 198.697.007 127.998.007l.001-.006Zm58.699 184.614c-2.293 3.76-7.215 4.952-10.975 2.644-30.053-18.357-67.885-22.515-112.44-12.335a7.981 7.981 0 0 1-9.552-6.007 7.968 7.968 0 0 1 6-9.553c48.76-11.14 90.583-6.344 124.323 14.276 3.76 2.308 4.952 7.215 2.644 10.975Zm15.667-34.853c-2.89 4.695-9.034 6.178-13.726 3.289-34.406-21.148-86.853-27.273-127.548-14.92-5.278 1.594-10.852-1.38-12.454-6.649-1.59-5.278 1.386-10.842 6.655-12.446 46.485-14.106 104.275-7.273 143.787 17.007 4.692 2.89 6.175 9.034 3.286 13.72v-.001Zm1.345-36.293C162.457 88.964 94.394 86.71 55.007 98.666c-6.325 1.918-13.014-1.653-14.93-7.978-1.917-6.328 1.65-13.012 7.98-14.935C93.27 62.027 168.434 64.68 215.929 92.876c5.702 3.376 7.566 10.724 4.188 16.405-3.362 5.69-10.73 7.565-16.4 4.187h-.006Z" }) });
}
function t0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 6H3" }),
    /* @__PURE__ */ i("path", { d: "M7 12H3" }),
    /* @__PURE__ */ i("path", { d: "M7 18H3" }),
    /* @__PURE__ */ i("path", { d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14" }),
    /* @__PURE__ */ i("path", { d: "M11 10v4h4" })
  ] });
}
function n0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" }),
    /* @__PURE__ */ i("path", { d: "M12 9v4" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01" })
  ] });
}
function wd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }),
    /* @__PURE__ */ i("path", { d: "M12 17h.01", strokeLinecap: "round", strokeWidth: "2" })
  ] });
}
function r0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "3" })
  ] });
}
function i0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i(
      "path",
      {
        d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ i(
      "path",
      {
        d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] });
}
function s0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i(
      "rect",
      {
        width: "20",
        height: "5",
        x: "2",
        y: "3",
        rx: "1",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none"
      }
    ),
    /* @__PURE__ */ i(
      "path",
      {
        d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ i(
      "path",
      {
        d: "M10 12h4",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] });
}
function o0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12" }),
    /* @__PURE__ */ i("path", { d: "M15 5.764V12" }),
    /* @__PURE__ */ i("path", { d: "M18 15v6" }),
    /* @__PURE__ */ i("path", { d: "M21 18h-6" }),
    /* @__PURE__ */ i("path", { d: "M9 3.236v15" })
  ] });
}
function a0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "10", r: "3" }),
    /* @__PURE__ */ i("path", { d: "M16 18h6" }),
    /* @__PURE__ */ i("path", { d: "M19 15v6" })
  ] });
}
function l0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "10", r: "3" }),
    /* @__PURE__ */ i("path", { d: "M16 18h6" })
  ] });
}
function c0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V14" }),
    /* @__PURE__ */ i("path", { d: "M15 5.764V14" }),
    /* @__PURE__ */ i("path", { d: "M21 18h-6" }),
    /* @__PURE__ */ i("path", { d: "M9 3.236v15" })
  ] });
}
function d0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { x: "3", y: "4", width: "18", height: "11", rx: "2", ry: "2" }),
    /* @__PURE__ */ i("line", { x1: "12", y1: "19", x2: "12", y2: "15" }),
    /* @__PURE__ */ i("line", { x1: "8", y1: "21", x2: "16", y2: "21" }),
    /* @__PURE__ */ i("path", { d: "M7 16 L15 8" }),
    /* @__PURE__ */ i("path", { d: "M15 8 L13 8" }),
    /* @__PURE__ */ i("path", { d: "M15 8 L15 10" })
  ] });
}
function u0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1" }),
    /* @__PURE__ */ i("path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" }),
    /* @__PURE__ */ i("path", { d: "M16 4h2a2 2 0 0 1 2 2v4" }),
    /* @__PURE__ */ i("path", { d: "M21 14H11" }),
    /* @__PURE__ */ i("path", { d: "m15 10-4 4 4 4" })
  ] });
}
function h0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "16", r: "1" }),
    /* @__PURE__ */ i("rect", { x: "3", y: "10", width: "18", height: "12", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M7 10V7a5 5 0 0 1 10 0v3" })
  ] });
}
function f0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "16", r: "1" }),
    /* @__PURE__ */ i("rect", { width: "18", height: "12", x: "3", y: "10", rx: "2" }),
    /* @__PURE__ */ i("path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5" })
  ] });
}
function m0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("polyline", { points: "12 6 12 12 16 14" })
  ] });
}
function p0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21.801 10A10 10 0 1 1 17 3.335" }),
    /* @__PURE__ */ i("path", { d: "m9 11 3 3L22 4" })
  ] });
}
function g0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("path", { d: "M12 8v4", strokeLinecap: "round" }),
    /* @__PURE__ */ i("path", { d: "M12 16h.01", strokeLinecap: "round", strokeWidth: "2" })
  ] });
}
function y0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
    /* @__PURE__ */ i("polyline", { points: "17 8 12 3 7 8" }),
    /* @__PURE__ */ i("line", { x1: "12", x2: "12", y1: "3", y2: "15" })
  ] });
}
function v0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" }),
    /* @__PURE__ */ i("path", { d: "M14 2v4a2 2 0 0 0 2 2h4" }),
    /* @__PURE__ */ i("path", { d: "M10 9H8" }),
    /* @__PURE__ */ i("path", { d: "M16 13H8" }),
    /* @__PURE__ */ i("path", { d: "M16 17H8" })
  ] });
}
function b0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z" }),
    /* @__PURE__ */ i("path", { d: "m21.854 2.147-10.94 10.939" })
  ] });
}
function x0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }),
    /* @__PURE__ */ i("path", { d: "M21 3v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }),
    /* @__PURE__ */ i("path", { d: "M8 16H3v5" })
  ] });
}
function w0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47" }),
    /* @__PURE__ */ i("path", { d: "M8 16H3v5" }),
    /* @__PURE__ */ i("path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64" }),
    /* @__PURE__ */ i("path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64" }),
    /* @__PURE__ */ i("path", { d: "M21 12c0 1-.16 1.97-.47 2.87" }),
    /* @__PURE__ */ i("path", { d: "M21 3v5h-5" }),
    /* @__PURE__ */ i("path", { d: "M22 22 2 2" })
  ] });
}
function k0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "10" }),
    /* @__PURE__ */ i("path", { d: "M4.929 4.929 19.07 19.071" })
  ] });
}
function N0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z" }),
    /* @__PURE__ */ i("path", { d: "M13 5v2" }),
    /* @__PURE__ */ i("path", { d: "M13 17v2" }),
    /* @__PURE__ */ i("path", { d: "M13 11v2" })
  ] });
}
function kd(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2" }),
    /* @__PURE__ */ i("path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" })
  ] });
}
function S0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M8 3 4 7l4 4" }),
    /* @__PURE__ */ i("path", { d: "M4 7h16" }),
    /* @__PURE__ */ i("path", { d: "m16 21 4-4-4-4" }),
    /* @__PURE__ */ i("path", { d: "M20 17H4" })
  ] });
}
function T0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" }),
    /* @__PURE__ */ i("circle", { cx: "12", cy: "12", r: "3" })
  ] });
}
function C0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("path", { d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" }),
    /* @__PURE__ */ i("path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7" }),
    /* @__PURE__ */ i("path", { d: "M7 3v4a1 1 0 0 0 1 1h7" })
  ] });
}
function P0(e) {
  return /* @__PURE__ */ p(P, { ...e, children: [
    /* @__PURE__ */ i("circle", { cx: "18", cy: "18", r: "3" }),
    /* @__PURE__ */ i("circle", { cx: "6", cy: "6", r: "3" }),
    /* @__PURE__ */ i("path", { d: "M6 21V9a9 9 0 0 0 9 9" })
  ] });
}
function M0({ ...e }) {
  return /* @__PURE__ */ i("nav", { "aria-label": "breadcrumb", ...e });
}
function D0({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "ol",
    {
      "data-slot": "breadcrumb-list",
      className: m(
        "text-ink-secondary flex flex-wrap items-center gap-1.5 text-sm wrap-break-word sm:gap-2.5 font-sentric-alt",
        e
      ),
      ...t
    }
  );
}
function I0({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "li",
    {
      "data-slot": "breadcrumb-item",
      className: m("inline-flex items-center gap-1.5", e),
      ...t
    }
  );
}
function A0({
  asChild: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ i(
    e ? En : "a",
    {
      "data-slot": "breadcrumb-link",
      className: m("text-ink-secondary hover:text-ink-primary transition-colors font-sentric-alt", t),
      ...n
    }
  );
}
function V0({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "span",
    {
      "data-slot": "breadcrumb-page",
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: m("text-ink-primary font-normal font-sentric-alt", e),
      ...t
    }
  );
}
function E0({
  children: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ i(
    "li",
    {
      "data-slot": "breadcrumb-separator",
      role: "presentation",
      "aria-hidden": "true",
      className: m("text-ink-secondary", t),
      ...n,
      children: e ?? /* @__PURE__ */ i(Wr, { className: "w-3.5 h-3.5 stroke-ink-secondary" })
    }
  );
}
function R0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "span",
    {
      "data-slot": "breadcrumb-ellipsis",
      role: "presentation",
      "aria-hidden": "true",
      className: m("flex w-9 h-9 items-center justify-center text-ink-secondary", e),
      ...t,
      children: [
        /* @__PURE__ */ i(xd, { size: "md", className: "stroke-ink-secondary" }),
        /* @__PURE__ */ i("span", { className: "sr-only", children: "More" })
      ]
    }
  );
}
const _t = bt.Provider, Ot = bt.Root, $t = bt.Trigger, xt = S.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => {
  const s = j((a) => a.isTunecore);
  return (
    // Portal to document.body so the tooltip escapes ancestor overflow-hidden/
    // overflow-auto containers (e.g. Table's ScrollArea and resizable-column
    // <td> cells) and stacking contexts (e.g. the sticky table header) instead
    // of being clipped or rendered behind them — a local z-index can't fix
    // that since it only wins within its nearest containing stacking context.
    /* @__PURE__ */ i(bt.Portal, { children: /* @__PURE__ */ i(
      bt.Content,
      {
        ref: r,
        sideOffset: t,
        className: m(
          "z-50 overflow-hidden rounded-md border px-3 py-1.5 text-sm text-md shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          "bg-layer-default text-ink-primary border-stroke-subtle",
          s ? "font-tunecore" : "font-sentric-alt",
          e
        ),
        ...n
      }
    ) })
  );
});
xt.displayName = bt.Content.displayName;
const W = K.forwardRef(({
  children: e,
  as: t = "p",
  className: n = "",
  ...r
}, s) => {
  const a = j((d) => d.isTunecore), o = m("text-ink-primary", a && "font-tunecore"), l = m(
    o,
    a ? "text-sm font-normal leading-normal" : "text-size-body-sm font-normal leading-[1.6] font-sentric-alt"
  ), c = {
    p: m(
      o,
      a ? "text-[0.875rem] font-normal" : "text-base font-normal leading-[1.6] font-sentric-alt"
    ),
    pMainFont: m(o, "text-base font-normal leading-normal font-sentric"),
    semibold: m(o, "font-semibold text-base leading-6 font-sentric-alt"),
    subtitle: m(
      o,
      a ? "font-bold uppercase tracking-[0.06rem]" : "font-sentric text-base font-bold leading-7 uppercase"
    ),
    // Sentric Design System v1.0 (June 2026) additions — values confirmed
    // against live Figma text styles. Tunecore fallbacks below are rough
    // placeholders (tunecore typography is a separate, out-of-scope spec);
    // revisit if/when these variants get used on a tunecore surface.
    bodyLg: m(
      o,
      a ? "text-lg font-normal" : "text-size-body-lg font-normal leading-[1.65] font-sentric-alt"
    ),
    bodySm: l,
    // @deprecated Use `bodySm` instead — kept as an alias (same styling,
    // same rendered <small> tag) for backward compatibility with existing
    // consumers of @sentricmusic/ui outside this monorepo. Not removed
    // because at least one (sentric-sandbox) has 600+ call sites still on
    // `small`, on a pinned version that predates `bodySm`'s existence —
    // removing this would silently drop their typography styling entirely
    // (Text falls back to no className) the next time they upgrade.
    small: l,
    caption: m(
      o,
      a ? "text-xs font-normal" : "text-size-caption font-normal leading-[1.5] tracking-[0.01em] font-sentric-alt"
    ),
    label: m(
      o,
      a ? "text-xs font-medium" : "text-size-label font-medium leading-[1.4] tracking-[0.01em] font-sentric-alt"
    ),
    sectionLabel: m(
      o,
      a ? "text-[10px] font-semibold uppercase tracking-[0.12em]" : "text-size-section-label font-semibold uppercase leading-[1.4] tracking-[0.12em] font-sentric"
    )
  }, u = {
    subtitle: "h2",
    p: "p",
    pMainFont: "p",
    semibold: "p",
    bodyLg: "p",
    bodySm: "span",
    small: "small",
    caption: "span",
    label: "span",
    sectionLabel: "span"
  }[t];
  return /* @__PURE__ */ i(
    u,
    {
      ref: s,
      className: m(c[t] || "", n),
      ...r,
      children: e
    }
  );
});
W.displayName = "Text";
const Nd = /* @__PURE__ */ new Set([
  "tunecorePrimary",
  "tunecoreSecondary",
  "tunecoreDropdown",
  "tunecoreDropdownDelete"
]), gn = ["primary", "secondary", "tertiary", "destructive"], vr = Ve(
  "group inline-flex items-center w-auto cursor-pointer font-sentric-alt whitespace-nowrap rounded-sm text-sm font-medium ring-offset-background transition ease-out duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-25 uppercase py-2 px-5",
  {
    variants: {
      variant: {
        primary: "justify-center border stroke-current bg-action-primary border-action-primary text-ink-on-accent shadow-small-grey hover:bg-action-primary-hover hover:border-action-primary-hover hover:shadow-md-grey active:bg-action-primary-pressed active:border-action-primary-pressed active:text-ink-inverse active:shadow-none disabled:bg-layer-disabled disabled:border-stroke-disabled disabled:text-ink-disabled disabled:shadow-none disabled:opacity-100",
        secondary: "justify-center border stroke-current bg-layer-default border-stroke-heavy text-ink-primary shadow-small-grey hover:bg-canvas-secondary hover:shadow-md-grey active:bg-stroke-subtle active:shadow-none disabled:bg-layer-disabled disabled:border-stroke-disabled disabled:text-ink-disabled disabled:shadow-none disabled:opacity-100",
        tertiary: "justify-center border-0 stroke-current bg-transparent text-ink-primary underline hover:text-action-primary-hover active:text-action-primary-pressed disabled:text-ink-disabled disabled:opacity-100",
        destructive: "justify-center border stroke-current bg-action-destructive border-action-destructive text-ink-inverse shadow-small-grey hover:bg-action-destructive-hover hover:border-action-destructive-hover hover:shadow-md-grey active:bg-action-destructive-pressed active:border-action-destructive-pressed active:shadow-none disabled:bg-layer-disabled disabled:border-stroke-disabled disabled:text-ink-disabled disabled:shadow-none disabled:opacity-100",
        tunecoreDestructive: "justify-center bg-action-destructive text-white hover:bg-action-destructive-hover active:bg-action-destructive-pressed",
        iconAction: "justify-center items-center gap-1 size-8 shrink-0 py-0 px-2 rounded-sm border border-stroke-heavy bg-layer-default text-ink-primary normal-case shadow-small-grey hover:bg-layer-raised active:bg-layer-disabled",
        darkSecondary: "justify-center bg-[var(--primitive-grey-800)] text-ink-disabled hover:bg-dark-secondary-hover active:bg-dark-secondary-active dark:hover:bg-action-primary",
        link: "text-ink-primary hover:text-ink-accent active:text-ink-accent p-0 stroke-canvas-inverse hover:stroke-action-primary active:stroke-action-primary disabled:text-ink-disabled",
        linkBack: "text-ink-primary hover:text-ink-accent active:text-ink-accent p-0 -ml-1 stroke-canvas-inverse hover:stroke-action-primary active:stroke-action-primary disabled:text-ink-disabled",
        dropdown: "justify-start text-ink-primary hover:bg-layer-raised border-0 normal-case rounded-sm p-2",
        dropdownDelete: "justify-start text-ink-error hover:bg-layer-raised border-0 normal-case rounded-sm p-2 w-full",
        dropdownGreen: "justify-start text-ink-success hover:bg-layer-raised border-0 normal-case rounded-sm p-2 w-full",
        tunecoreDropdown: "justify-start text-white hover:bg-layer-raised hover:text-white border-0 normal-case rounded-sm p-2",
        tunecoreDropdownDelete: "justify-start text-action-destructive hover:bg-layer-raised hover:text-action-destructive border-0 normal-case rounded-sm p-2",
        tunecoreLink: "group text-white hover:text-ink-accent active:text-ink-accent p-0 stroke-white hover:stroke-action-primary active:stroke-action-primary disabled:text-ink-secondary",
        outline: "ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
        tunecoreOutline: "ring-1 hover:ring-2 ring-stroke-subtle hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
        ghost: "hover:bg-layer-raised hover:text-ink-primary",
        tunecorePrimary: "px-5 py-2.5 text-white font-bold rounded-full uppercase tracking-wider hover:brightness-110 transition-all duration-150",
        tunecoreSecondary: "justify-center bg-transparent px-5 py-2.5 ring-2 ring-white text-white rounded-full hover:ring-stroke-primary active:ring-stroke-primary font-bold text-[13px] leading-[100%] tracking-[1px] uppercase "
      },
      size: {
        lg: "",
        sm: "",
        "icon-lg": "",
        "icon-sm": ""
      }
    },
    compoundVariants: [
      ...gn.map((e) => ({ variant: e, size: "lg", className: "h-10 text-size-body-sm font-normal" })),
      ...gn.map((e) => ({ variant: e, size: "sm", className: "h-8 text-size-label font-medium tracking-[0.12px]" })),
      ...gn.map((e) => ({ variant: e, size: "icon-lg", className: "size-10 shrink-0 p-0 text-size-body-sm font-normal" })),
      ...gn.map((e) => ({ variant: e, size: "icon-sm", className: "size-8 shrink-0 p-0 text-size-label font-medium" }))
    ],
    defaultVariants: {
      variant: "primary",
      size: "lg"
    }
  }
), $ = S.forwardRef(
  ({
    className: e,
    tooltipText: t,
    tooltip: n,
    label: r,
    icon: s,
    iconPosition: a,
    variant: o = "primary",
    size: l,
    disabled: c,
    ...u
  }, d) => {
    const h = j((k) => k.isTunecore), f = o === "linkBack" ? "left" : a ?? "right", g = h ? o === "primary" ? "tunecoreSecondary" : o === "secondary" ? "tunecorePrimary" : o === "destructive" ? "tunecoreDestructive" : o === "tertiary" || o === "link" ? "tunecoreLink" : o === "outline" ? "tunecoreOutline" : o === "dropdown" ? "tunecoreDropdown" : o === "dropdownDelete" ? "tunecoreDropdownDelete" : o : o, y = Nd.has(g ?? ""), v = m(
      vr({ variant: g, size: l }),
      h && !y && "rounded-lg",
      e
    ), x = () => /* @__PURE__ */ p(ce, { children: [
      s != null && f === "left" && /* @__PURE__ */ i("span", { className: m(r != null && "mr-2"), children: s }),
      g === "tunecorePrimary" ? /* @__PURE__ */ i("p", { children: r }) : r,
      s != null && f === "right" && /* @__PURE__ */ i("span", { className: m(r != null && "ml-2"), children: s })
    ] });
    if (g === "tunecorePrimary") {
      const T = /* @__PURE__ */ i(
        n ? $t : "button",
        {
          ref: n ? void 0 : d,
          type: "button",
          className: v,
          style: {
            background: c ? "linear-gradient(to bottom right, rgba(0, 239, 134, 0.5), rgba(0, 142, 185, 0.5))" : "linear-gradient(to bottom right, #00ef86, #008eb9)",
            borderRadius: "50px",
            padding: "12px 20px"
          },
          disabled: c,
          ...u,
          children: /* @__PURE__ */ i("div", { className: "flex items-center", children: x() })
        }
      );
      return n ? /* @__PURE__ */ i(_t, { children: /* @__PURE__ */ p(Ot, { delayDuration: 200, children: [
        T,
        /* @__PURE__ */ i(xt, { children: /* @__PURE__ */ i(W, { className: "max-w-72", children: t }) })
      ] }) }) : T;
    }
    const w = /* @__PURE__ */ i(
      n ? $t : "button",
      {
        ref: n ? void 0 : d,
        type: "button",
        className: v,
        disabled: c,
        ...u,
        children: x()
      }
    );
    return n ? /* @__PURE__ */ i(_t, { children: /* @__PURE__ */ p(Ot, { delayDuration: 200, children: [
      w,
      /* @__PURE__ */ i(xt, { children: /* @__PURE__ */ i(W, { className: "max-w-72", children: t }) })
    ] }) }) : w;
  }
);
$.displayName = "Button";
const Sd = S.forwardRef(
  ({ label: e = "Confirm", ...t }, n) => /* @__PURE__ */ i(
    $,
    {
      ref: n,
      variant: "primary",
      icon: /* @__PURE__ */ i(nt, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), Td = S.forwardRef(
  ({ label: e = "Cancel", ...t }, n) => /* @__PURE__ */ i(
    $,
    {
      ref: n,
      variant: "darkSecondary",
      icon: /* @__PURE__ */ i(Uo, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), Cd = S.forwardRef(
  ({ label: e = "Next", ...t }, n) => /* @__PURE__ */ i(
    $,
    {
      ref: n,
      variant: "primary",
      icon: /* @__PURE__ */ i(hd, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), Pd = S.forwardRef(
  ({ label: e = "Previous", ...t }, n) => /* @__PURE__ */ i(
    $,
    {
      ref: n,
      variant: "secondary",
      icon: /* @__PURE__ */ i(Ur, { size: "md" }),
      iconPosition: "left",
      label: e,
      ...t
    }
  )
), Md = S.forwardRef(
  ({ label: e = "Save", ...t }, n) => /* @__PURE__ */ i(
    $,
    {
      ref: n,
      variant: "primary",
      icon: /* @__PURE__ */ i(nt, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
), Dd = S.forwardRef(
  ({ label: e = "Delete", ...t }, n) => /* @__PURE__ */ i(
    $,
    {
      ref: n,
      variant: "darkSecondary",
      icon: /* @__PURE__ */ i(Go, { size: "md" }),
      iconPosition: "right",
      label: e,
      ...t
    }
  )
);
Sd.displayName = "ConfirmButton";
Td.displayName = "CancelButton";
Cd.displayName = "NextButton";
Pd.displayName = "PreviousButton";
Md.displayName = "SaveButton";
Dd.displayName = "DeleteButton";
const Ko = S.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }, s) => /* @__PURE__ */ i(
    zo.Root,
    {
      ref: s,
      decorative: n,
      orientation: t,
      className: m(
        "bg-border shrink-0",
        t === "horizontal" ? "h-px w-full" : "h-full w-px",
        e
      ),
      ...r
    }
  )
);
Ko.displayName = zo.Root.displayName;
const Id = Ve(
  "flex w-full items-stretch *:focus-visible:z-10 *:focus-visible:relative [&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit [&>input]:flex-1 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-md has-[>[data-slot=button-group]]:gap-2",
  {
    variants: {
      orientation: {
        horizontal: "[&>*:not(:first-child)]:rounded-l-none [&>*:not(:first-child)]:border-l-0 [&>*:not(:last-child)]:rounded-r-none",
        vertical: "flex-col"
      }
    },
    defaultVariants: {
      orientation: "horizontal"
    }
  }
);
function L0({
  className: e,
  orientation: t,
  ...n
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      role: "group",
      "data-slot": "button-group",
      "data-orientation": t,
      className: m(Id({ orientation: t }), e),
      ...n
    }
  );
}
function B0({
  className: e,
  asChild: t = !1,
  ...n
}) {
  return /* @__PURE__ */ i(
    t ? En : "div",
    {
      className: m(
        "bg-muted flex items-center gap-2 rounded-md border px-4 text-sm font-medium shadow-xs [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n
    }
  );
}
function F0({
  className: e,
  orientation: t = "horizontal",
  ...n
}) {
  return /* @__PURE__ */ i(
    Ko,
    {
      "data-slot": "button-group-separator",
      orientation: t,
      className: m(
        "-mx-1 my-1 w-[calc(100%+0.5rem)]! bg-layer-raised",
        e
      ),
      ...n
    }
  );
}
const Ad = () => /* @__PURE__ */ i(xc, { className: "w-4 h-4" }), Vd = () => /* @__PURE__ */ i(Eo, { className: "w-4 h-4" }), Ed = () => /* @__PURE__ */ i("span", { className: "text-lg text-ink-primary", children: "▼" });
function Rt({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: r,
  ...s
}) {
  const a = j((o) => o.isTunecore);
  return /* @__PURE__ */ i(
    Vc,
    {
      weekStartsOn: 1,
      showOutsideDays: n,
      captionLayout: r,
      fromYear: 1900,
      toYear: 2030,
      className: m(
        "p-3",
        a ? "font-tunecore" : "font-sentric",
        "text-ink-primary",
        e
      ),
      classNames: {
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: r === "dropdown" || r === "dropdown-buttons" ? "sr-only" : `text-sm mt-[2px] text-ink-primary ${a ? "font-tunecore" : "font-sentric"}`,
        vhidden: "sr-only",
        caption_dropdowns: "flex justify-center gap-2 px-10",
        dropdown: `text-sm appearance-none cursor-pointer focus:outline-none relative bg-no-repeat bg-right bg-size-[16px] border-none rounded px-2 py-1 pr-6 ${a ? "font-tunecore bg-layer-raised text-white bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23ffffff%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22/%3E%3C/svg%3E')]" : "font-sentric bg-transparent text-ink-primary bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23374151%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22/%3E%3C/svg%3E')] dark:bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23faf8f5%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpath%20d%3D%22m6%209%206%206%206-6%22/%3E%3C/svg%3E')]"}`,
        nav: "space-x-1 flex items-center",
        nav_button: m(
          vr({ variant: "outline" }),
          "px-2 py-1 rounded-md",
          a ? "bg-layer-raised text-white border-layer-raised hover:bg-action-primary hover:border-action-primary" : "bg-transparent text-ink-primary"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "rounded-md w-9 font-normal text-[0.8rem] text-ink-secondary",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative flex justify-center items-center",
        day: m(
          vr({ variant: "ghost" }),
          "h-9 w-9 p-0 flex justify-center items-center aria-selected:opacity-100",
          a ? "text-white hover:bg-action-primary hover:text-black" : "hover:bg-layer-raised"
        ),
        day_range_end: "bg-action-primary text-black",
        day_selected: "bg-action-primary text-black! hover:bg-action-primary focus:bg-action-primary hover:text-black! focus:text-black!",
        day_today: a ? "bg-layer-raised aria-selected:bg-layer-raised aria-selected:text-white! text-white!" : "bg-action-secondary aria-selected:bg-action-secondary aria-selected:text-black! text-black!",
        day_outside: a ? "text-white/50 aria-selected:text-white aria-selected:opacity-30" : "text-ink-secondary opacity-50 aria-selected:text-black/40 aria-selected:opacity-30",
        day_disabled: "text-ink-disabled opacity-50",
        day_range_middle: a ? "aria-selected:bg-action-primary/45 aria-selected:text-white" : "aria-selected:bg-action-primary/45 aria-selected:text-black",
        day_hidden: "invisible",
        ...t
      },
      components: {
        IconLeft: Ad,
        IconRight: Vd,
        IconDropdown: Ed
      },
      ...s
    }
  );
}
Rt.displayName = "Calendar";
const Rd = { light: "", dark: ".dark" }, Xo = S.createContext(null);
function Yo() {
  const e = S.useContext(Xo);
  if (!e)
    throw new Error("useChart must be used within a <ChartContainer />");
  return e;
}
const Ld = S.forwardRef(({ id: e, className: t, children: n, config: r, ...s }, a) => {
  const o = S.useId(), l = `chart-${e || o.replace(/:/g, "")}`, c = S.useMemo(() => ({ config: r }), [r]);
  return /* @__PURE__ */ i(Xo.Provider, { value: c, children: /* @__PURE__ */ p(
    "div",
    {
      "data-chart": l,
      ref: a,
      className: m(
        // --- ADD position: relative and z-index: 1 (or similar low value) ---
        "relative z-1",
        // --- End Addition ---
        "flex aspect-video justify-center text-xs [&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-none [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-sector]:outline-none [&_.recharts-surface]:outline-none",
        t
      ),
      ...s,
      children: [
        /* @__PURE__ */ i(Bd, { id: l, config: r }),
        /* @__PURE__ */ i(Hr.ResponsiveContainer, { children: n })
      ]
    }
  ) });
});
Ld.displayName = "Chart";
function Bd({ id: e, config: t }) {
  const n = Object.entries(t).filter(
    ([r, s]) => s.theme || s.color
  );
  return n.length ? /* @__PURE__ */ i(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(Rd).map(
          ([r, s]) => `
${s} [data-chart=${e}] {
${n.map(([a, o]) => {
            var c;
            const l = ((c = o.theme) == null ? void 0 : c[r]) || o.color;
            return l ? `  --color-${a}: ${l};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}
const z0 = Hr.Tooltip, Fd = S.forwardRef(
  ({
    active: e,
    payload: t,
    className: n,
    indicator: r = "dot",
    hideLabel: s = !1,
    hideIndicator: a = !1,
    label: o,
    labelFormatter: l,
    labelClassName: c,
    formatter: u,
    color: d,
    nameKey: h,
    labelKey: f
  }, g) => {
    const { config: y } = Yo(), v = j((w) => w.isTunecore), x = S.useMemo(() => {
      var M;
      if (s || !(t != null && t.length))
        return null;
      const [w] = t, k = `${f || w.dataKey || w.name || "value"}`, N = br(y, w, k), T = !f && typeof o == "string" ? ((M = y[o]) == null ? void 0 : M.label) || o : N == null ? void 0 : N.label;
      return l ? /* @__PURE__ */ i("div", { className: m("font-medium", c), children: l(T, t) }) : T ? /* @__PURE__ */ i("div", { className: m("font-medium", c), children: T }) : null;
    }, [
      o,
      l,
      t,
      s,
      c,
      y,
      f
    ]);
    if (!e || !(t != null && t.length))
      return null;
    const b = t.length === 1 && r !== "dot";
    return /* @__PURE__ */ p(
      "div",
      {
        ref: g,
        className: m(
          "grid min-w-32 max-w-[500px] items-start gap-1.5 border border-border/50 bg-layer-default px-2.5 py-1.5 text-ink-secondary text-base shadow-xl max-h-[800px] overflow-y-auto",
          v ? "rounded-lg" : "rounded-sm",
          n
        ),
        children: [
          b ? null : x,
          /* @__PURE__ */ i("div", { className: "grid gap-1.5", children: t.map((w, k) => {
            const N = `${h || w.name || w.dataKey || "value"}`, T = br(y, w, N), M = d || w.payload.fill || w.color;
            return /* @__PURE__ */ i(
              "div",
              {
                className: m(
                  "flex w-full flex-wrap items-stretch gap-2 [&>svg]:h-2.5 [&>svg]:w-2.5 [&>svg]:text-muted-foreground",
                  r === "dot" && "items-center"
                ),
                children: u && (w == null ? void 0 : w.value) !== void 0 && w.name ? u(w.value, w.name, w, k, w.payload) : /* @__PURE__ */ p(ce, { children: [
                  T != null && T.icon ? /* @__PURE__ */ i(T.icon, {}) : !a && /* @__PURE__ */ i(
                    "div",
                    {
                      className: m(
                        "shrink-0 rounded-[2px] border-(--color-border) bg-(--color-bg)",
                        {
                          "h-2.5 w-2.5": r === "dot",
                          "w-1": r === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
                          "my-0.5": b && r === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": M,
                        "--color-border": M
                      }
                    }
                  ),
                  /* @__PURE__ */ p(
                    "div",
                    {
                      className: m(
                        "flex flex-1 justify-between leading-none",
                        b ? "items-end" : "items-center"
                      ),
                      children: [
                        /* @__PURE__ */ p("div", { className: "grid gap-1.5", children: [
                          b ? x : null,
                          /* @__PURE__ */ i("span", { className: "text-muted-foreground", children: (T == null ? void 0 : T.label) || w.name })
                        ] }),
                        w.value && /* @__PURE__ */ i("span", { className: "font-sentric-alt font-medium tabular-nums text-ink-primary", children: w.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              w.dataKey
            );
          }) })
        ]
      }
    );
  }
);
Fd.displayName = "ChartTooltip";
const j0 = Hr.Legend, zd = S.forwardRef(
  ({ className: e, hideIcon: t = !1, payload: n, verticalAlign: r = "bottom", nameKey: s }, a) => {
    const { config: o } = Yo();
    return n != null && n.length ? /* @__PURE__ */ i(
      "div",
      {
        ref: a,
        className: m(
          "flex items-center justify-center gap-4",
          r === "top" ? "pb-3" : "pt-3",
          e
        ),
        children: n.map((l) => {
          const c = `${s || l.dataKey || "value"}`, u = br(o, l, c);
          return /* @__PURE__ */ p(
            "div",
            {
              className: m(
                "flex items-center gap-1.5 [&>svg]:h-3 [&>svg]:w-3 [&>svg]:text-muted-foreground"
              ),
              children: [
                u != null && u.icon && !t ? /* @__PURE__ */ i(u.icon, {}) : /* @__PURE__ */ i(
                  "div",
                  {
                    className: "h-2 w-2 shrink-0 rounded-[2px]",
                    style: {
                      backgroundColor: l.color
                    }
                  }
                ),
                u == null ? void 0 : u.label
              ]
            },
            l.value
          );
        })
      }
    ) : null;
  }
);
zd.displayName = "ChartLegend";
function br(e, t, n) {
  if (typeof t != "object" || t === null)
    return;
  const r = "payload" in t && typeof t.payload == "object" && t.payload !== null ? t.payload : void 0;
  let s = n;
  return n in t && typeof t[n] == "string" ? s = t[n] : r && n in r && typeof r[n] == "string" && (s = r[n]), s in e ? e[s] : e[n];
}
function jd(e, t, n, r, s) {
  let a = e.trim().toUpperCase();
  t !== void 0 && t !== "" && a.startsWith(t.toUpperCase()) && (a = a.slice(t.length));
  const o = n.toUpperCase();
  a.endsWith(o) && (a = a.slice(0, a.length - o.length));
  const l = s ? a.replace(/[^A-Z0-9]/g, "") : a.replace(/\D/g, "");
  return l.length === 0 ? "" : l.length <= r ? s ? l : l.padStart(r, "0") : l.slice(0, r);
}
const _d = S.forwardRef(
  ({
    prefix: e,
    suffix: t,
    digitCount: n,
    value: r,
    label: s,
    hasError: a = !1,
    errorMessage: o,
    smallFont: l = !1,
    allowLetters: c = !1,
    disabled: u = !1,
    onChange: d,
    onBlur: h
  }, f) => {
    const g = j((C) => C.isTunecore), y = S.useId(), v = `codedInput-label-${y}`, x = `codedInput-${y}`, b = a || o !== void 0 && o !== "", w = (C) => {
      const A = (c ? C.target.value.replace(/[^a-z0-9]/gi, "") : C.target.value.replace(/\D/g, "")).slice(0, n);
      d == null || d(A);
    }, k = (C) => {
      const D = C.clipboardData.getData("text");
      if (D.length === 0)
        return;
      C.preventDefault();
      const A = jd(D, e, t, n, c);
      A !== "" && (d == null || d(A));
    }, N = m(
      "flex items-center shrink-0 select-none px-2",
      // TuneCore predates this radius token system and has no spec of its
      // own — keep its original rounded-lg (8px) rather than silently
      // inheriting Sentric's new rounded-sm (6px).
      g ? "rounded-lg" : "rounded-sm",
      l ? "text-xs" : "text-sm",
      "text-ink-primary bg-layer-raised",
      g ? "font-tunecore" : "font-sentric-alt"
    ), T = b ? g ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary" : "ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-within:ring-2 focus-within:ring-stroke-primary", M = b && !g ? "bg-red-100 dark:bg-red-800" : "";
    return /* @__PURE__ */ p("div", { className: m("flex flex-col w-full", l ? "gap-0.5" : "gap-1"), children: [
      s != null && s !== "" && /* @__PURE__ */ i(
        "label",
        {
          id: v,
          htmlFor: x,
          className: m(
            "leading-snug self-start",
            l ? "text-xs" : "text-base",
            "text-ink-primary",
            g ? "font-tunecore" : "font-sentric-alt"
          ),
          children: s
        }
      ),
      /* @__PURE__ */ p(
        "div",
        {
          className: m(
            "flex flex-row items-stretch w-full overflow-hidden transition ease-out duration-200",
            g ? "rounded-lg" : "rounded-sm",
            T,
            M,
            u ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
          ),
          children: [
            e != null && e !== "" && /* @__PURE__ */ i(
              "span",
              {
                "aria-hidden": "true",
                className: m(
                  N,
                  "rounded-r-none border-r border-stroke-heavy/20 py-1.5"
                ),
                children: e
              }
            ),
            /* @__PURE__ */ i(
              "input",
              {
                ref: f,
                id: x,
                type: "text",
                inputMode: c ? "text" : "numeric",
                pattern: c ? "[A-Za-z0-9]*" : "[0-9]*",
                placeholder: c ? "0001VXKQ" : "0".repeat(n),
                value: r,
                disabled: u,
                "aria-label": s ?? `${e ?? ""}${t} code`,
                "aria-invalid": b,
                "aria-describedby": b ? `${x}-error` : void 0,
                onChange: w,
                onPaste: k,
                onBlur: h,
                className: m(
                  "flex-1 min-w-0 px-2 py-1.5 font-medium focus-visible:outline-none transition ease-out duration-200 bg-transparent",
                  l ? "text-xs" : "text-sm",
                  "text-ink-primary placeholder:text-ink-primary/50",
                  g ? "font-tunecore" : "font-sentric-alt"
                )
              }
            ),
            /* @__PURE__ */ i(
              "span",
              {
                "aria-hidden": "true",
                className: m(
                  N,
                  "rounded-l-none border-l border-stroke-heavy/20 py-1.5"
                ),
                children: t
              }
            )
          ]
        }
      ),
      b && o != null && o !== "" && /* @__PURE__ */ i(
        W,
        {
          id: `${x}-error`,
          className: m(
            "text-ink-error",
            l ? "text-[10px]" : "text-xs"
          ),
          children: o
        }
      )
    ] });
  }
);
_d.displayName = "CodedInput";
function Od(e, t) {
  return t.type === "UPDATE" ? t.payload : e;
}
function $d(e, t = {}) {
  const { horizontal: n = !0, vertical: r = !1 } = t, [s, a] = Sc(Od, {
    canScrollLeft: !1,
    canScrollRight: !1,
    canScrollUp: !1,
    canScrollDown: !1
  }), o = De(() => {
    const l = e.current;
    if (!l)
      return;
    const { scrollLeft: c, scrollTop: u, scrollWidth: d, scrollHeight: h, clientWidth: f, clientHeight: g } = l;
    a({
      type: "UPDATE",
      payload: {
        canScrollLeft: n && c > 5,
        // Small threshold to avoid flickering
        canScrollRight: n && c < d - f - 5,
        canScrollUp: r && u > 5,
        canScrollDown: r && u < h - g - 5
      }
    });
  }, [e, n, r]);
  return Ae(() => {
    const l = e.current;
    if (!l)
      return;
    o(), l.addEventListener("scroll", o, { passive: !0 });
    const c = new ResizeObserver(o);
    return c.observe(l), () => {
      l.removeEventListener("scroll", o), c.disconnect();
    };
  }, [o, e]), s;
}
const Cn = S.forwardRef(({ className: e, orientation: t = "vertical", ...n }, r) => /* @__PURE__ */ i(
  tt.ScrollAreaScrollbar,
  {
    ref: r,
    orientation: t,
    className: m(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-px",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-px rounded-lg",
      e
    ),
    ...n,
    children: /* @__PURE__ */ i(tt.ScrollAreaThumb, { className: "relative flex-1 rounded-full cursor-pointer bg-ink-secondary dark:bg-ink-secondary/50" })
  }
));
Cn.displayName = tt.ScrollAreaScrollbar.displayName;
const Gr = S.forwardRef(({ className: e, children: t, "aria-label": n, showScrollIndicators: r = !1, indicatorOrientation: s = "horizontal", indicatorTopInset: a = 0, indicatorBottomInset: o = 0, ...l }, c) => {
  const u = S.useRef(null), d = j((y) => y.isTunecore), h = $d(u, {
    horizontal: r && (s === "horizontal" || s === "both"),
    vertical: r && (s === "vertical" || s === "both")
  }), f = d ? "from-action-primary/20 via-action-primary/5 to-transparent" : "from-canvas-inverse/30 via-ink-secondary/10 to-transparent dark:from-black/80 dark:via-black/40", g = d ? "from-action-primary/20 via-action-primary/5 to-transparent" : "from-canvas-inverse/35 via-ink-secondary/12 to-transparent dark:from-black/85 dark:via-black/45";
  return /* @__PURE__ */ p(
    tt.Root,
    {
      ref: c,
      className: m("relative overflow-hidden", e),
      ...l,
      children: [
        r && h.canScrollLeft && /* @__PURE__ */ i(
          "div",
          {
            className: m(
              "absolute left-0 z-30 w-12 pointer-events-none bg-linear-to-r",
              f
            ),
            style: { top: a, bottom: o },
            "aria-hidden": "true"
          }
        ),
        r && h.canScrollRight && /* @__PURE__ */ i(
          "div",
          {
            className: m(
              "absolute right-0 z-30 w-12 pointer-events-none bg-linear-to-l",
              f
            ),
            style: { top: a, bottom: o },
            "aria-hidden": "true"
          }
        ),
        r && h.canScrollUp && /* @__PURE__ */ i(
          "div",
          {
            className: m(
              "absolute top-0 left-0 right-0 z-30 h-16 pointer-events-none bg-linear-to-b",
              g
            ),
            "aria-hidden": "true"
          }
        ),
        r && h.canScrollDown && /* @__PURE__ */ i(
          "div",
          {
            className: m(
              "absolute bottom-0 left-0 right-0 z-30 h-16 pointer-events-none bg-linear-to-t",
              g
            ),
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ i(
          tt.Viewport,
          {
            ref: r ? u : void 0,
            className: "w-full h-full scroll-viewport",
            tabIndex: 0,
            role: "region",
            "aria-label": n ?? "Scrollable content",
            children: t
          }
        ),
        /* @__PURE__ */ i(Cn, {}),
        /* @__PURE__ */ i(tt.Corner, {})
      ]
    }
  );
});
Gr.displayName = tt.Root.displayName;
const Zo = X.Root, Hd = X.Trigger, Ud = X.Portal, _0 = X.Close, qo = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  X.Overlay,
  {
    ref: n,
    className: m(
      "fixed inset-0 z-50 bg-black/10  backdrop-blur-xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
qo.displayName = X.Overlay.displayName;
const Kr = S.forwardRef(({ className: e, children: t, showCloseButton: n = !0, ...r }, s) => {
  const a = j((o) => o.isTunecore);
  return /* @__PURE__ */ p(Ud, { children: [
    /* @__PURE__ */ i(qo, {}),
    /* @__PURE__ */ p(
      X.Content,
      {
        ref: s,
        className: m(
          `fixed left-[50%] top-4 sm:top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] sm:translate-y-[-50%] gap-4 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-4rem)] ${a ? "bg-layer-inverse text-white" : "bg-layer-default text-ink-primary"}`,
          e
        ),
        ...r,
        children: [
          /* @__PURE__ */ i(Gr, { className: "w-full h-full max-h-[calc(100vh-2rem)] sm:max-h-[calc(100vh-4rem)]", children: /* @__PURE__ */ i("div", { className: "p-6", children: t }) }),
          n && /* @__PURE__ */ p(X.Close, { className: "absolute z-30 transition-opacity rounded-sm right-4 top-4 ring-stroke-primary disabled:pointer-events-none", children: [
            /* @__PURE__ */ i(Wo, { size: "lg", className: "stroke-ink-primary hover:stroke-ink-accent" }),
            /* @__PURE__ */ i("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
});
Kr.displayName = X.Content.displayName;
function Xr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: m(
        "flex flex-col space-y-1.5 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
Xr.displayName = "DialogHeader";
function Wd({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: m(
        "flex justify-between space-x-4 mt-2",
        e
      ),
      ...t
    }
  );
}
Wd.displayName = "DialogFooter";
const Yr = S.forwardRef(({ className: e, ...t }, n) => {
  const r = j((s) => s.isTunecore);
  return /* @__PURE__ */ i(
    X.Title,
    {
      ref: n,
      className: m(_o("h3", { isTunecore: r }), e),
      ...t
    }
  );
});
Yr.displayName = X.Title.displayName;
const Jo = S.forwardRef(({ asChild: e, className: t, children: n, ...r }, s) => e ? /* @__PURE__ */ i(X.Description, { ref: s, asChild: !0, className: t, ...r, children: n }) : /* @__PURE__ */ i(X.Description, { ref: s, asChild: !0, ...r, children: /* @__PURE__ */ i(W, { as: "p", className: t, children: n }) }));
Jo.displayName = X.Description.displayName;
function Qo({
  className: e,
  ...t
}) {
  const n = j((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    ot,
    {
      "data-slot": "command",
      className: m(
        `flex h-full w-full flex-col overflow-hidden rounded-md text-ink-primary ${n ? "bg-layer-inverse" : "bg-layer-default"}`,
        e
      ),
      ...t
    }
  );
}
function O0({
  title: e = "Command Palette",
  description: t = "Search for a command to run...",
  children: n,
  className: r,
  showCloseButton: s = !0,
  ...a
}) {
  return /* @__PURE__ */ p(Zo, { ...a, children: [
    /* @__PURE__ */ p(Xr, { className: "sr-only", children: [
      /* @__PURE__ */ i(Yr, { children: e }),
      /* @__PURE__ */ i(Jo, { children: t })
    ] }),
    /* @__PURE__ */ i(
      Kr,
      {
        className: m("overflow-hidden p-0", r),
        showCloseButton: s,
        children: /* @__PURE__ */ i(Qo, { className: "[&_[cmdk-group-heading]]:text-muted-foreground **:data-[slot=command-input-wrapper]:h-12 **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 **:[[cmdk-input]]:h-12 **:[[cmdk-item]]:px-2 **:[[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children: n })
      }
    )
  ] });
}
function Gd({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ p(
    "div",
    {
      "data-slot": "command-input-wrapper",
      className: "flex items-center gap-2 px-3 h-10 border-b border-stroke-subtle",
      children: [
        /* @__PURE__ */ i(wc, { className: "size-4 shrink-0 text-ink-primary/50" }),
        /* @__PURE__ */ i(
          ot.Input,
          {
            "data-slot": "command-input",
            className: m(
              "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none focus:outline-none focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 placeholder:text-ink-primary/50 text-ink-primary",
              e
            ),
            ...t
          }
        )
      ]
    }
  );
}
function Kd({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    ot.List,
    {
      "data-slot": "command-list",
      className: m(
        "max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto text-ink-primary",
        e
      ),
      ...t
    }
  );
}
function Xd({
  ...e
}) {
  const t = j((n) => n.isTunecore);
  return /* @__PURE__ */ i(
    ot.Empty,
    {
      "data-slot": "command-empty",
      className: `py-6 text-sm text-center ${t ? "text-action-primary/70" : "text-ink-secondary"}`,
      ...e
    }
  );
}
function Yn({
  className: e,
  ...t
}) {
  const n = j((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    ot.Group,
    {
      "data-slot": "command-group",
      className: m(
        `overflow-hidden p-1 text-ink-primary ${n ? "**:[[cmdk-group-heading]]:text-action-primary/70" : "**:[[cmdk-group-heading]]:text-black/70 dark:**:[[cmdk-group-heading]]:text-white/70"} **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium`,
        e
      ),
      ...t
    }
  );
}
function $0({
  className: e,
  ...t
}) {
  const n = j((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    ot.Separator,
    {
      "data-slot": "command-separator",
      className: m(
        `-mx-1 h-px ${n ? "bg-action-primary/20" : "bg-stroke-subtle"}`,
        e
      ),
      ...t
    }
  );
}
function Zn({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    ot.Item,
    {
      "data-slot": "command-item",
      className: m(
        "relative flex w-full cursor-pointer select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none data-disabled:pointer-events-none text-ink-primary hover:bg-layer-raised hover:text-ink-primary focus:bg-layer-raised focus:text-ink-primary data-[selected=true]:bg-layer-raised data-[selected=true]:text-ink-primary",
        e
      ),
      ...t
    }
  );
}
function H0({
  className: e,
  ...t
}) {
  const n = j((r) => r.isTunecore);
  return /* @__PURE__ */ i(
    "span",
    {
      "data-slot": "command-shortcut",
      className: m(
        `ml-auto text-xs tracking-widest ${n ? "text-action-primary/50" : "text-ink-disabled"}`,
        e
      ),
      ...t
    }
  );
}
const Zr = jt.Root, qr = jt.Trigger, Rn = S.forwardRef(
  ({ className: e, side: t = "right", align: n = "center", sideOffset: r = 0, disablePortal: s = !1, ...a }, o) => {
    const l = j((u) => u.isTunecore), c = /* @__PURE__ */ i(
      jt.Content,
      {
        ref: o,
        align: n,
        sideOffset: r,
        side: t,
        className: m(
          `z-50 rounded-md border p-4 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 mt-1 border-stroke-subtle text-ink-primary ${l ? "bg-layer-inverse" : "bg-layer-default"}`,
          e
        ),
        ...a
      }
    );
    return s ? c : /* @__PURE__ */ i(jt.Portal, { children: c });
  }
);
Rn.displayName = jt.Content.displayName;
function U0({
  data: e,
  value: t,
  values: n,
  onValuesChange: r,
  maxDisplayCount: s = 3,
  multiSelectDisplay: a,
  selectAllLabel: o,
  onValueChange: l,
  clearButton: c,
  clearLabel: u = "Clear",
  placeholder: d = "Select option...",
  searchPlaceholder: h = "Search...",
  emptyText: f = "No option found.",
  className: g,
  triggerClassName: y,
  contentClassName: v,
  disabled: x = !1,
  label: b,
  smallFont: w = !1,
  customWidth: k = !1,
  searchByLabel: N = !1,
  disablePortal: T = !1,
  isNav: M = !1,
  popoverSide: C = "bottom",
  popoverAlign: D = "start",
  renderOption: A,
  textAlign: E = "left",
  onSearchChange: R,
  isLoading: B = !1,
  onLoadMore: ee,
  hasNextPage: Ce = !1,
  isLoadingMore: Y = !1,
  onSearchClear: z,
  hasError: _ = !1,
  errorMessage: L,
  ...oe
}) {
  const [we, Ue] = S.useState(!1), [Fe, We] = S.useState(""), te = j((U) => U.isTunecore), tn = oe["aria-invalid"] === !0 || _ || L !== void 0 && L !== "", Ge = `combobox-${S.useId()}`;
  S.useEffect(() => {
    if (R && Fe !== "") {
      const U = setTimeout(() => {
        R(Fe);
      }, 300);
      return () => clearTimeout(U);
    }
  }, [Fe, R]);
  const rn = (U) => U.length > 0 && "groupLabel" in U[0], Ke = S.useMemo(() => rn(e) ? e.flatMap((U) => U.options) : e, [e]), ze = Ke.find((U) => U.value === t), ue = n !== void 0, lt = ue && Ke.length > 0 && Ke.every((U) => n.includes(U.value)), sn = (U) => ue ? n.includes(U) : t === U, on = () => {
    if (!ue)
      return;
    const U = Ke.map((Ye) => Ye.value);
    r == null || r(lt ? [] : U);
  }, Xe = (U) => {
    if (ue) {
      const O = n.includes(U) ? n.filter((G) => G !== U) : [...n, U];
      r == null || r(O);
      return;
    }
    const Ye = U === t ? "" : U;
    l == null || l(Ye), Ue(!1);
  }, ge = (U) => {
    const Ye = U ? { id: Ge, name: Ge } : {};
    return /* @__PURE__ */ p(Zr, { open: we, onOpenChange: Ue, children: [
      /* @__PURE__ */ i(qr, { asChild: !0, disabled: x, children: /* @__PURE__ */ i(
        $,
        {
          type: "button",
          role: "combobox",
          "aria-expanded": we,
          "aria-label": "Select an option",
          disabled: x,
          variant: "outline",
          label: ue ? /* @__PURE__ */ p("span", { className: "flex items-center justify-between w-full min-w-0", children: [
            /* @__PURE__ */ i("span", { className: "block min-w-0 truncate", children: n.length > 0 ? (() => {
              const O = Ke.filter((G) => n.includes(G.value)).map((G) => G.label);
              return a === "count" || O.length > s ? `${O.length} selected` : O.join(", ");
            })() : d }),
            c && n.length > 0 && /* @__PURE__ */ i(
              $,
              {
                className: "ml-2 shrink-0 p-0",
                variant: "link",
                label: /* @__PURE__ */ i(Uo, { size: "md", className: te || M ? "stroke-white" : "stroke-ink-primary" }),
                tooltip: !0,
                tooltipText: u,
                onClick: (O) => {
                  O.stopPropagation(), r == null || r([]);
                }
              }
            )
          ] }) : ze ? A && ze.label.includes(`
`) ? (() => {
            const [O, G] = ze.label.split(`
`);
            return /* @__PURE__ */ p("div", { className: "flex flex-col text-left min-w-0", children: [
              /* @__PURE__ */ i("span", { className: "font-medium truncate", children: O }),
              /* @__PURE__ */ i("span", { className: "text-xs opacity-75 truncate", children: G })
            ] });
          })() : /* @__PURE__ */ i("span", { className: "block min-w-0 truncate", children: ze.label }) : /* @__PURE__ */ i("span", { className: "block min-w-0 truncate", children: d }),
          icon: /* @__PURE__ */ i(
            cd,
            {
              size: "md",
              className: m(
                "ml-2 shrink-0",
                te || M ? "stroke-white" : "stroke-ink-primary"
              )
            }
          ),
          className: m(
            // Match FormInput styling exactly
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 justify-between items-center normal-case overflow-hidden",
            // TuneCore predates this radius token system and has no spec of
            // its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            te ? "rounded-lg" : "rounded-sm",
            "data-disabled:cursor-not-allowed data-disabled:pointer-events-none",
            M ? "whitespace-normal" : "whitespace-nowrap",
            // Allow text wrapping in navigation mode
            k ? "" : ue ? "w-full min-w-[280px] max-w-[280px]" : "w-full",
            w ? "text-xs" : "text-sm",
            // Navigation-specific styling for dark sidebar use (publishing-dashboard)
            M && te ? "font-tunecore bg-layer-inverse border border-stroke-subtle text-white ring-0 hover:border-stroke-primary focus-visible:border-stroke-primary" : M && !te ? "font-sentric-alt border border-ink-secondary text-white ring-0" : te ? "font-tunecore bg-layer-raised text-white ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary data-disabled:hover:ring-layer-raised" : "font-sentric-alt text-ink-primary bg-layer-default ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary data-disabled:hover:ring-stroke-heavy",
            // Apply error styling to match FormInput (not for navigation mode)
            !M && tn && (te ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            // Apply placeholder-like styling when no option is selected (match FormInput placeholder colors exactly)
            !ze && !ue && (te || M) ? "!text-white/35" : "",
            ue && n.length === 0 && (te || M) ? "!text-white/35" : "",
            !ze && !ue && !te && !M ? "!text-ink-secondary" : "",
            ue && n.length === 0 && !te && !M ? "!text-ink-secondary" : "",
            y
          ),
          ...Ye
        }
      ) }),
      /* @__PURE__ */ i(
        Rn,
        {
          className: m(
            "relative z-50 max-h-96 min-w-32 overflow-hidden rounded-md border border-stroke-subtle shadow-md p-0 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
            te ? "font-tunecore bg-layer-inverse text-white" : "font-sentric-alt bg-layer-default text-ink-primary",
            k ? "" : "w-(--radix-popover-trigger-width)",
            v
          ),
          side: C,
          align: D,
          disablePortal: T,
          onWheel: (O) => {
            O.stopPropagation();
          },
          children: /* @__PURE__ */ p(
            Qo,
            {
              className: "flex flex-col",
              shouldFilter: !R,
              children: [
                /* @__PURE__ */ i(
                  Gd,
                  {
                    placeholder: h,
                    value: Fe,
                    onValueChange: (O) => {
                      We(O), O === "" && z && z();
                    }
                  }
                ),
                /* @__PURE__ */ p(
                  Kd,
                  {
                    className: "max-h-[300px] overflow-y-auto flex-1",
                    onWheel: (O) => {
                      O.stopPropagation();
                    },
                    onScroll: (O) => {
                      if (Ce && !Y && ee) {
                        const G = O.currentTarget;
                        G.scrollHeight - G.scrollTop <= G.clientHeight + 50 && ee();
                      }
                    },
                    children: [
                      /* @__PURE__ */ i(Xd, { children: B ? "Loading..." : f }),
                      ue && o !== void 0 && /* @__PURE__ */ i(
                        Yn,
                        {
                          className: m(
                            "p-1 border-b",
                            "border-stroke-subtle"
                          ),
                          children: /* @__PURE__ */ p(
                            Zn,
                            {
                              value: "__select_all__",
                              onSelect: on,
                              style: { pointerEvents: "auto" },
                              children: [
                                /* @__PURE__ */ i(
                                  "span",
                                  {
                                    className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                                    style: { pointerEvents: "none" },
                                    children: /* @__PURE__ */ i(
                                      nt,
                                      {
                                        size: "md",
                                        className: m(
                                          "stroke-ink-primary",
                                          lt ? "opacity-100" : "opacity-0"
                                        )
                                      }
                                    )
                                  }
                                ),
                                /* @__PURE__ */ i("span", { className: "block text-left font-medium", children: o })
                              ]
                            }
                          )
                        }
                      ),
                      rn(e) ? (
                        // Render grouped data with CommandGroup headings
                        e.map((O) => /* @__PURE__ */ i(Yn, { heading: O.groupLabel, className: "p-1", children: O.options.map((G) => /* @__PURE__ */ p(
                          Zn,
                          {
                            value: N ? `${G.value} ${G.label}` : G.value,
                            onSelect: (ke) => {
                              const On = N ? G.value : ke;
                              Xe(On);
                            },
                            style: { pointerEvents: "auto" },
                            children: [
                              /* @__PURE__ */ i(
                                "span",
                                {
                                  className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                                  style: { pointerEvents: "none" },
                                  children: /* @__PURE__ */ i(
                                    nt,
                                    {
                                      size: "md",
                                      className: m(
                                        "stroke-ink-primary",
                                        sn(G.value) ? "opacity-100" : "opacity-0"
                                      )
                                    }
                                  )
                                }
                              ),
                              /* @__PURE__ */ i(
                                "span",
                                {
                                  onClick: (ke) => {
                                    ke.preventDefault(), ke.stopPropagation(), Xe(G.value);
                                  },
                                  style: { cursor: "pointer" },
                                  className: m(
                                    "block",
                                    E === "left" ? "text-left" : E === "center" ? "text-center" : "text-right"
                                  ),
                                  children: A ? A(G) : G.label
                                }
                              )
                            ]
                          },
                          G.value
                        )) }, O.groupLabel))
                      ) : (
                        // Render flat data
                        /* @__PURE__ */ p(Yn, { className: "p-1", children: [
                          e.map((O) => /* @__PURE__ */ p(
                            Zn,
                            {
                              value: N ? `${O.value} ${O.label}` : O.value,
                              onSelect: (G) => {
                                const ke = N ? O.value : G;
                                Xe(ke);
                              },
                              style: { pointerEvents: "auto" },
                              children: [
                                /* @__PURE__ */ i(
                                  "span",
                                  {
                                    className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
                                    style: { pointerEvents: "none" },
                                    children: /* @__PURE__ */ i(
                                      nt,
                                      {
                                        size: "md",
                                        className: m(
                                          "stroke-ink-primary",
                                          sn(O.value) ? "opacity-100" : "opacity-0"
                                        )
                                      }
                                    )
                                  }
                                ),
                                /* @__PURE__ */ i(
                                  "span",
                                  {
                                    onClick: (G) => {
                                      G.preventDefault(), G.stopPropagation(), Xe(O.value);
                                    },
                                    style: { cursor: "pointer" },
                                    className: m(
                                      "block",
                                      E === "left" ? "text-left" : E === "center" ? "text-center" : "text-right"
                                    ),
                                    children: A ? A(O) : O.label
                                  }
                                )
                              ]
                            },
                            O.value
                          )),
                          Y && /* @__PURE__ */ i("div", { className: "flex items-center justify-center py-2", children: /* @__PURE__ */ i(
                            "span",
                            {
                              className: m(
                                "text-sm text-ink-primary",
                                te && "opacity-75"
                              ),
                              children: "Loading more..."
                            }
                          ) })
                        ] })
                      )
                    ]
                  }
                )
              ]
            }
          )
        }
      )
    ] });
  };
  return b == null || b === "" ? L !== void 0 && L !== "" ? /* @__PURE__ */ p("div", { className: m("flex flex-col", k ? "" : "w-full"), children: [
    ge(!1),
    /* @__PURE__ */ i(
      W,
      {
        className: m(
          "text-ink-error",
          w ? "text-[10px]" : "text-xs"
        ),
        children: L
      }
    )
  ] }) : ge(!1) : /* @__PURE__ */ p("div", { className: m("flex flex-col justify-between", k ? "" : "w-full", g), children: [
    /* @__PURE__ */ i(
      "label",
      {
        className: m(
          "leading-snug self-start",
          w ? "text-xs" : "text-base",
          "text-ink-primary",
          te ? "font-tunecore" : "font-sentric-alt"
        ),
        htmlFor: Ge,
        children: b
      }
    ),
    ge(!0),
    L !== void 0 && L !== "" && /* @__PURE__ */ i(
      W,
      {
        className: m(
          "text-ink-error",
          w ? "text-[10px]" : "text-xs"
        ),
        children: L
      }
    )
  ] });
}
const Yd = ({
  children: e,
  className: t,
  elevation: n = "default"
}) => {
  const r = j((s) => s.isTunecore);
  return /* @__PURE__ */ i(
    "div",
    {
      className: m(
        "w-full p-4 bg-layer-default text-ink-primary",
        n === "default" && "shadow-md",
        n === "system" && "shadow-system",
        r ? "rounded-lg" : "rounded-sm",
        t
      ),
      children: e
    }
  );
};
function W0({
  className: e,
  buttonClassName: t,
  value: n,
  onChange: r,
  label: s,
  placeholder: a = "Pick a date",
  disabled: o = !1,
  disabledDays: l,
  smallFont: c = !1,
  semiSmallFont: u = !1
}) {
  const d = j((x) => x.isTunecore), [h, f] = K.useState(n);
  K.useEffect(() => {
    f(n);
  }, [n]);
  const g = (x) => {
    x && x.setHours(12, 0, 0, 0), f(x), r(x);
  }, y = () => {
    f(void 0), r(void 0);
  }, v = h ? It(h, "dd/MM/yyyy") : void 0;
  return /* @__PURE__ */ p("div", { className: m("flex flex-col w-full", e), children: [
    s != null && s !== "" ? /* @__PURE__ */ i(
      "label",
      {
        className: m(
          "self-start leading-snug",
          c ? "text-xs" : u ? "text-sm  mb-0.5 font-medium" : "text-base mb-1",
          "text-ink-primary",
          d ? "font-tunecore" : "font-sentric-alt"
        ),
        children: s
      }
    ) : null,
    /* @__PURE__ */ p(Zr, { children: [
      /* @__PURE__ */ i(qr, { asChild: !0, children: /* @__PURE__ */ p(
        "button",
        {
          type: "button",
          disabled: o,
          className: m(
            "flex items-center font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 w-full text-left",
            // TuneCore predates this radius token system and has no spec of
            // its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            d ? "rounded-lg" : "rounded-sm",
            c ? "text-xs" : u ? "text-sm" : "text-base",
            d ? "font-tunecore bg-layer-raised text-white ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary placeholder:text-white/50" : "font-sentric-alt text-ink-primary bg-layer-default ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary placeholder:text-ink-primary/50",
            o && "opacity-50 cursor-not-allowed",
            t
          ),
          children: [
            /* @__PURE__ */ i(Ro, { className: "w-4 h-4 mr-2" }),
            v ?? /* @__PURE__ */ i("span", { className: "text-ink-primary/50", children: a })
          ]
        }
      ) }),
      /* @__PURE__ */ p(Rn, { className: "w-auto p-0", side: "bottom", align: "start", children: [
        /* @__PURE__ */ i(
          Rt,
          {
            mode: "single",
            selected: h,
            onSelect: g,
            disabled: l,
            initialFocus: !0,
            captionLayout: "dropdown",
            defaultMonth: h
          }
        ),
        h && /* @__PURE__ */ i("div", { className: "flex items-end justify-end w-full px-6 pb-4", children: /* @__PURE__ */ i(
          $,
          {
            label: "Clear",
            variant: "link",
            onClick: y,
            className: "w-auto mt-2"
          }
        ) })
      ] })
    ] })
  ] });
}
function G0({
  className: e,
  onSelect: t,
  label: n,
  smallFont: r,
  multiYear: s,
  fromYear: a,
  toYear: o,
  initialRange: l,
  maxDate: c,
  numberOfMonths: u = 2,
  defaultMonth: d
}) {
  const h = j((Y) => Y.isTunecore), [f, g] = K.useState(l), [y, v] = K.useState(l == null ? void 0 : l.from), [x, b] = K.useState(l == null ? void 0 : l.to), w = s === !0, k = K.useRef(t);
  K.useLayoutEffect(() => {
    k.current = t;
  });
  const N = K.useRef(!1);
  K.useEffect(() => {
    w ? (v(l == null ? void 0 : l.from), b(l == null ? void 0 : l.to)) : g(l);
  }, [l, w]), K.useEffect(() => {
    if (!N.current) {
      N.current = !0;
      return;
    }
    w ? g(void 0) : (v(void 0), b(void 0)), k.current(void 0);
  }, [w]);
  const T = (Y) => {
    g(Y), t(Y);
  }, M = (Y) => {
    if (Y === void 0)
      return;
    const z = new Date(Y);
    return z.setHours(12, 0, 0, 0), z;
  }, C = (Y) => {
    const z = M(Y), _ = M(x), L = z !== void 0 && _ !== void 0 && _ < z ? void 0 : _;
    L !== _ && b(void 0), v(z), t(z !== void 0 || L !== void 0 ? { from: z, to: L } : void 0);
  }, D = (Y) => {
    const z = M(Y), _ = M(y);
    b(z), t(_ !== void 0 || z !== void 0 ? { from: _, to: z } : void 0);
  }, A = () => {
    w ? (v(void 0), b(void 0)) : g(void 0), t(void 0);
  }, E = w ? y !== void 0 || x !== void 0 ? { from: y, to: x } : void 0 : f, R = E != null && E.from ? E.to ? /* @__PURE__ */ p("span", { className: "text-sm capitalize font-sentric-alt", children: [
    It(E.from, "LLL dd, y"),
    " ",
    "-",
    " ",
    It(E.to, "LLL dd, y")
  ] }) : /* @__PURE__ */ i("span", { className: "text-sm capitalize font-sentric-alt", children: It(E.from, "LLL dd, y") }) : E != null && E.to ? /* @__PURE__ */ p("span", { className: "text-sm capitalize font-sentric-alt", children: [
    "To:",
    " ",
    It(E.to, "LLL dd, y")
  ] }) : "", B = a !== void 0 || o !== void 0, ee = {
    captionLayout: "dropdown-buttons",
    ...a !== void 0 && { fromYear: a },
    ...o !== void 0 && { toYear: o }
  }, Ce = {
    ...B && { captionLayout: "dropdown-buttons" },
    ...a !== void 0 && { fromYear: a },
    ...o !== void 0 && { toYear: o },
    ...c !== void 0 && { disabled: { after: c } },
    ...c !== void 0 && { toMonth: c },
    numberOfMonths: u
  };
  return /* @__PURE__ */ p("div", { className: m("flex flex-col w-full justify-between", e), children: [
    /* @__PURE__ */ i(
      "label",
      {
        className: m(
          "leading-snug self-start",
          r ? "text-xs" : "text-base",
          "text-ink-primary",
          h ? "font-tunecore" : "font-sentric-alt"
        ),
        htmlFor: "datePicker",
        children: n
      }
    ),
    /* @__PURE__ */ p(Zr, { children: [
      /* @__PURE__ */ i(qr, { asChild: !0, children: /* @__PURE__ */ i(
        $,
        {
          id: "datePicker",
          label: /* @__PURE__ */ p(ce, { children: [
            /* @__PURE__ */ i(Ro, { className: "w-4 h-4 mr-2 shrink-0" }),
            /* @__PURE__ */ i("span", { className: "truncate", children: R })
          ] }),
          variant: "outline",
          className: m(
            "w-full flex items-center px-3 py-1.5 justify-start text-left font-normal normal-case overflow-hidden text-ink-primary",
            h ? "font-tunecore bg-layer-raised ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary"
          )
        }
      ) }),
      /* @__PURE__ */ p(Rn, { className: "w-auto p-0", side: "bottom", align: "center", children: [
        w ? /* @__PURE__ */ p("div", { className: "flex gap-4 p-3", children: [
          /* @__PURE__ */ i("div", { className: "flex flex-col gap-1", children: /* @__PURE__ */ i(
            Rt,
            {
              initialFocus: !0,
              mode: "single",
              selected: y,
              onSelect: C,
              defaultMonth: y ?? /* @__PURE__ */ new Date(),
              ...ee,
              ...c !== void 0 && { disabled: (Y) => Y > c }
            }
          ) }),
          /* @__PURE__ */ i(
            "div",
            {
              className: m(
                "w-px self-stretch",
                h ? "bg-layer-inverse" : "bg-stroke-subtle"
              )
            }
          ),
          /* @__PURE__ */ i("div", { className: m("flex flex-col gap-1", !y && "pointer-events-none opacity-50"), children: /* @__PURE__ */ i(
            Rt,
            {
              mode: "single",
              selected: x,
              onSelect: D,
              defaultMonth: x ?? (y ? new Date(y.getFullYear(), y.getMonth() + 1, 1) : /* @__PURE__ */ new Date()),
              ...ee,
              disabled: (Y) => y !== void 0 && Y < y || c !== void 0 && Y > c
            },
            (y == null ? void 0 : y.toISOString()) ?? "no-from"
          ) })
        ] }) : /* @__PURE__ */ i(
          Rt,
          {
            initialFocus: !0,
            mode: "range",
            defaultMonth: d ?? /* @__PURE__ */ new Date(),
            selected: f,
            onSelect: T,
            ...Ce
          }
        ),
        /* @__PURE__ */ i("div", { className: "flex items-end justify-end w-full px-6 pb-4", children: /* @__PURE__ */ i(
          $,
          {
            label: "Clear",
            variant: "link",
            onClick: A,
            className: "w-auto mt-2"
          }
        ) })
      ] })
    ] })
  ] });
}
const Zd = Z.Root, qd = Z.Trigger, K0 = Z.Group, X0 = Z.Portal, Jd = Z.Sub, Y0 = Z.RadioGroup, ea = S.forwardRef(({ className: e, inset: t, children: n, ...r }, s) => /* @__PURE__ */ p(
  Z.SubTrigger,
  {
    ref: s,
    className: m(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm text-ink-primary outline-none focus:bg-layer-raised data-[state=open]:bg-layer-raised",
      t && "pl-8",
      e
    ),
    ...r,
    children: [
      n,
      /* @__PURE__ */ i(Eo, { className: "w-4 h-4 ml-auto" })
    ]
  }
));
ea.displayName = Z.SubTrigger.displayName;
const ta = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  Z.SubContent,
  {
    ref: n,
    className: m(
      "z-50 min-w-32 overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
ta.displayName = Z.SubContent.displayName;
const na = S.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ i(Z.Portal, { children: /* @__PURE__ */ i(
  Z.Content,
  {
    ref: r,
    sideOffset: t,
    className: m(
      "font-sentric-alt relative z-50 max-h-96 min-w-32 overflow-hidden rounded-md border border-stroke-subtle bg-layer-default text-ink-primary shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 p-1",
      e
    ),
    ...n
  }
) }));
na.displayName = Z.Content.displayName;
const Ln = S.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ i(
  Z.Item,
  {
    ref: r,
    className: m(
      "relative flex w-full cursor-default select-none items-center rounded-sm p-2 text-sm text-ink-primary outline-none focus:bg-layer-raised focus:text-ink-primary data-disabled:pointer-events-none data-disabled:opacity-50 hover:cursor-pointer",
      e
    ),
    ...n
  }
));
Ln.displayName = Z.Item.displayName;
const Qd = S.forwardRef(({ className: e, children: t, checked: n, ...r }, s) => /* @__PURE__ */ p(
  Z.CheckboxItem,
  {
    ref: s,
    className: m(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-layer-raised focus:text-ink-primary data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    checked: n,
    ...r,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ i(Z.ItemIndicator, { children: /* @__PURE__ */ i(Lo, { className: "w-4 h-4" }) }) }),
      t
    ]
  }
));
Qd.displayName = Z.CheckboxItem.displayName;
const eu = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p(
  Z.RadioItem,
  {
    ref: r,
    className: m(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-layer-raised focus:text-ink-primary data-disabled:pointer-events-none data-disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ i(Z.ItemIndicator, { children: /* @__PURE__ */ i(kc, { className: "w-2 h-2 fill-current" }) }) }),
      t
    ]
  }
));
eu.displayName = Z.RadioItem.displayName;
const tu = S.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ i(
  Z.Label,
  {
    ref: r,
    className: m(
      "px-2 py-1.5 text-sm font-semibold",
      t && "pl-8",
      e
    ),
    ...n
  }
));
tu.displayName = Z.Label.displayName;
const nu = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  Z.Separator,
  {
    ref: n,
    className: m("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
nu.displayName = Z.Separator.displayName;
function ru({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "span",
    {
      className: m("ml-auto text-xs tracking-widest opacity-60", e),
      ...t
    }
  );
}
ru.displayName = "DropdownMenuShortcut";
function ls(e) {
  return { id: e.id, name: e.name, size: e.size ?? 0, type: e.type ?? "" };
}
const cs = 50 * 1024 * 1024;
class ds extends Rc {
  constructor(n, r) {
    super(n, r);
    is(this, "opts");
    this.id = r.id ?? "ChunkedUpload", this.type = "uploader", this.opts = {
      chunkSize: cs,
      ...r
    }, this.handleUpload = this.handleUpload.bind(this);
  }
  install() {
    this.uppy.addUploader(this.handleUpload);
  }
  uninstall() {
    this.uppy.removeUploader(this.handleUpload);
  }
  // -- Upload orchestration
  /** Resolve headers — supports both static objects and factory functions. */
  resolveHeaders() {
    const n = this.opts.headers;
    return typeof n == "function" ? n() : n ?? {};
  }
  async handleUpload(n) {
    var r, s, a, o;
    for (const l of n) {
      const c = this.uppy.getFile(l);
      if (c != null && c.data)
        try {
          const u = c.data, d = this.opts.chunkSize ?? cs, h = u.size <= d ? await this.uploadSingle(c, u) : await this.uploadChunked(c, u, d);
          this.uppy.emit("upload-success", c, {
            status: 200,
            body: typeof h == "object" && h !== null ? h : { result: h }
          }), (s = (r = this.opts).onUploadSuccess) == null || s.call(r, ls(c), h);
        } catch (u) {
          const d = u instanceof Error ? u : new Error(String(u));
          this.uppy.emit("upload-error", c, d), (o = (a = this.opts).onUploadError) == null || o.call(a, ls(c), d);
        }
    }
  }
  // -- Single-request upload (small files)
  async uploadSingle(n, r) {
    const s = new FormData(), a = new Blob([r], { type: "application/octet-stream" });
    s.append("file", a, n.name);
    const o = await fetch(this.opts.endpoint, {
      method: "POST",
      headers: this.resolveHeaders(),
      body: s
    });
    if (!o.ok) {
      const c = await o.text().catch(() => "");
      throw new Error(`Upload failed (${o.status}): ${c}`);
    }
    this.uppy.emit("upload-progress", n, {
      uploadStarted: Date.now(),
      bytesUploaded: r.size,
      bytesTotal: r.size
    });
    const l = await o.text();
    try {
      return JSON.parse(l);
    } catch {
      return l;
    }
  }
  // -- Chunked upload (large files — S3 multipart via backend)
  async uploadChunked(n, r, s) {
    const a = Math.ceil(r.size / s);
    let o = "", l = [], c = {};
    const u = n.name.includes(".") ? n.name.slice(n.name.lastIndexOf(".")) : "", d = `${crypto.randomUUID()}${u}`, h = this.opts.endpoint;
    if (!/\/upload$/.test(h))
      throw new Error(
        `ChunkedUploadPlugin: "endpoint" must end with "/upload" (no trailing slash or query params). Received: ${h}`
      );
    const f = h.replace(/\/upload$/, "/upload-chunk");
    for (let g = 0; g < a; g++) {
      const y = g * s, v = Math.min(y + s, r.size), x = r.slice(y, v), b = new FormData();
      b.append("chunk", String(g)), b.append("chunks", String(a)), b.append("name", d), b.append("OriginalFilename", n.name), b.append("UploadID", o), b.append("ETagList", JSON.stringify(l));
      const w = new Blob([x], { type: "application/octet-stream" });
      b.append("file", w, d);
      const k = await fetch(f, {
        method: "POST",
        headers: this.resolveHeaders(),
        body: b
      });
      if (!k.ok) {
        const T = await k.text().catch(() => "");
        throw new Error(`Chunk ${g + 1}/${a} failed (${k.status}): ${T}`);
      }
      const N = await k.json().catch(() => ({}));
      c = typeof N == "object" && N !== null ? N : {}, typeof c.uploadID == "string" && (o = c.uploadID), Array.isArray(c.eTagList) && (l = c.eTagList), this.uppy.emit("upload-progress", n, {
        uploadStarted: Date.now(),
        bytesUploaded: v,
        bytesTotal: r.size
      });
    }
    return c;
  }
}
const iu = {
  "application/vnd.v21": [".v21"],
  "text/plain": [".txt"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"]
};
function su(e) {
  return e !== void 0 ? Object.keys(e).length > 0 ? e : void 0 : iu;
}
function ou(e) {
  if (!e)
    return;
  const t = [];
  for (const [n, r] of Object.entries(e)) {
    t.push(n);
    for (const s of r)
      t.includes(s) || t.push(s);
  }
  return t.length > 0 ? t : void 0;
}
function au(e) {
  if (e === 0)
    return "0 B";
  const t = 1024, n = ["B", "KB", "MB", "GB", "TB", "PB"], r = Math.min(n.length - 1, Math.floor(Math.log(e) / Math.log(t)));
  return `${Number.parseFloat((e / t ** r).toFixed(1))} ${n[r]}`;
}
const ra = ({
  files: e,
  onRemoveFile: t,
  onClearAll: n,
  onUploadStart: r,
  disabled: s
}) => {
  const { uppy: a, status: o, progress: l } = Bc(), c = Ee(o);
  Ae(() => {
    c.current !== "uploading" && o === "uploading" && (r == null || r(e.length)), c.current = o;
  }, [o, r, e.length]);
  const [u, d] = se({}), [h, f] = se({});
  Ae(() => {
    if (o !== "uploading" && o !== "paused" && o !== "complete" && o !== "error")
      return;
    const k = () => {
      const T = a.getState(), M = {}, C = {};
      for (const [D, A] of Object.entries(T.files)) {
        const E = A;
        M[D] = E.progress, C[D] = E.error ?? null;
      }
      d(M), f(C);
    };
    if (k(), o === "complete" || o === "error")
      return;
    const N = window.setInterval(k, 250);
    return () => window.clearInterval(N);
  }, [a, o]);
  const g = o === "uploading" || o === "paused", y = o === "complete", v = o === "error", x = e.length > 0, b = g || s === !0, w = De(() => {
    a.upload();
  }, [a]);
  return x ? /* @__PURE__ */ p(ce, { children: [
    /* @__PURE__ */ p("div", { className: "flex flex-col gap-1 mt-1", children: [
      e.map((k) => {
        const N = u[k.id] ?? k.progress, T = (N == null ? void 0 : N.percentage) ?? 0, M = (N == null ? void 0 : N.uploadComplete) === !0, C = h[k.id] ?? k.error ?? null;
        return /* @__PURE__ */ p("div", { className: "flex items-center gap-2 text-xs", children: [
          /* @__PURE__ */ p("span", { className: "flex-1 truncate", title: k.name, children: [
            k.name,
            /* @__PURE__ */ p("span", { className: "ml-1 text-ink-secondary", children: [
              "(",
              au(k.size ?? 0),
              ")"
            ] })
          ] }),
          M && /* @__PURE__ */ i("span", { className: "text-ink-success", children: "Done" }),
          C != null && /* @__PURE__ */ i("span", { className: "text-ink-error", title: C, children: "Failed" }),
          !M && C == null && g && /* @__PURE__ */ p("span", { className: "text-ink-secondary tabular-nums", children: [
            T,
            "%"
          ] }),
          /* @__PURE__ */ i(
            "button",
            {
              type: "button",
              className: "text-ink-secondary hover:text-ink-error transition-colors px-1",
              onClick: (D) => {
                D.stopPropagation(), t(k.id);
              },
              "aria-label": `Remove file ${k.name}`,
              title: "Remove file",
              disabled: b,
              children: "✕"
            }
          )
        ] }, k.id);
      }),
      g && /* @__PURE__ */ i("div", { className: "w-full h-1.5 bg-layer-raised rounded-full overflow-hidden mt-1", children: /* @__PURE__ */ i(
        "div",
        {
          className: "h-full bg-action-primary transition-all duration-300",
          style: { width: `${l}%` }
        }
      ) })
    ] }),
    /* @__PURE__ */ p("div", { className: "flex items-center gap-2 self-end", children: [
      !g && !y && /* @__PURE__ */ i(
        $,
        {
          className: "text-xs font-sentric-alt",
          variant: "primary",
          label: "Upload",
          disabled: e.length === 0 || b,
          onClick: w
        }
      ),
      y && /* @__PURE__ */ i("span", { className: "text-xs text-ink-success font-medium", children: "All uploads complete" }),
      v && !g && /* @__PURE__ */ i(
        $,
        {
          className: "text-xs font-sentric-alt",
          variant: "primary",
          label: "Retry",
          disabled: b,
          onClick: w
        }
      ),
      /* @__PURE__ */ i(
        $,
        {
          className: "text-xs font-sentric-alt",
          variant: "link",
          label: "Clear all",
          onClick: n,
          disabled: b
        }
      )
    ] })
  ] }) : null;
};
ra.displayName = "UploadModeContent";
const lu = ({
  endpoint: e,
  headers: t,
  onUploadSuccess: n,
  onUploadError: r,
  onUploadStart: s,
  multiple: a = !1,
  chunkSize: o,
  accept: l,
  disabled: c,
  label: u,
  useFsAccessApi: d = !0,
  // Legacy props
  onFileAccepted: h,
  file: f,
  onClick: g
}) => {
  const y = j((z) => z.isTunecore), v = e !== void 0 && e !== "", x = su(l), b = Zt(
    () => ou(x),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- stable reference from resolveAccept
    [JSON.stringify(x)]
  ), [w] = se(() => {
    if (!v)
      return null;
    const z = new Ec({
      autoProceed: !1,
      restrictions: {
        maxNumberOfFiles: a ? null : 1,
        allowedFileTypes: b ?? null
      }
    });
    return z.use(ds, {
      id: "ChunkedUpload",
      endpoint: e,
      headers: t,
      chunkSize: o,
      onUploadSuccess: n,
      onUploadError: r
    }), z;
  });
  Ae(() => () => {
    w == null || w.cancelAll();
  }, [w]), Ae(() => {
    if (!w)
      return;
    const z = w.getPlugin("ChunkedUpload");
    z && z instanceof ds && (z.opts.headers = t, z.opts.onUploadSuccess = n, z.opts.onUploadError = r);
  }, [w, t, n, r]);
  const [k, N] = se([]), T = De((z) => {
    w && w.removeFile(z), N((_) => _.filter((L) => L.id !== z));
  }, [w]), M = De(() => {
    w && w.cancelAll(), N([]);
  }, [w]), C = De((z) => {
    if (v && w) {
      if (!a) {
        const L = Object.keys(w.getState().files);
        for (const oe of L)
          w.removeFile(oe);
        N([]);
      }
      const _ = [];
      for (const L of z)
        try {
          const oe = w.addFile({
            name: L.name,
            type: L.type || "application/octet-stream",
            data: L,
            source: "local"
          });
          oe && _.push({
            id: typeof oe == "string" ? oe : L.name,
            name: L.name,
            size: L.size
          });
        } catch {
        }
      _.length > 0 && N((L) => [...L, ..._]);
    } else h != null && z[0] != null && h(z[0]);
  }, [v, w, a, h]), { getRootProps: D, getInputProps: A, isFocused: E, isDragAccept: R, isDragReject: B } = Fc({
    onDrop: C,
    accept: x,
    disabled: c,
    multiple: v ? a : !1,
    useFsAccessApi: d
  }), ee = f != null, Ce = [
    "flex flex-col items-center p-3 outline-none transition-all duration-200",
    y ? "rounded-lg" : "rounded-sm",
    "bg-layer-raised",
    "border-stroke-subtle",
    "text-ink-primary",
    c ? "cursor-not-allowed" : "cursor-pointer",
    E && "border-stroke-primary!",
    R && "border-stroke-success!",
    B && "border-stroke-error!"
  ].filter(Boolean).join(" "), Y = v ? "Drag and drop files here, or click to select" : ee ? `Selected File: ${f == null ? void 0 : f.name}` : "Drag and drop a file here, or click to select a file";
  return /* @__PURE__ */ p("div", { className: "flex flex-col gap-1.5 w-full", children: [
    u != null && u !== "" && /* @__PURE__ */ i("label", { className: "text-sm font-medium text-ink-primary", children: u }),
    /* @__PURE__ */ p("div", { ...D({ className: Ce }), children: [
      /* @__PURE__ */ i(
        "input",
        {
          ...A(),
          "aria-label": "Upload file - drag and drop a file here, or click to select a file",
          title: "Upload file - supports drag and drop or click to browse"
        }
      ),
      /* @__PURE__ */ i(W, { as: "p", children: Y })
    ] }),
    v && w && /* @__PURE__ */ i(
      Lc,
      {
        uppy: w,
        children: /* @__PURE__ */ i(
          ra,
          {
            files: k,
            onRemoveFile: T,
            onClearAll: M,
            onUploadStart: s,
            disabled: c
          }
        )
      }
    ),
    !v && ee && /* @__PURE__ */ i("div", { className: "flex items-center gap-2 self-end", children: /* @__PURE__ */ i(
      $,
      {
        className: "text-xs font-sentric-alt",
        variant: "link",
        label: "Clear selected file",
        onClick: g
      }
    ) })
  ] });
};
lu.displayName = "FileDropzone";
const cu = Ve(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), ia = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  jo.Root,
  {
    ref: n,
    className: m(cu(), e),
    ...t
  }
));
ia.displayName = jo.Root.displayName;
const Z0 = jc, sa = S.createContext(
  {}
), oa = S.createContext(
  {}
);
function Bn() {
  const e = S.useContext(sa), t = S.useContext(oa), { id: n } = t;
  if (!e.name)
    return {
      id: n,
      name: "",
      formItemId: `${n}-form-item`,
      formDescriptionId: `${n}-form-item-description`,
      formMessageId: `${n}-form-item-message`,
      invalid: !1,
      isDirty: !1,
      isTouched: !1,
      isValidating: !1
    };
  const { getFieldState: r, formState: s } = zc(), a = r(e.name, s);
  return {
    id: n,
    name: e.name,
    formItemId: `${n}-form-item`,
    formDescriptionId: `${n}-form-item-description`,
    formMessageId: `${n}-form-item-message`,
    ...a
  };
}
function q0({
  ...e
}) {
  const t = S.useMemo(
    () => ({ name: e.name }),
    [e.name]
  );
  return /* @__PURE__ */ i(sa.Provider, { value: t, children: /* @__PURE__ */ i(_c, { ...e }) });
}
const du = S.forwardRef(({ className: e, ...t }, n) => {
  const r = S.useId(), s = S.useMemo(() => ({ id: r }), [r]);
  return /* @__PURE__ */ i(oa.Provider, { value: s, children: /* @__PURE__ */ i("div", { ref: n, className: m("", e), ...t }) });
});
du.displayName = "FormItem";
const uu = S.forwardRef(({ className: e, smallFont: t, required: n, children: r, ...s }, a) => {
  const { error: o, formItemId: l } = Bn(), c = j((u) => u.isTunecore);
  return /* @__PURE__ */ p(
    ia,
    {
      ref: a,
      className: m(
        o && "",
        "text-ink-primary",
        c ? "font-tunecore" : "font-sentric-alt",
        t ? "text-xs" : "text-sm font-medium",
        "leading-snug inline-flex",
        e
      ),
      htmlFor: l,
      ...s,
      children: [
        r,
        n && /* @__PURE__ */ i(W, { className: "ml-1", "aria-label": "required", children: "*" })
      ]
    }
  );
});
uu.displayName = "FormLabel";
const hu = S.forwardRef(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: s, formMessageId: a } = Bn();
  return /* @__PURE__ */ i(
    En,
    {
      ref: t,
      id: r,
      "aria-describedby": n ? `${s} ${a}` : `${s}`,
      "aria-invalid": !!n,
      ...e
    }
  );
});
hu.displayName = "FormControl";
const fu = S.forwardRef(({ className: e, ...t }, n) => {
  const { formDescriptionId: r } = Bn();
  return /* @__PURE__ */ i(
    "p",
    {
      ref: n,
      id: r,
      className: m("text-sm text-muted-foreground", e),
      ...t
    }
  );
});
fu.displayName = "FormDescription";
const mu = S.forwardRef(({ className: e, children: t, ...n }, r) => {
  const { error: s, formMessageId: a } = Bn(), o = s == null ? void 0 : s.message;
  let l;
  return typeof o == "string" && o !== "undefined" && o !== "" ? l = o : l = t, l == null || l === "" ? null : /* @__PURE__ */ i(
    W,
    {
      as: "bodySm",
      ref: r,
      id: a,
      className: m(
        "text-ink-error font-medium",
        e
      ),
      ...n,
      children: l
    }
  );
});
mu.displayName = "FormMessage";
const pu = [], gu = [];
function yu() {
  return /* @__PURE__ */ p(ce, { children: [
    /* @__PURE__ */ p(
      "svg",
      {
        "aria-hidden": "true",
        className: "absolute -left-px -top-px h-[calc(100%+2px)] w-auto overflow-visible opacity-0 transition-opacity duration-150 ease-out motion-reduce:transition-none group-data-[state=checked]/mark:opacity-100",
        fill: "none",
        viewBox: "0 0 18 16",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ i("path", { d: "M13.5 0.5H2A1.5 1.5 0 0 0 0.5 2V14A1.5 1.5 0 0 0 2 15.5H14A1.5 1.5 0 0 0 15.5 14V7.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1", vectorEffect: "non-scaling-stroke" }),
          /* @__PURE__ */ i("path", { d: "M3.25 7.08L7.55 11.39L16.5 2.44", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.16667", vectorEffect: "non-scaling-stroke" })
        ]
      }
    ),
    /* @__PURE__ */ i("span", { className: "relative flex size-4 items-center justify-center", children: /* @__PURE__ */ i(
      "svg",
      {
        "aria-hidden": "true",
        className: "absolute opacity-0 transition-opacity duration-150 ease-out motion-reduce:transition-none group-data-[state=indeterminate]/mark:opacity-100",
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ i("path", { d: "M4 8L12 8", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5" })
      }
    ) })
  ] });
}
const xr = S.forwardRef(({
  className: e,
  smallFont: t = !1,
  column: n = !1,
  label: r = "",
  secondaryLabel: s,
  id: a,
  checked: o,
  onCheckedChange: l,
  onChange: c,
  defaultChecked: u,
  disabled: d = !1,
  isList: h = !1,
  options: f = pu,
  showSelectAll: g = !0,
  onSelectionChange: y,
  selectedValues: v = gu,
  tableHeader: x = !1,
  ...b
}, w) => {
  const k = S.useId(), N = a ?? `form-checkbox-${k}`, T = `${N}-label`, M = `${N}-secondary-label`, C = r !== "" || s !== void 0, D = S.useMemo(
    () => v.length === f.length && f.length > 0,
    [v, f.length]
  ), A = (B) => {
    y && y(
      v.includes(B) ? v.filter((ee) => ee !== B) : [...v, B]
    );
  }, E = (B) => {
    const ee = B === !0;
    l == null || l(ee), c && c({
      target: { checked: ee },
      currentTarget: { checked: ee }
    });
  }, R = /* @__PURE__ */ i(
    ss.Root,
    {
      id: N,
      ref: w,
      "aria-describedby": s !== void 0 ? M : void 0,
      "aria-labelledby": r !== "" ? T : void 0,
      checked: o,
      defaultChecked: u,
      disabled: d,
      onCheckedChange: E,
      className: m(
        "relative flex shrink-0 cursor-pointer items-center justify-center rounded-[2px] border bg-transparent outline-none transition-colors duration-150 ease-out motion-reduce:transition-none focus-visible:ring-2 focus-visible:ring-action-primary focus-visible:ring-offset-2 disabled:pointer-events-none",
        !C && "disabled:opacity-25",
        C || x ? "size-6" : "size-4",
        "border-ink-primary text-ink-primary data-[state=checked]:border-transparent data-[state=checked]:text-ink-accent",
        e
      ),
      ...b,
      children: /* @__PURE__ */ i(ss.Indicator, { forceMount: !0, className: "group/mark", children: /* @__PURE__ */ i(yu, {}) })
    }
  );
  return h ? /* @__PURE__ */ p("div", { className: "flex flex-col items-start gap-4", children: [
    g && f.length > 0 && /* @__PURE__ */ i(
      xr,
      {
        checked: D,
        label: "Select all",
        onCheckedChange: (B) => y == null ? void 0 : y(B ? f.map((ee) => ee.value) : [])
      }
    ),
    f.map((B) => /* @__PURE__ */ i(
      xr,
      {
        checked: v.includes(B.value),
        label: B.label,
        onCheckedChange: () => A(B.value)
      },
      B.value
    ))
  ] }) : C ? /* @__PURE__ */ p(
    "div",
    {
      className: m(
        n ? "flex flex-col-reverse items-start gap-4" : "flex items-center gap-4",
        d && "pointer-events-none opacity-25"
      ),
      children: [
        R,
        /* @__PURE__ */ p("label", { className: "flex min-w-0 cursor-pointer flex-col gap-2 whitespace-nowrap overflow-clip [text-box-edge:cap_alphabetic] [text-box-trim:trim-both]", htmlFor: N, children: [
          r !== "" && /* @__PURE__ */ i(W, { as: t ? "label" : "bodySm", id: T, children: r }),
          s !== void 0 && /* @__PURE__ */ i(W, { as: "label", className: "text-ink-secondary", id: M, children: s })
        ] })
      ]
    }
  ) : R;
});
xr.displayName = "FormCheckbox";
const vu = S.forwardRef(
  ({ className: e, smallFont: t, type: n, hasError: r, errorMessage: s, customWidth: a, label: o, ...l }, c) => {
    const u = j((y) => y.isTunecore), d = l["aria-invalid"] === !0 || r || s !== void 0 && s !== "", f = `formTextInput-${S.useId()}`, g = (y) => {
      const v = y ? { id: f, name: f } : {};
      return y ? /* @__PURE__ */ i(
        "input",
        {
          type: n,
          className: m(
            "flex font-medium px-2 py-1.5  focus-visible:outline-none transition ease-out duration-200",
            // TuneCore predates this radius token system and has no spec
            // of its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            u ? "rounded-lg" : "rounded-sm",
            a ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            u ? "font-tunecore text-white placeholder:text-white/50 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary bg-layer-raised" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            d && (u ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      ) : /* @__PURE__ */ i(
        "input",
        {
          type: n,
          className: m(
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200",
            // TuneCore predates this radius token system and has no spec
            // of its own — keep its original rounded-lg (8px) rather than
            // silently inheriting Sentric's new rounded-sm (6px).
            u ? "rounded-lg" : "rounded-sm",
            a ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            u ? "font-tunecore text-white bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            d && (u ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      );
    };
    return o == null || o === "" ? s !== void 0 && s !== "" ? /* @__PURE__ */ p("div", { className: m("flex flex-col", a ? "" : "w-full"), children: [
      g(!1),
      /* @__PURE__ */ i(
        W,
        {
          className: m(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: s
        }
      )
    ] }) : g(!1) : /* @__PURE__ */ p("div", { className: m("flex flex-col justify-between", a ? "" : "w-full"), children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: m(
            "leading-snug self-start",
            t ? "text-xs" : "text-base",
            "text-ink-primary",
            u ? "font-tunecore" : "font-sentric-alt"
          ),
          htmlFor: f,
          children: o
        }
      ),
      g(!0),
      s !== void 0 && s !== "" && /* @__PURE__ */ i(
        W,
        {
          className: m(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: s
        }
      )
    ] });
  }
);
vu.displayName = "FormInput";
const bu = [], xu = S.forwardRef(
  ({
    className: e,
    smallFont: t,
    type: n = "text",
    hasError: r,
    customWidth: s,
    label: a,
    values: o = bu,
    onChange: l,
    placeholder: c,
    addButtonText: u = "Add another",
    minItems: d = 1,
    ...h
  }, f) => {
    const g = j((N) => N.isTunecore), y = h["aria-invalid"] === !0 || r;
    S.useEffect(() => {
      if (d > 0 && o.length < d) {
        const N = [...o];
        for (; N.length < d; )
          N.push("");
        l(N);
      }
    }, [o, d, l]);
    const v = (N, T) => {
      const M = [...o];
      M[N] = T, l(M);
    }, x = () => {
      l([...o, ""]);
    }, b = (N) => {
      if (o.length > d) {
        const T = o.filter((M, C) => C !== N);
        l(T);
      }
    }, w = m(
      "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200",
      // TuneCore predates this radius token system and has no spec of its
      // own — keep its original rounded-lg (8px) rather than silently
      // inheriting Sentric's new rounded-sm (6px).
      g ? "rounded-lg" : "rounded-sm",
      s ? "" : "w-full",
      t ? "text-xs" : "text-sm",
      g ? "font-tunecore bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
      y && (g ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
      e
    ), k = () => {
      const N = o.length === 0 ? [""] : o, T = o.length === 0;
      return /* @__PURE__ */ p("div", { className: "space-y-2", children: [
        N.map((M, C) => /* @__PURE__ */ p("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ i(
            "input",
            {
              type: n,
              className: w,
              value: M,
              onChange: (D) => {
                T ? l([D.target.value]) : v(C, D.target.value);
              },
              placeholder: c,
              ref: C === 0 ? f : void 0,
              ...h
            }
          ),
          o.length > d && /* @__PURE__ */ i(
            $,
            {
              type: "button",
              variant: "link",
              onClick: () => b(C),
              className: "min-w-0 p-1",
              icon: /* @__PURE__ */ i(Go, { className: "h-5 w-5 stroke-ink-primary group-hover:stroke-ink-accent" })
            }
          )
        ] }, `input-${C}`)),
        /* @__PURE__ */ i(
          $,
          {
            type: "button",
            variant: "link",
            onClick: x,
            className: "flex items-center text-ink-accent",
            icon: /* @__PURE__ */ i(yd, { className: "w-5 h-5" }),
            label: u
          }
        )
      ] });
    };
    return a == null || a === "" ? k() : /* @__PURE__ */ p("div", { className: m("flex flex-col justify-between", s ? "" : "w-full"), children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: m(
            "leading-snug self-start mb-2",
            t ? "text-xs" : "text-base",
            g ? "font-tunecore" : "font-sentric-alt"
          ),
          children: a
        }
      ),
      k()
    ] });
  }
);
xu.displayName = "FormMultipleInput";
const wu = S.forwardRef(
  ({ hasError: e, errorMessage: t, smallFont: n, min: r, max: s, className: a, showPercentage: o = !1, ...l }, c) => {
    const u = j((h) => h.isTunecore), d = l["aria-invalid"] === !0 || e || t !== void 0 && t !== "";
    return /* @__PURE__ */ p("div", { className: "flex flex-col justify-between", children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: m(
            "leading-snug self-start text-ink-primary",
            n ? "text-xs" : "text-base",
            u ? "font-tunecore" : "font-sentric-alt"
          ),
          htmlFor: "formNumberInput",
          children: l.label
        }
      ),
      /* @__PURE__ */ p("div", { className: "relative", children: [
        /* @__PURE__ */ i(
          "input",
          {
            min: r,
            max: s,
            id: "formNumberInput",
            name: "formNumberInput",
            type: "number",
            className: m(
              "flex font-medium px-2 py-1.5 min-w-24 focus-visible:outline-none transition ease-out duration-200",
              // TuneCore predates this radius token system and has no spec
              // of its own — keep its original rounded-lg (8px) rather than
              // silently inheriting Sentric's new rounded-sm (6px).
              u ? "rounded-lg" : "rounded-sm",
              o ? "pr-6" : "",
              // Add right padding when percentage is shown
              n ? "text-xs" : "text-sm",
              u ? "font-tunecore bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
              d && (u ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-error bg-layer-error"),
              a
            ),
            ref: c,
            ...l
          }
        ),
        o && /* @__PURE__ */ i(
          "span",
          {
            className: m(
              "absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none",
              n ? "text-xs" : "text-sm",
              "text-ink-primary",
              u ? "font-tunecore" : "font-sentric-alt"
            ),
            children: "%"
          }
        )
      ] }),
      t !== void 0 && t !== "" && /* @__PURE__ */ i(
        "span",
        {
          className: m(
            "text-ink-error mt-0.5",
            n ? "text-[10px]" : "text-xs"
          ),
          children: t
        }
      )
    ] });
  }
);
wu.displayName = "NumberInput";
const ku = S.forwardRef(
  ({ className: e, smallFont: t, hasError: n, errorMessage: r, customWidth: s, label: a, rows: o, ...l }, c) => {
    const u = j((y) => y.isTunecore), d = l["aria-invalid"] === !0 || n || r !== void 0 && r !== "", f = `formTextarea-${S.useId()}`, g = (y) => {
      const v = y ? { id: f, name: f } : {};
      return y ? /* @__PURE__ */ i(
        "textarea",
        {
          rows: o ?? 4,
          className: m(
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 resize-y",
            u ? "rounded-lg" : "rounded-sm",
            s ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            u ? "font-tunecore text-ink-primary placeholder:text-white/50 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary bg-layer-raised" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            d && (u ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      ) : /* @__PURE__ */ i(
        "textarea",
        {
          rows: o ?? 4,
          className: m(
            "flex font-medium px-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 resize-y",
            u ? "rounded-lg" : "rounded-sm",
            s ? "" : "w-full",
            t ? "text-xs" : "text-sm",
            u ? "font-tunecore text-ink-primary bg-layer-raised placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-stroke-primary" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary",
            d && (u ? "ring-2 ring-action-destructive" : "ring-2 ring-stroke-primary bg-layer-error"),
            e
          ),
          ref: c,
          ...v,
          ...l
        }
      );
    };
    return a == null || a === "" ? r !== void 0 && r !== "" ? /* @__PURE__ */ p("div", { className: m("flex flex-col", s ? "" : "w-full"), children: [
      g(!1),
      /* @__PURE__ */ i(
        W,
        {
          className: m(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: r
        }
      )
    ] }) : g(!1) : /* @__PURE__ */ p("div", { className: m("flex flex-col justify-between", s ? "" : "w-full"), children: [
      /* @__PURE__ */ i(
        "label",
        {
          className: m(
            "leading-snug self-start",
            t ? "text-xs" : "text-base",
            "text-ink-primary",
            u ? "font-tunecore" : "font-sentric-alt"
          ),
          htmlFor: f,
          children: a
        }
      ),
      g(!0),
      r !== void 0 && r !== "" && /* @__PURE__ */ i(
        W,
        {
          className: m(
            "text-ink-error",
            t ? "text-[10px]" : "text-xs"
          ),
          children: r
        }
      )
    ] });
  }
);
ku.displayName = "FormTextarea";
const aa = "0 0 2342 278.32", us = { x: 117.08, y: 142.73 }, la = [
  {
    id: "s-dot",
    d: "M234.152 142.729C234.152 207.75 181.683 260.877 117.467 260.877C53.2513 260.877 -0.000976562 207.75 -0.000976562 142.729C-0.000976562 77.7079 52.4682 24.5811 116.684 24.5811C180.9 24.5811 234.152 76.915 234.152 142.729Z",
    offsetX: 1053.92
  },
  {
    id: "s-swoosh",
    d: "M371.2 103.082C309.333 97.5314 299.936 93.5668 299.936 81.6727C299.936 72.1574 309.333 65.8139 353.188 65.8139C399.392 65.8139 420.536 72.1574 420.536 89.6021H514.511C511.378 31.7175 455.777 0 353.188 0C312.466 0 278.008 5.55057 252.948 17.4447C282.707 50.7481 300.719 94.3597 300.719 142.729C300.719 149.865 299.936 157.002 299.152 164.138C315.598 167.31 335.176 169.689 356.32 171.275C422.886 176.032 431.5 179.204 431.5 193.477C431.5 204.578 422.886 212.508 367.284 212.508C346.923 212.508 317.164 210.922 288.972 207.75C281.924 227.573 270.96 245.811 258.43 261.67C286.622 273.564 324.212 278.321 371.2 278.321C467.524 278.321 525.475 256.912 525.475 189.512C525.475 118.941 463.608 111.011 371.2 103.082Z",
    offsetX: 781.79
  },
  {
    id: "E",
    d: "M554.267 7.13623V271.185H821.311V201.406H644.326V173.653H814.263V104.668H644.326V76.9148H821.311V7.13623H554.267Z",
    offsetX: 483.21
  },
  {
    id: "N",
    d: "M1107.75 7.13623V181.583L984.017 7.13623H850.104V271.185H940.946V96.7383L1063.9 271.185H1197.81V7.13623H1107.75Z",
    offsetX: 147.04
  },
  {
    id: "T",
    d: "M1226.6 7.13623V84.0513H1336.24V271.185H1427.08V84.0513H1537.5V7.13623H1226.6Z",
    offsetX: -211.05
  },
  {
    id: "R",
    d: "M1655.57 81.276V131.231H1745.63C1765.99 131.231 1780.87 131.231 1780.87 106.65C1780.87 82.0689 1765.99 82.0689 1745.63 82.0689H1655.57V81.276ZM1875.63 218.454V270.788H1785.57V233.52C1785.57 209.732 1780.09 203.389 1756.59 203.389H1656.35V270.788H1566.29V7.53271H1769.12C1841.17 7.53271 1877.19 37.6644 1877.19 93.1701C1877.19 133.61 1859.96 156.605 1828.64 167.706C1856.83 169.292 1875.63 186.737 1875.63 218.454Z",
    offsetX: -550.74
  },
  {
    id: "I",
    d: "M1996.04 7.53271H1905.98V270.788H1996.04V7.53271Z",
    offsetX: -780.01
  },
  {
    id: "C",
    d: "M2183.81 0C2277.78 0 2334.17 39.6469 2342 113.39H2245.68C2241.76 96.7385 2223.75 76.915 2183.81 76.915C2136.82 76.915 2118.81 104.668 2118.81 138.764C2118.81 173.654 2137.6 201.406 2183.81 201.406C2223.75 201.406 2241.76 181.583 2245.68 164.138H2342C2334.17 237.882 2278.57 278.321 2183.81 278.321C2083.57 278.321 2024.83 231.538 2024.83 138.764C2024.83 45.9904 2083.57 0 2183.81 0Z",
    offsetX: -1012.41
  }
], Nu = {
  wave: { durationMs: 1600, staggerShare: 0.07 },
  reveal: { durationMs: 2400, staggerShare: 0 },
  draw: { durationMs: 2400, staggerShare: 0.045 }
};
function ca({
  variant: e = "reveal",
  durationMs: t,
  label: n = "Loading",
  className: r
}) {
  const s = Nu[e], a = t ?? s.durationMs, { staggerShare: o } = s;
  return /* @__PURE__ */ i(
    "svg",
    {
      viewBox: aa,
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className: m("sentric-logo-loader w-full", `sentric-logo-loader--${e}`, r),
      style: { "--sentric-logo-duration": `${a}ms` },
      role: n == null ? void 0 : "status",
      "aria-label": n ?? void 0,
      "aria-hidden": n == null ? !0 : void 0,
      children: /* @__PURE__ */ i("g", { className: "sentric-logo-loader__group", children: la.map((l, c) => {
        const u = l.id === "s-dot";
        return /* @__PURE__ */ i(
          "g",
          {
            className: m(
              "sentric-logo-loader__glyph",
              u && "sentric-logo-loader__glyph--dot"
            ),
            style: {
              "--sentric-logo-tx": `${l.offsetX}px`,
              ...o > 0 ? {
                "--sentric-logo-delay": `${Math.round(c * o * a)}ms`
              } : {}
            },
            children: u ? (
              // Nested group so the dot's pop-in scale composes with the
              // spread translate above it — two animations cannot share
              // one `transform`.
              /* @__PURE__ */ i(
                "g",
                {
                  className: "sentric-logo-loader__dot",
                  style: { transformOrigin: `${us.x}px ${us.y}px` },
                  children: /* @__PURE__ */ i("path", { className: "sentric-logo-loader__path", d: l.d, pathLength: 1 })
                }
              )
            ) : /* @__PURE__ */ i("path", { className: "sentric-logo-loader__path", d: l.d, pathLength: 1 })
          },
          l.id
        );
      }) })
    }
  );
}
const J0 = ({ loadingText: e = "Loading..." }) => Oc.createPortal(
  /* @__PURE__ */ p(
    "div",
    {
      role: "status",
      "aria-live": "polite",
      className: "fixed inset-0 z-50 flex flex-col items-center justify-center bg-black/10 backdrop-blur-xl",
      children: [
        /* @__PURE__ */ i(ca, { label: null, className: "w-1/4 mb-2 md:w-1/8 text-ink-primary" }),
        /* @__PURE__ */ i(W, { as: "subtitle", className: "text-ink-primary", children: e })
      ]
    }
  ),
  document.getElementById("loading-root")
), Q0 = ({
  loadingText: e = "Loading..."
}) => /* @__PURE__ */ p(
  "div",
  {
    role: "status",
    "aria-live": "polite",
    className: "absolute inset-0 z-50 flex flex-col items-center justify-center overflow-hidden bg-black/10 rounded-md backdrop-blur-3xl",
    children: [
      /* @__PURE__ */ i(ca, { label: null, className: "w-48 max-w-[50%] text-ink-primary" }),
      /* @__PURE__ */ i(W, { as: "subtitle", className: "mt-4 text-center text-ink-primary", children: e })
    ]
  }
);
function e1({ title: e, className: t }) {
  return /* @__PURE__ */ i(
    "svg",
    {
      viewBox: aa,
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      className: m("w-full", t),
      role: e == null ? void 0 : "img",
      "aria-label": e,
      "aria-hidden": e == null ? !0 : void 0,
      children: la.map((n) => /* @__PURE__ */ i("path", { d: n.d }, n.id))
    }
  );
}
const hs = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_API: "https://uat-sa-api.publishingdashboard.com/api/v1", VITE_API_OLD: "https://uatapi.sentricapp.com/api/v1", VITE_CLONE_LIST_URL: "https://vws7dkrb5qhuu6ayzkjprt7h2a0ckuev.lambda-url.eu-west-1.on.aws/", VITE_LAUNCH_DARKLY_ID: "624d54bdea0454154cd0d09a", VITE_LOCIZE_API_KEY: "lz_api_v0oGYt5shmgU9ax8UKYHT7QRmj1wCmB7", VITE_LOCIZE_PROJECT_ID: "5ee2f31f-72cc-4506-bfa8-8a10e34c5935", VITE_LOCIZE_VERSION: "staging", VITE_OTEL_ENABLED: "true", VITE_OTEL_EXPORTER_URL: "/api/traces", VITE_RIGHTS_APP_URL: "https://datasuite-rightsapp-git-deploy-uat-sentric-music.vercel.app/", VITE_STAGE: "uat", VITE_TRACKING: "false" }, Ht = /* @__PURE__ */ new Map(), yn = (e) => {
  const t = Ht.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([n, r]) => [n, r.getState()])
  ) : {};
}, Su = (e, t, n) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(n)
    };
  const r = Ht.get(n.name);
  if (r)
    return { type: "tracked", store: e, ...r };
  const s = {
    connection: t.connect(n),
    stores: {}
  };
  return Ht.set(n.name, s), { type: "tracked", store: e, ...s };
}, Tu = (e, t) => {
  if (t === void 0) return;
  const n = Ht.get(e);
  n && (delete n.stores[t], Object.keys(n.stores).length === 0 && Ht.delete(e));
}, Cu = (e) => {
  var t, n;
  if (!e) return;
  const r = e.split(`
`), s = r.findIndex(
    (o) => o.includes("api.setState")
  );
  if (s < 0) return;
  const a = ((t = r[s + 1]) == null ? void 0 : t.trim()) || "";
  return (n = /.+ (.+) .+/.exec(a)) == null ? void 0 : n[1];
}, Pu = (e, t = {}) => (n, r, s) => {
  const { enabled: a, anonymousActionType: o, store: l, ...c } = t;
  let u;
  try {
    u = (a ?? (hs ? "production" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!u)
    return e(n, r, s);
  const { connection: d, ...h } = Su(l, u, c);
  let f = !0;
  s.setState = ((v, x, b) => {
    const w = n(v, x);
    if (!f) return w;
    const k = b === void 0 ? {
      type: o || Cu(new Error().stack) || "anonymous"
    } : typeof b == "string" ? { type: b } : b;
    return l === void 0 ? (d == null || d.send(k, r()), w) : (d == null || d.send(
      {
        ...k,
        type: `${l}/${k.type}`
      },
      {
        ...yn(c.name),
        [l]: s.getState()
      }
    ), w);
  }), s.devtools = {
    cleanup: () => {
      d && typeof d.unsubscribe == "function" && d.unsubscribe(), Tu(c.name, l);
    }
  };
  const g = (...v) => {
    const x = f;
    f = !1, n(...v), f = x;
  }, y = e(s.setState, r, s);
  if (h.type === "untracked" ? d == null || d.init(y) : (h.stores[h.store] = s, d == null || d.init(
    Object.fromEntries(
      Object.entries(h.stores).map(([v, x]) => [
        v,
        v === h.store ? y : x.getState()
      ])
    )
  )), s.dispatchFromDevtools && typeof s.dispatch == "function") {
    let v = !1;
    const x = s.dispatch;
    s.dispatch = (...b) => {
      (hs ? "production" : void 0) !== "production" && b[0].type === "__setState" && !v && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), v = !0), x(...b);
    };
  }
  return d.subscribe((v) => {
    var x;
    switch (v.type) {
      case "ACTION":
        if (typeof v.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return qn(
          v.payload,
          (b) => {
            if (b.type === "__setState") {
              if (l === void 0) {
                g(b.state);
                return;
              }
              Object.keys(b.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const w = b.state[l];
              if (w == null)
                return;
              JSON.stringify(s.getState()) !== JSON.stringify(w) && g(w);
              return;
            }
            s.dispatchFromDevtools && typeof s.dispatch == "function" && s.dispatch(b);
          }
        );
      case "DISPATCH":
        switch (v.payload.type) {
          case "RESET":
            return g(y), l === void 0 ? d == null ? void 0 : d.init(s.getState()) : d == null ? void 0 : d.init(yn(c.name));
          case "COMMIT":
            if (l === void 0) {
              d == null || d.init(s.getState());
              return;
            }
            return d == null ? void 0 : d.init(yn(c.name));
          case "ROLLBACK":
            return qn(v.state, (b) => {
              if (l === void 0) {
                g(b), d == null || d.init(s.getState());
                return;
              }
              g(b[l]), d == null || d.init(yn(c.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return qn(v.state, (b) => {
              if (l === void 0) {
                g(b);
                return;
              }
              JSON.stringify(s.getState()) !== JSON.stringify(b[l]) && g(b[l]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: b } = v.payload, w = (x = b.computedStates.slice(-1)[0]) == null ? void 0 : x.state;
            if (!w) return;
            g(l === void 0 ? w : w[l]), d == null || d.send(
              null,
              // FIXME no-any
              b
            );
            return;
          }
          case "PAUSE_RECORDING":
            return f = !f;
        }
        return;
    }
  }), y;
}, Mu = Pu, qn = (e, t) => {
  let n;
  try {
    n = JSON.parse(e);
  } catch (r) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      r
    );
  }
  n !== void 0 && t(n);
};
function t1({ steps: e, initialStep: t, storeName: n = "wizard" }) {
  if (e.length === 0)
    throw new Error("Wizard must have at least one step");
  const r = t ?? e[0], s = e.indexOf(r);
  if (s === -1)
    throw new Error(`Initial step "${r}" not found in steps array`);
  return Fo()(
    Mu(
      (a, o) => ({
        currentStep: r,
        currentStepIndex: s,
        completedSteps: [],
        isStepComplete: (l) => o().completedSteps.includes(l),
        markStepComplete: (l) => {
          o().completedSteps.includes(l) || a((c) => ({ completedSteps: [...c.completedSteps, l] }));
        },
        nextStep: () => {
          const l = o().currentStepIndex + 1;
          l >= e.length || a({ currentStep: e[l], currentStepIndex: l });
        },
        previousStep: () => {
          const l = o().currentStepIndex - 1;
          l < 0 || a({ currentStep: e[l], currentStepIndex: l });
        },
        goToStep: (l) => {
          const c = e.indexOf(l);
          c !== -1 && a({ currentStep: l, currentStepIndex: c });
        },
        reset: () => {
          a({
            currentStep: r,
            currentStepIndex: s,
            completedSteps: []
          });
        }
      }),
      {
        name: n
      }
    )
  );
}
const Du = ({
  onNext: e,
  onPrevious: t,
  canGoNext: n = !0,
  canGoPrevious: r = !0,
  isNextLoading: s = !1,
  isPreviousLoading: a = !1,
  nextDisabledTooltip: o,
  hideNext: l,
  hidePrevious: c,
  nextLabel: u = "Next",
  previousLabel: d = "Previous",
  isLastStep: h = !1,
  isTunecore: f = !1
}) => {
  const g = async () => {
    if (n && !s && e != null)
      try {
        await e();
      } catch (v) {
        console.error("Error in next step:", v);
      }
  }, y = async () => {
    if (r && !a && t != null)
      try {
        await t();
      } catch (v) {
        console.error("Error in previous step:", v);
      }
  };
  return /* @__PURE__ */ p("div", { className: "flex justify-between mt-6", children: [
    /* @__PURE__ */ i("div", { className: "flex", children: !c && r && t != null ? /* @__PURE__ */ i(
      $,
      {
        type: "button",
        variant: "outline",
        onClick: () => {
          y();
        },
        disabled: !r || a,
        label: a ? "Loading..." : d
      }
    ) : !c && /* @__PURE__ */ i("div", {}) }),
    /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
      !l && (!n || s) && o != null && o !== "" && /* @__PURE__ */ p("div", { className: "flex items-center gap-2 px-3 py-2 rounded-lg bg-layer-disabled", children: [
        /* @__PURE__ */ i(wd, { className: "w-5 h-5 shrink-0 stroke-ink-accent" }),
        /* @__PURE__ */ i("span", { className: "text-sm text-ink-secondary", children: o })
      ] }),
      !l && e != null && /* @__PURE__ */ i(
        $,
        {
          type: "button",
          variant: f ? "secondary" : "primary",
          onClick: () => {
            g();
          },
          disabled: !n || s,
          label: s ? "Loading..." : h ? "Finish" : u
        }
      )
    ] })
  ] });
}, Jn = ({
  index: e,
  title: t,
  isActive: n,
  isCompleted: r,
  showStepNumbers: s,
  isTunecore: a,
  onStepClick: o,
  canNavigate: l = !0
}) => {
  const u = `w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-200 ${r ? a ? "bg-action-primary text-white" : "bg-action-secondary text-black" : n ? a ? "bg-brand-primary text-white" : "bg-action-primary/70 text-white" : a && l ? "bg-layer-inverse text-white" : a ? "bg-layer-inverse text-gray-500" : "bg-layer-raised text-ink-secondary border-2 border-stroke-subtle"}`, d = [n && "current step", r && "completed"].filter(Boolean).join(", "), h = d ? `${t}, ${d}` : t, f = s ? r && !n ? /* @__PURE__ */ i(nt, { className: "w-5 h-5 stroke-black", "aria-hidden": "true" }) : /* @__PURE__ */ i("span", { className: "leading-none", children: e + 1 }) : r ? /* @__PURE__ */ i(nt, { className: "w-5 h-5 stroke-black", "aria-hidden": "true" }) : null;
  return o != null ? /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      onClick: () => {
        l && o(e);
      },
      className: m(u, l ? "cursor-pointer" : "cursor-not-allowed"),
      "aria-label": h,
      "aria-current": n ? "step" : void 0,
      "aria-disabled": !l,
      children: f
    }
  ) : /* @__PURE__ */ i("div", { className: u, children: f });
}, Iu = ({ index: e, currentStepIndex: t, isTunecore: n }) => {
  const r = e < t ? n ? "bg-action-primary" : "bg-action-secondary" : e === t ? n ? "bg-layer-inverse" : "bg-action-primary" : n ? "bg-layer-inverse" : "bg-layer-raised";
  return /* @__PURE__ */ i("div", { className: m("flex-1 h-0.5 mx-2", r) });
}, fs = ({ index: e, currentStepIndex: t, isTunecore: n }) => {
  const r = e < t ? n ? "bg-action-primary" : "bg-action-secondary" : e === t ? n ? "bg-layer-inverse" : "bg-action-primary" : n ? "bg-layer-inverse" : "bg-layer-raised";
  return /* @__PURE__ */ i("div", { className: m("flex-1 mx-2 w-0.5", r) });
}, Au = ({ step: e, animated: t, children: n }) => {
  const r = e.visible !== !1;
  return t ? /* @__PURE__ */ i(
    "div",
    {
      className: m("overflow-hidden transition-all duration-500 ease-in-out", {
        "max-h-0 opacity-0": !r,
        "max-h-40 opacity-100": r
      }),
      children: n
    }
  ) : r ? /* @__PURE__ */ i(ce, { children: n }) : null;
}, Vu = ({
  steps: e,
  currentStepIndex: t,
  direction: n = "horizontal",
  isTunecore: r = !1,
  onStepClick: s,
  animated: a = !1,
  showStepNumbers: o = !0,
  showDescriptions: l = !1,
  showLabels: c = !0,
  stretch: u = !1,
  canNavigateToStep: d
}) => {
  if (e.length === 0)
    return null;
  const h = Math.min(Math.max(t, 0), e.length - 1);
  return /* @__PURE__ */ p(
    "div",
    {
      className: m({
        "w-full mb-4": n === "horizontal",
        "h-full": n === "vertical" && u
      }),
      children: [
        /* @__PURE__ */ p("div", { className: "block md:hidden", children: [
          /* @__PURE__ */ p("div", { className: "flex items-center justify-between mb-2", children: [
            /* @__PURE__ */ p("span", { className: `text-sm font-medium ${r ? "text-white" : "text-ink-primary"}`, children: [
              h + 1,
              " ",
              "of",
              " ",
              e.length
            ] }),
            /* @__PURE__ */ i("div", { className: "flex justify-center mt-3 space-x-2", children: e.map((f, g) => {
              const y = g === h, v = f.isComplete === !0 || g < h;
              return /* @__PURE__ */ i(
                "div",
                {
                  className: m("w-3 h-3 rounded-full transition-all duration-200", {
                    [r ? "bg-action-primary" : "bg-action-secondary"]: v,
                    [r ? "bg-brand-primary" : "bg-action-primary"]: !v && y,
                    [r ? "bg-layer-inverse" : "bg-layer-raised"]: !v && !y
                  })
                },
                f.id
              );
            }) })
          ] }),
          /* @__PURE__ */ i(
            "div",
            {
              className: m("w-full h-2 rounded-full", {
                "bg-layer-inverse": r,
                "bg-layer-raised": !r
              }),
              children: /* @__PURE__ */ i(
                "div",
                {
                  className: "h-2 rounded-full transition-all duration-300 bg-action-primary",
                  style: { width: `${(h + 1) / e.length * 100}%` }
                }
              )
            }
          )
        ] }),
        n === "horizontal" && /* @__PURE__ */ i("div", { className: "items-center justify-between hidden md:flex", children: e.map((f, g) => {
          const y = g === h, v = f.isComplete === !0 || g < h, x = g === e.length - 1;
          return /* @__PURE__ */ p("div", { className: `flex items-center ${x ? "" : "flex-1"}`, children: [
            /* @__PURE__ */ p("div", { className: "flex flex-col items-center", children: [
              /* @__PURE__ */ i(
                Jn,
                {
                  index: g,
                  title: f.title,
                  isActive: y,
                  isCompleted: v,
                  showStepNumbers: o,
                  isTunecore: r,
                  onStepClick: s,
                  canNavigate: d == null || d(g)
                }
              ),
              l && /* @__PURE__ */ p("div", { className: "mt-2 text-center", children: [
                /* @__PURE__ */ i(
                  "div",
                  {
                    className: m("text-sm font-medium", {
                      "text-ink-accent": y && !r || v && !y,
                      "text-brand-primary": y && r,
                      "text-white/70": r && !y && !v,
                      "text-ink-secondary": !r && !y && !v
                    }),
                    children: f.title
                  }
                ),
                f.description != null && f.description !== "" && /* @__PURE__ */ i("div", { className: "text-xs mt-1 text-ink-secondary", children: f.description })
              ] })
            ] }),
            !x && /* @__PURE__ */ i(
              Iu,
              {
                index: g,
                currentStepIndex: h,
                isTunecore: r
              }
            )
          ] }, f.id);
        }) }),
        n === "vertical" && /* @__PURE__ */ i("div", { className: m("hidden md:flex flex-col", { "h-full": u }), children: e.map((f, g) => {
          const y = g === h, v = f.isComplete === !0 || g < h, x = g === e.length - 1, b = /* @__PURE__ */ p("div", { className: "ml-3 min-w-0", children: [
            /* @__PURE__ */ i(
              "div",
              {
                className: m("text-sm font-medium pt-1", {
                  "text-ink-accent": y && !r || v && !y,
                  "text-brand-primary": y && r,
                  "text-white/70": r && !y && !v,
                  "text-ink-secondary": !r && !y && !v
                }),
                children: f.title
              }
            ),
            l && f.description != null && f.description !== "" && /* @__PURE__ */ i("div", { className: "text-xs mt-0.5 text-ink-secondary", children: f.description })
          ] });
          return u ? /* @__PURE__ */ p(K.Fragment, { children: [
            /* @__PURE__ */ p("div", { className: "flex flex-row items-center self-center", children: [
              /* @__PURE__ */ i(
                Jn,
                {
                  index: g,
                  title: f.title,
                  isActive: y,
                  isCompleted: v,
                  showStepNumbers: o,
                  isTunecore: r,
                  onStepClick: s,
                  canNavigate: d == null || d(g)
                }
              ),
              c && b
            ] }),
            !x && /* @__PURE__ */ i("div", { className: "flex flex-row flex-1", children: /* @__PURE__ */ i("div", { className: "flex flex-col items-center w-8", children: /* @__PURE__ */ i(
              fs,
              {
                index: g,
                currentStepIndex: h,
                isTunecore: r
              }
            ) }) })
          ] }, f.id) : /* @__PURE__ */ i(Au, { step: f, animated: a, children: /* @__PURE__ */ p("div", { className: "flex flex-row", children: [
            /* @__PURE__ */ p("div", { className: "flex flex-col items-center w-8", children: [
              /* @__PURE__ */ i(
                Jn,
                {
                  index: g,
                  title: f.title,
                  isActive: y,
                  isCompleted: v,
                  showStepNumbers: o,
                  isTunecore: r,
                  onStepClick: s,
                  canNavigate: d == null || d(g)
                }
              ),
              !x && /* @__PURE__ */ i("div", { className: m("flex flex-col flex-1", { "pb-5": !c }), children: /* @__PURE__ */ i(
                fs,
                {
                  index: g,
                  currentStepIndex: h,
                  isTunecore: r
                }
              ) })
            ] }),
            c && /* @__PURE__ */ p("div", { className: m("ml-3 min-w-0", { "pb-5": !x }), children: [
              /* @__PURE__ */ i(
                "div",
                {
                  className: m("text-sm font-medium pt-1", {
                    "text-ink-accent": y && !r || v && !y,
                    "text-brand-primary": y && r,
                    "text-white/70": r && !y && !v,
                    "text-ink-secondary": !r && !y && !v
                  }),
                  children: f.title
                }
              ),
              l && f.description != null && f.description !== "" && /* @__PURE__ */ i("div", { className: "text-xs mt-0.5 text-ink-secondary", children: f.description })
            ] })
          ] }) }, f.id);
        }) })
      ]
    }
  );
}, n1 = ({
  steps: e,
  wizardStore: t,
  showProgress: n = !0,
  showNavigation: r = !0,
  showStepNumbers: s = !0,
  showDescriptions: a = !1,
  direction: o,
  isTunecore: l,
  onStepClick: c,
  onComplete: u,
  onCancel: d,
  // Currently unused but reserved for future implementation
  onError: h,
  className: f,
  containerClassName: g
}) => {
  const [y, v] = se({}), [x, b] = se(!1), [w, k] = se(null), N = e[t.currentStepIndex], T = N == null ? void 0 : N.component;
  Ae(() => {
    k(null);
  }, [t.currentStepIndex]);
  const M = e.map((R) => ({
    ...R,
    isComplete: t.completedSteps.includes(R.id)
  })), C = async () => {
    if (N != null) {
      if (k(null), v((R) => ({
        ...R,
        [N.id]: !0
      })), (N == null ? void 0 : N.validation) != null) {
        b(!0);
        try {
          const R = await N.validation();
          if (!R.isValid) {
            v((B) => ({
              ...B,
              [N.id]: !1
            })), k(R.errorMessage ?? "Validation failed. Please check your input and try again.");
            return;
          }
        } catch (R) {
          k("An unexpected error occurred. Please try again."), h != null ? h(R) : console.error("Validation error:", R);
          return;
        } finally {
          b(!1);
        }
      }
      t.markStepComplete(N.id), t.currentStepIndex === e.length - 1 ? u == null || u() : t.nextStep();
    }
  }, D = () => {
    t.previousStep();
  }, A = (R) => {
    t.markStepComplete(R);
  };
  if (N == null || T == null)
    return /* @__PURE__ */ p("div", { className: "p-4 text-ink-error", children: [
      'Error: No component found for step "',
      t.currentStep,
      '"'
    ] });
  const E = {
    stepId: N.id,
    isActive: !0,
    onNext: C,
    onPrevious: D,
    onComplete: A,
    onWizardComplete: u,
    // Pass the wizard's onComplete to allow steps to complete the wizard
    isNextDisabled: y[N.id] === !1 || x,
    isPreviousDisabled: t.currentStepIndex === 0 || x,
    isLoading: x
  };
  return /* @__PURE__ */ p(
    Yd,
    {
      className: g ?? f,
      children: [
        n && /* @__PURE__ */ i(
          Vu,
          {
            steps: M,
            currentStepIndex: t.currentStepIndex,
            showStepNumbers: s,
            showDescriptions: a,
            direction: o,
            isTunecore: l,
            onStepClick: c
          }
        ),
        /* @__PURE__ */ i(T, { ...E }),
        /* @__PURE__ */ i(nd, { message: w ?? void 0 }),
        r && /* @__PURE__ */ i(
          Du,
          {
            onNext: C,
            onPrevious: t.currentStepIndex > 0 ? D : void 0,
            canGoNext: !(y[N.id] === !1 || x),
            canGoPrevious: t.currentStepIndex > 0 && !x,
            isNextLoading: x,
            isPreviousLoading: !1,
            isLastStep: t.currentStepIndex === e.length - 1,
            nextLabel: t.currentStepIndex === e.length - 1 ? "Complete" : "Next",
            isTunecore: l
          }
        )
      ]
    }
  );
};
function r1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    pr.Root,
    {
      "data-slot": "radio-group",
      className: m("grid gap-3", e),
      ...t
    }
  );
}
function i1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    pr.Item,
    {
      "data-slot": "radio-group-item",
      className: m(
        "aspect-square size-4 shrink-0 cursor-pointer rounded-full border shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        "border-ink-primary focus-visible:ring-action-primary/50 data-[state=checked]:bg-action-primary data-[state=checked]:border-ink-accent",
        e
      ),
      ...t,
      children: /* @__PURE__ */ i(
        pr.Indicator,
        {
          "data-slot": "radio-group-indicator",
          className: "flex size-full items-center justify-center text-ink-inverse",
          children: /* @__PURE__ */ i(
            "svg",
            {
              className: "size-3",
              viewBox: "0 0 12 12",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
              "aria-hidden": "true",
              children: /* @__PURE__ */ i(
                "path",
                {
                  d: "M10 3L4.5 8.5L2 6",
                  stroke: "currentColor",
                  strokeWidth: "1.16667",
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }
              )
            }
          )
        }
      )
    }
  );
}
function s1({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: m(
        "flex flex-col overflow-y-auto rounded-sm border border-stroke-subtle bg-layer-default",
        e
      ),
      ...t
    }
  );
}
const da = ie.Root, o1 = ie.Group, ua = ie.Value, Jr = S.forwardRef(({ className: e, smallFont: t, label: n, customWidth: r, ...s }, a) => {
  const o = j((d) => d.isTunecore), c = `formSelect-${S.useId()}`, u = (d) => {
    const h = d ? { id: c, name: c } : {};
    return /* @__PURE__ */ p(
      ie.Trigger,
      {
        ref: a,
        "aria-label": "Select an option",
        className: m(
          "group flex cursor-pointer font-medium pr-2 py-1.5 focus-visible:outline-none transition ease-out duration-200 justify-between items-center",
          o ? "rounded-lg" : "rounded-sm",
          "data-disabled:cursor-not-allowed data-disabled:pointer-events-none",
          r ? "" : "w-full",
          t ? "text-xs" : "text-sm",
          o ? "font-tunecore bg-layer-raised text-white placeholder:text-white/35 ring-1 hover:ring-2 ring-layer-raised hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary data-disabled:hover:ring-layer-raised data-disabled:text-white/35" : "font-sentric-alt bg-layer-default text-ink-primary placeholder:text-ink-secondary ring-1 hover:ring-2 ring-stroke-heavy hover:ring-stroke-primary focus-visible:ring-2 focus-visible:ring-stroke-primary data-disabled:ring-stroke-disabled data-disabled:hover:ring-stroke-disabled data-disabled:text-ink-disabled",
          e
        ),
        ...h,
        ...s,
        children: [
          /* @__PURE__ */ i("span", { className: "flex-1 pl-3 text-left", children: s.children }),
          /* @__PURE__ */ i(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              strokeWidth: "1.75",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "w-4 h-4 ml-2 shrink-0 stroke-ink-primary group-data-disabled:stroke-ink-disabled",
              children: /* @__PURE__ */ i("path", { d: "m6 9 6 6 6-6" })
            }
          )
        ]
      }
    );
  };
  return n == null || n === "" ? u(!1) : /* @__PURE__ */ p("div", { className: m("flex flex-col justify-between", r ? "" : "w-full"), children: [
    /* @__PURE__ */ i(
      "label",
      {
        className: m(
          "leading-snug self-start text-ink-primary",
          t ? "text-xs" : "text-base",
          o ? "font-tunecore" : "font-sentric-alt"
        ),
        htmlFor: c,
        children: n
      }
    ),
    u(!0)
  ] });
});
Jr.displayName = "SelectTrigger";
const ha = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ie.ScrollUpButton,
  {
    ref: n,
    className: m(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ i(Nc, { className: "w-4 h-4" })
  }
));
ha.displayName = ie.ScrollUpButton.displayName;
const fa = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ie.ScrollDownButton,
  {
    ref: n,
    className: m(
      "flex cursor-default items-center justify-center py-1",
      e
    ),
    ...t,
    children: /* @__PURE__ */ i(Vo, { className: "w-4 h-4" })
  }
));
fa.displayName = ie.ScrollDownButton.displayName;
const Qr = S.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, s) => {
  const a = j((o) => o.isTunecore);
  return /* @__PURE__ */ i(ie.Portal, { children: /* @__PURE__ */ p(
    ie.Content,
    {
      ref: s,
      className: m(
        "relative z-50 max-h-96 min-w-32 overflow-hidden rounded-md border shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        a ? "font-tunecore border-stroke-subtle bg-layer-inverse text-white" : "font-sentric-alt border-stroke-subtle bg-layer-default text-ink-primary",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      ...r,
      children: [
        /* @__PURE__ */ i(ha, {}),
        /* @__PURE__ */ i(
          ie.Viewport,
          {
            className: m(
              "p-1",
              n === "popper" && "h-(--radix-select-trigger-height) w-full min-w-(--radix-select-trigger-width)"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ i(fa, {})
      ]
    }
  ) });
});
Qr.displayName = ie.Content.displayName;
const Eu = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ie.Label,
  {
    ref: n,
    className: m("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
    ...t
  }
));
Eu.displayName = ie.Label.displayName;
const ei = S.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ p(
  ie.Item,
  {
    ref: r,
    className: m(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none data-disabled:pointer-events-none data-disabled:opacity-50 hover:cursor-pointer",
      "focus:bg-layer-raised focus:text-ink-primary hover:bg-layer-raised hover:text-ink-primary",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ i("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ i(ie.ItemIndicator, { children: /* @__PURE__ */ i(Lo, { className: "w-4 h-4" }) }) }),
      /* @__PURE__ */ i(ie.ItemText, { children: t })
    ]
  }
));
ei.displayName = ie.Item.displayName;
const Ru = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  ie.Separator,
  {
    ref: n,
    className: m("-mx-1 my-1 h-px bg-[var(--color-stroke-divider)]", e),
    ...t
  }
));
Ru.displayName = ie.Separator.displayName;
const a1 = X.Root, l1 = X.Trigger, c1 = X.Close, Lu = X.Portal, ma = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  X.Overlay,
  {
    className: m(
      "fixed inset-0 z-50 bg-black/10  backdrop-blur-xl  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
ma.displayName = X.Overlay.displayName;
const Bu = Ve(
  "fixed z-50 gap-4 bg-layer-default text-ink-primary p-6 shadow-lg transition ease-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-200 data-[state=open]:duration-200",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), Fu = S.forwardRef(({ side: e = "right", className: t, children: n, ...r }, s) => /* @__PURE__ */ p(Lu, { children: [
  /* @__PURE__ */ i(ma, {}),
  /* @__PURE__ */ p(
    X.Content,
    {
      ref: s,
      className: m(Bu({ side: e }), t),
      ...r,
      children: [
        n,
        /* @__PURE__ */ p(X.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
          /* @__PURE__ */ i(Wo, { size: "lg", className: "stroke-ink-primary" }),
          /* @__PURE__ */ i("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
Fu.displayName = X.Content.displayName;
function zu({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: m(
        "flex flex-col space-y-2 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
zu.displayName = "SheetHeader";
function ju({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: m(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
ju.displayName = "SheetFooter";
const _u = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  X.Title,
  {
    ref: n,
    className: m("text-lg font-semibold text-left font-sentric", e),
    ...t
  }
));
_u.displayName = X.Title.displayName;
const Ou = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  X.Description,
  {
    ref: n,
    className: m("text-sm text-muted-foreground", e),
    ...t
  }
));
Ou.displayName = X.Description.displayName;
const pa = S.createContext(null), ga = S.createContext(null);
function ya() {
  const e = S.useContext(pa);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider");
  return e;
}
const $u = 295, Hu = 200, Uu = 420;
function vn(e, t, n) {
  return Math.min(n, Math.max(t, e));
}
function d1({
  open: e,
  onOpenChange: t,
  defaultWidth: n = $u,
  minWidth: r = Hu,
  maxWidth: s = Uu,
  widthStorageKey: a,
  children: o
}) {
  const l = S.useCallback((v) => t(v), [t]), c = S.useCallback(() => t(!e), [t, e]), [u, d] = S.useState(() => {
    if (a == null)
      return vn(n, r, s);
    try {
      const v = localStorage.getItem(a), x = v != null ? Number.parseInt(v, 10) : Number.NaN;
      return vn(Number.isNaN(x) ? n : x, r, s);
    } catch {
      return vn(n, r, s);
    }
  }), [h, f] = S.useState(!1), g = S.useCallback((v) => {
    d((x) => {
      const b = vn(v, r, s);
      if (a != null && b !== x)
        try {
          localStorage.setItem(a, String(b));
        } catch {
        }
      return b;
    });
  }, [r, s, a]), y = S.useMemo(() => ({
    state: e ? "expanded" : "collapsed",
    open: e,
    setOpen: l,
    toggleSidebar: c,
    width: u,
    setWidth: g,
    minWidth: r,
    maxWidth: s,
    resizing: h
  }), [e, l, c, u, g, r, s, h]);
  return /* @__PURE__ */ i(pa.Provider, { value: y, children: /* @__PURE__ */ i(ga.Provider, { value: f, children: o }) });
}
const Wu = 4, Gu = S.forwardRef(
  ({ className: e, onPointerDown: t, ...n }, r) => {
    const { toggleSidebar: s, state: a, width: o, setWidth: l } = ya(), c = S.useContext(ga), u = S.useRef(null), d = (y) => {
      u.current = { startX: y.clientX, startWidth: o, dragged: !1 }, y.currentTarget.setPointerCapture(y.pointerId), t == null || t(y);
    }, h = (y) => {
      const v = u.current;
      if (!v)
        return;
      const x = y.clientX - v.startX;
      !v.dragged && Math.abs(x) >= Wu && (v.dragged = !0, c == null || c(!0)), v.dragged && l(v.startWidth + x);
    }, f = (y) => {
      var v;
      (v = u.current) != null && v.dragged && (c == null || c(!1)), y.currentTarget.hasPointerCapture(y.pointerId) && y.currentTarget.releasePointerCapture(y.pointerId);
    }, g = (y) => {
      var x;
      const v = ((x = u.current) == null ? void 0 : x.dragged) ?? !1;
      if (u.current = null, v) {
        y.preventDefault();
        return;
      }
      s();
    };
    return a !== "expanded" ? null : /* @__PURE__ */ i(
      "button",
      {
        ref: r,
        type: "button",
        "data-slot": "sidebar-rail",
        "data-state": a,
        "aria-label": "Toggle Sidebar",
        title: "Toggle Sidebar",
        onPointerDown: d,
        onPointerMove: h,
        onPointerUp: f,
        onPointerCancel: f,
        onClick: g,
        className: m(
          "absolute inset-y-0 -right-4 z-20 hidden w-4 -translate-x-1/2 cursor-col-resize touch-none opacity-0 transition-opacity duration-150 ease-out after:absolute after:inset-y-0 after:left-1/2 after:w-px after:-translate-x-1/2 after:transition-colors hover:after:bg-stroke-primary group-hover:opacity-100 focus-visible:opacity-100 lg:flex",
          e
        ),
        ...n
      }
    );
  }
);
Gu.displayName = "SidebarRail";
const Ku = S.forwardRef(
  ({ className: e, onClick: t, ...n }, r) => {
    const { state: s, toggleSidebar: a } = ya(), o = s === "collapsed";
    return /* @__PURE__ */ i(
      "button",
      {
        ref: r,
        type: "button",
        "data-slot": "sidebar-toggle-button",
        "data-state": s,
        "aria-label": o ? "Expand Sidebar" : "Collapse Sidebar",
        title: o ? "Expand Sidebar" : "Collapse Sidebar",
        onClick: (l) => {
          a(), t == null || t(l);
        },
        className: m(
          "absolute -right-3 top-1/2 z-30 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full border border-stroke-subtle bg-layer-default text-ink-primary shadow-small-grey opacity-0 transition-all duration-150 ease-out hover:scale-110 group-hover:opacity-100 focus-visible:opacity-100 lg:flex",
          e
        ),
        ...n,
        children: o ? /* @__PURE__ */ i(Wr, { className: "w-3.5 h-3.5 stroke-ink-primary" }) : /* @__PURE__ */ i(Ur, { className: "w-3.5 h-3.5 stroke-ink-primary" })
      }
    );
  }
);
Ku.displayName = "SidebarToggleButton";
const Xu = S.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ i(
    "div",
    {
      ref: n,
      "data-slot": "sidebar-footer",
      className: m("mt-auto flex flex-col gap-2", e),
      ...t
    }
  )
);
Xu.displayName = "SidebarFooter";
function Ze({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: m("animate-pulse rounded-md bg-black/10 backdrop-blur-xl", e),
      ...t
    }
  );
}
function u1({ trackCount: e = 4 }) {
  return /* @__PURE__ */ p(Ze, { className: "w-full min-h-[400px] rounded-lg flex flex-col", children: [
    /* @__PURE__ */ p("div", { className: "flex items-center gap-4 p-6", children: [
      /* @__PURE__ */ i(Ze, { className: "w-20 h-20 rounded-md shrink-0" }),
      /* @__PURE__ */ p("div", { className: "flex-1", children: [
        /* @__PURE__ */ i(Ze, { className: "w-3/4 h-4 mb-2" }),
        /* @__PURE__ */ i(Ze, { className: "w-1/2 h-3" })
      ] })
    ] }),
    /* @__PURE__ */ i("div", { className: "flex-1 p-6 pt-0", children: /* @__PURE__ */ i("div", { className: "space-y-6", children: Array.from({ length: e }, (t, n) => /* @__PURE__ */ p("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ i(Ze, { className: "w-6 h-4 shrink-0" }),
      /* @__PURE__ */ i(Ze, { className: "flex-1 h-4" }),
      /* @__PURE__ */ i(Ze, { className: "w-12 h-4 shrink-0" })
    ] }, `track-skeleton-${n}`)) }) })
  ] });
}
function Yu({ className: e, ...t }) {
  return /* @__PURE__ */ i(
    "div",
    {
      className: m("animate-pulse rounded-md bg-layer-raised", e),
      ...t
    }
  );
}
const Zu = {
  sm: { container: "w-3 h-3", border: "1.5px" },
  md: { container: "w-4 h-4", border: "2px" },
  lg: { container: "w-6 h-6", border: "2.5px" }
};
function h1({
  status: e = "pending",
  size: t = "md",
  label: n,
  className: r
}) {
  if (e === "idle")
    return null;
  const { container: s, border: a } = Zu[t];
  return /* @__PURE__ */ p("span", { className: m("inline-flex items-center", n != null && n !== "" && "gap-2", r), children: [
    /* @__PURE__ */ p(
      "span",
      {
        className: m("relative shrink-0 inline-flex items-center justify-center", s),
        style: { "--spinner-border": a },
        children: [
          e === "pending" && /* @__PURE__ */ i(
            "span",
            {
              "aria-label": "Loading",
              role: "status",
              className: "absolute inset-0 rounded-full border-current border-t-transparent animate-spin",
              style: { borderWidth: "var(--spinner-border)" }
            }
          ),
          e === "success" && /* @__PURE__ */ i(
            "svg",
            {
              "aria-label": "Success",
              role: "img",
              className: m(
                "absolute inset-0 animate-in zoom-in-50 fade-in duration-200",
                s
              ),
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: 2.5,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: /* @__PURE__ */ i("path", { d: "M20 6 9 17l-5-5" })
            }
          ),
          e === "error" && /* @__PURE__ */ p(
            "svg",
            {
              "aria-label": "Error",
              role: "img",
              className: m(
                "absolute inset-0 animate-in zoom-in-50 fade-in duration-200",
                s
              ),
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: 2.5,
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [
                /* @__PURE__ */ i("path", { d: "M18 6 6 18" }),
                /* @__PURE__ */ i("path", { d: "m6 6 12 12" })
              ]
            }
          )
        ]
      }
    ),
    n != null && n !== "" && /* @__PURE__ */ i("span", { className: "text-sm leading-none", children: n })
  ] });
}
function qu(e) {
  return /* @__PURE__ */ p("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
    /* @__PURE__ */ i("path", { d: "M12 4L4 12", stroke: "currentColor", strokeWidth: "1.16667", strokeLinecap: "round", strokeLinejoin: "round" }),
    /* @__PURE__ */ i("path", { d: "M4 4L12 12", stroke: "currentColor", strokeWidth: "1.16667", strokeLinecap: "round", strokeLinejoin: "round" })
  ] });
}
function Ju(e) {
  return /* @__PURE__ */ i("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: /* @__PURE__ */ i("path", { d: "M13.3333 4L6 11.3333L2.66667 8", stroke: "currentColor", strokeWidth: "1.16667", strokeLinecap: "round", strokeLinejoin: "round" }) });
}
const Qu = Ve(
  "peer inline-flex shrink-0 items-center rounded-full border shadow-xs transition-colors outline-none focus-visible:ring-[3px] focus-visible:ring-action-primary/50 disabled:cursor-not-allowed data-[state=unchecked]:bg-layer-raised data-[state=unchecked]:border-stroke-default data-[state=checked]:bg-action-primary data-[state=checked]:border-stroke-primary disabled:bg-layer-disabled disabled:border-stroke-disabled",
  {
    variants: {
      size: {
        sm: "h-6 w-10 p-0.5",
        xl: "h-8 w-13 p-1"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
), eh = Ve(
  "group/thumb pointer-events-none flex items-center justify-center rounded-full transition-transform data-[state=unchecked]:bg-layer-strong data-[state=checked]:bg-layer-accent data-[disabled]:bg-layer-raised",
  {
    variants: {
      size: {
        sm: "size-5 data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0",
        xl: "size-6 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
);
function f1({
  className: e,
  size: t = "sm",
  disabled: n,
  ...r
}) {
  return /* @__PURE__ */ i(
    os.Root,
    {
      "data-slot": "switch",
      disabled: n,
      className: m(Qu({ size: t }), e),
      ...r,
      children: /* @__PURE__ */ p(os.Thumb, { "data-slot": "switch-thumb", className: eh({ size: t }), children: [
        /* @__PURE__ */ i(
          qu,
          {
            "aria-hidden": !0,
            className: "block text-ink-inverse group-data-[state=checked]/thumb:hidden"
          }
        ),
        /* @__PURE__ */ i(
          Ju,
          {
            "aria-hidden": !0,
            className: m(
              "hidden group-data-[state=checked]/thumb:block",
              n === !0 ? "text-ink-inverse" : "text-action-primary"
            )
          }
        )
      ] })
    }
  );
}
const va = Nt({});
function th(e) {
  const t = Ee(null);
  return t.current === null && (t.current = e()), t.current;
}
const ti = typeof window < "u", nh = ti ? Tc : Ae, ni = /* @__PURE__ */ Nt(null);
function ri(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function ii(e, t) {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
const Re = (e, t, n) => n > t ? t : n < e ? e : n;
function wr(e, t) {
  return t ? `${e}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${t}` : e;
}
let St = () => {
}, Le = () => {
};
process.env.NODE_ENV !== "production" && (St = (e, t, n) => {
  !e && typeof console < "u" && console.warn(wr(t, n));
}, Le = (e, t, n) => {
  if (!e)
    throw new Error(wr(t, n));
});
const Be = {}, ba = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e);
function xa(e) {
  return typeof e == "object" && e !== null;
}
const wa = (e) => /^0[^.\s]+$/u.test(e);
// @__NO_SIDE_EFFECTS__
function si(e) {
  let t;
  return () => (t === void 0 && (t = e()), t);
}
const xe = /* @__NO_SIDE_EFFECTS__ */ (e) => e, rh = (e, t) => (n) => t(e(n)), qt = (...e) => e.reduce(rh), Ut = /* @__NO_SIDE_EFFECTS__ */ (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
};
class oi {
  constructor() {
    this.subscriptions = [];
  }
  add(t) {
    return ri(this.subscriptions, t), () => ii(this.subscriptions, t);
  }
  notify(t, n, r) {
    const s = this.subscriptions.length;
    if (s)
      if (s === 1)
        this.subscriptions[0](t, n, r);
      else
        for (let a = 0; a < s; a++) {
          const o = this.subscriptions[a];
          o && o(t, n, r);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Te = /* @__NO_SIDE_EFFECTS__ */ (e) => e * 1e3, be = /* @__NO_SIDE_EFFECTS__ */ (e) => e / 1e3;
function ka(e, t) {
  return t ? e * (1e3 / t) : 0;
}
const ms = /* @__PURE__ */ new Set();
function Fn(e, t, n) {
  e || ms.has(t) || (console.warn(wr(t, n)), ms.add(t));
}
const Na = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e, ih = 1e-7, sh = 12;
function oh(e, t, n, r, s) {
  let a, o, l = 0;
  do
    o = t + (n - t) / 2, a = Na(o, r, s) - e, a > 0 ? n = o : t = o;
  while (Math.abs(a) > ih && ++l < sh);
  return o;
}
function Jt(e, t, n, r) {
  if (e === t && n === r)
    return xe;
  const s = (a) => oh(a, 0, 1, e, n);
  return (a) => a === 0 || a === 1 ? a : Na(s(a), t, r);
}
const Sa = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, Ta = (e) => (t) => 1 - e(1 - t), Ca = /* @__PURE__ */ Jt(0.33, 1.53, 0.69, 0.99), ai = /* @__PURE__ */ Ta(Ca), Pa = /* @__PURE__ */ Sa(ai), Ma = (e) => (e *= 2) < 1 ? 0.5 * ai(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1))), li = (e) => 1 - Math.sin(Math.acos(e)), Da = Ta(li), Ia = Sa(li), ah = /* @__PURE__ */ Jt(0.42, 0, 1, 1), lh = /* @__PURE__ */ Jt(0, 0, 0.58, 1), Aa = /* @__PURE__ */ Jt(0.42, 0, 0.58, 1), ch = (e) => Array.isArray(e) && typeof e[0] != "number", Va = (e) => Array.isArray(e) && typeof e[0] == "number", ps = {
  linear: xe,
  easeIn: ah,
  easeInOut: Aa,
  easeOut: lh,
  circIn: li,
  circInOut: Ia,
  circOut: Da,
  backIn: ai,
  backInOut: Pa,
  backOut: Ca,
  anticipate: Ma
}, dh = (e) => typeof e == "string", gs = (e) => {
  if (Va(e)) {
    Le(e.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [t, n, r, s] = e;
    return Jt(t, n, r, s);
  } else if (dh(e))
    return Le(ps[e] !== void 0, `Invalid easing type '${e}'`, "invalid-easing-type"), ps[e];
  return e;
}, bn = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function uh(e, t) {
  let n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), s = !1, a = !1;
  const o = /* @__PURE__ */ new WeakSet();
  let l = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function c(d) {
    o.has(d) && (u.schedule(d), e()), d(l);
  }
  const u = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (d, h = !1, f = !1) => {
      const y = f && s ? n : r;
      return h && o.add(d), y.has(d) || y.add(d), d;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (d) => {
      r.delete(d), o.delete(d);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (d) => {
      if (l = d, s) {
        a = !0;
        return;
      }
      s = !0, [n, r] = [r, n], n.forEach(c), n.clear(), s = !1, a && (a = !1, u.process(d));
    }
  };
  return u;
}
const hh = 40;
function Ea(e, t) {
  let n = !1, r = !0;
  const s = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, a = () => n = !0, o = bn.reduce((k, N) => (k[N] = uh(a), k), {}), { setup: l, read: c, resolveKeyframes: u, preUpdate: d, update: h, preRender: f, render: g, postRender: y } = o, v = () => {
    const k = Be.useManualTiming ? s.timestamp : performance.now();
    n = !1, Be.useManualTiming || (s.delta = r ? 1e3 / 60 : Math.max(Math.min(k - s.timestamp, hh), 1)), s.timestamp = k, s.isProcessing = !0, l.process(s), c.process(s), u.process(s), d.process(s), h.process(s), f.process(s), g.process(s), y.process(s), s.isProcessing = !1, n && t && (r = !1, e(v));
  }, x = () => {
    n = !0, r = !0, s.isProcessing || e(v);
  };
  return { schedule: bn.reduce((k, N) => {
    const T = o[N];
    return k[N] = (M, C = !1, D = !1) => (n || x(), T.schedule(M, C, D)), k;
  }, {}), cancel: (k) => {
    for (let N = 0; N < bn.length; N++)
      o[bn[N]].cancel(k);
  }, state: s, steps: o };
}
const { schedule: q, cancel: Oe, state: ae, steps: Qn } = /* @__PURE__ */ Ea(typeof requestAnimationFrame < "u" ? requestAnimationFrame : xe, !0);
let kn;
function fh() {
  kn = void 0;
}
const pe = {
  now: () => (kn === void 0 && pe.set(ae.isProcessing || Be.useManualTiming ? ae.timestamp : performance.now()), kn),
  set: (e) => {
    kn = e, queueMicrotask(fh);
  }
}, Ra = (e) => (t) => typeof t == "string" && t.startsWith(e), ci = /* @__PURE__ */ Ra("--"), mh = /* @__PURE__ */ Ra("var(--"), di = (e) => mh(e) ? ph.test(e.split("/*")[0].trim()) : !1, ph = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu, Tt = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Wt = {
  ...Tt,
  transform: (e) => Re(0, 1, e)
}, xn = {
  ...Tt,
  default: 1
}, Lt = (e) => Math.round(e * 1e5) / 1e5, ui = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function gh(e) {
  return e == null;
}
const yh = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, hi = (e, t) => (n) => !!(typeof n == "string" && yh.test(n) && n.startsWith(e) || t && !gh(n) && Object.prototype.hasOwnProperty.call(n, t)), La = (e, t, n) => (r) => {
  if (typeof r != "string")
    return r;
  const [s, a, o, l] = r.match(ui);
  return {
    [e]: parseFloat(s),
    [t]: parseFloat(a),
    [n]: parseFloat(o),
    alpha: l !== void 0 ? parseFloat(l) : 1
  };
}, vh = (e) => Re(0, 255, e), er = {
  ...Tt,
  transform: (e) => Math.round(vh(e))
}, Qe = {
  test: /* @__PURE__ */ hi("rgb", "red"),
  parse: /* @__PURE__ */ La("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + er.transform(e) + ", " + er.transform(t) + ", " + er.transform(n) + ", " + Lt(Wt.transform(r)) + ")"
};
function bh(e) {
  let t = "", n = "", r = "", s = "";
  return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), r = e.substring(5, 7), s = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), r = e.substring(3, 4), s = e.substring(4, 5), t += t, n += n, r += r, s += s), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: s ? parseInt(s, 16) / 255 : 1
  };
}
const kr = {
  test: /* @__PURE__ */ hi("#"),
  parse: bh,
  transform: Qe.transform
}, Qt = /* @__NO_SIDE_EFFECTS__ */ (e) => ({
  test: (t) => typeof t == "string" && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), _e = /* @__PURE__ */ Qt("deg"), Ie = /* @__PURE__ */ Qt("%"), V = /* @__PURE__ */ Qt("px"), xh = /* @__PURE__ */ Qt("vh"), wh = /* @__PURE__ */ Qt("vw"), ys = {
  ...Ie,
  parse: (e) => Ie.parse(e) / 100,
  transform: (e) => Ie.transform(e * 100)
}, ht = {
  test: /* @__PURE__ */ hi("hsl", "hue"),
  parse: /* @__PURE__ */ La("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + Ie.transform(Lt(t)) + ", " + Ie.transform(Lt(n)) + ", " + Lt(Wt.transform(r)) + ")"
}, re = {
  test: (e) => Qe.test(e) || kr.test(e) || ht.test(e),
  parse: (e) => Qe.test(e) ? Qe.parse(e) : ht.test(e) ? ht.parse(e) : kr.parse(e),
  transform: (e) => typeof e == "string" ? e : e.hasOwnProperty("red") ? Qe.transform(e) : ht.transform(e),
  getAnimatableNone: (e) => {
    const t = re.parse(e);
    return t.alpha = 0, re.transform(t);
  }
}, kh = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function Nh(e) {
  var t, n;
  return isNaN(e) && typeof e == "string" && (((t = e.match(ui)) == null ? void 0 : t.length) || 0) + (((n = e.match(kh)) == null ? void 0 : n.length) || 0) > 0;
}
const Ba = "number", Fa = "color", Sh = "var", Th = "var(", vs = "${}", Ch = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function Gt(e) {
  const t = e.toString(), n = [], r = {
    color: [],
    number: [],
    var: []
  }, s = [];
  let a = 0;
  const l = t.replace(Ch, (c) => (re.test(c) ? (r.color.push(a), s.push(Fa), n.push(re.parse(c))) : c.startsWith(Th) ? (r.var.push(a), s.push(Sh), n.push(c)) : (r.number.push(a), s.push(Ba), n.push(parseFloat(c))), ++a, vs)).split(vs);
  return { values: n, split: l, indexes: r, types: s };
}
function za(e) {
  return Gt(e).values;
}
function ja(e) {
  const { split: t, types: n } = Gt(e), r = t.length;
  return (s) => {
    let a = "";
    for (let o = 0; o < r; o++)
      if (a += t[o], s[o] !== void 0) {
        const l = n[o];
        l === Ba ? a += Lt(s[o]) : l === Fa ? a += re.transform(s[o]) : a += s[o];
      }
    return a;
  };
}
const Ph = (e) => typeof e == "number" ? 0 : re.test(e) ? re.getAnimatableNone(e) : e;
function Mh(e) {
  const t = za(e);
  return ja(e)(t.map(Ph));
}
const $e = {
  test: Nh,
  parse: za,
  createTransformer: ja,
  getAnimatableNone: Mh
};
function tr(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function Dh({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let s = 0, a = 0, o = 0;
  if (!t)
    s = a = o = n;
  else {
    const l = n < 0.5 ? n * (1 + t) : n + t - n * t, c = 2 * n - l;
    s = tr(c, l, e + 1 / 3), a = tr(c, l, e), o = tr(c, l, e - 1 / 3);
  }
  return {
    red: Math.round(s * 255),
    green: Math.round(a * 255),
    blue: Math.round(o * 255),
    alpha: r
  };
}
function Pn(e, t) {
  return (n) => n > 0 ? t : e;
}
const Q = (e, t, n) => e + (t - e) * n, nr = (e, t, n) => {
  const r = e * e, s = n * (t * t - r) + r;
  return s < 0 ? 0 : Math.sqrt(s);
}, Ih = [kr, Qe, ht], Ah = (e) => Ih.find((t) => t.test(e));
function bs(e) {
  const t = Ah(e);
  if (St(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !t)
    return !1;
  let n = t.parse(e);
  return t === ht && (n = Dh(n)), n;
}
const xs = (e, t) => {
  const n = bs(e), r = bs(t);
  if (!n || !r)
    return Pn(e, t);
  const s = { ...n };
  return (a) => (s.red = nr(n.red, r.red, a), s.green = nr(n.green, r.green, a), s.blue = nr(n.blue, r.blue, a), s.alpha = Q(n.alpha, r.alpha, a), Qe.transform(s));
}, Nr = /* @__PURE__ */ new Set(["none", "hidden"]);
function Vh(e, t) {
  return Nr.has(e) ? (n) => n <= 0 ? e : t : (n) => n >= 1 ? t : e;
}
function Eh(e, t) {
  return (n) => Q(e, t, n);
}
function fi(e) {
  return typeof e == "number" ? Eh : typeof e == "string" ? di(e) ? Pn : re.test(e) ? xs : Bh : Array.isArray(e) ? _a : typeof e == "object" ? re.test(e) ? xs : Rh : Pn;
}
function _a(e, t) {
  const n = [...e], r = n.length, s = e.map((a, o) => fi(a)(a, t[o]));
  return (a) => {
    for (let o = 0; o < r; o++)
      n[o] = s[o](a);
    return n;
  };
}
function Rh(e, t) {
  const n = { ...e, ...t }, r = {};
  for (const s in n)
    e[s] !== void 0 && t[s] !== void 0 && (r[s] = fi(e[s])(e[s], t[s]));
  return (s) => {
    for (const a in r)
      n[a] = r[a](s);
    return n;
  };
}
function Lh(e, t) {
  const n = [], r = { color: 0, var: 0, number: 0 };
  for (let s = 0; s < t.values.length; s++) {
    const a = t.types[s], o = e.indexes[a][r[a]], l = e.values[o] ?? 0;
    n[s] = l, r[a]++;
  }
  return n;
}
const Bh = (e, t) => {
  const n = $e.createTransformer(t), r = Gt(e), s = Gt(t);
  return r.indexes.var.length === s.indexes.var.length && r.indexes.color.length === s.indexes.color.length && r.indexes.number.length >= s.indexes.number.length ? Nr.has(e) && !s.values.length || Nr.has(t) && !r.values.length ? Vh(e, t) : qt(_a(Lh(r, s), s.values), n) : (St(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), Pn(e, t));
};
function Oa(e, t, n) {
  return typeof e == "number" && typeof t == "number" && typeof n == "number" ? Q(e, t, n) : fi(e)(e, t);
}
const Fh = (e) => {
  const t = ({ timestamp: n }) => e(n);
  return {
    start: (n = !0) => q.update(t, n),
    stop: () => Oe(t),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => ae.isProcessing ? ae.timestamp : pe.now()
  };
}, $a = (e, t, n = 10) => {
  let r = "";
  const s = Math.max(Math.round(t / n), 2);
  for (let a = 0; a < s; a++)
    r += Math.round(e(a / (s - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${r.substring(0, r.length - 2)})`;
}, Mn = 2e4;
function mi(e) {
  let t = 0;
  const n = 50;
  let r = e.next(t);
  for (; !r.done && t < Mn; )
    t += n, r = e.next(t);
  return t >= Mn ? 1 / 0 : t;
}
function zh(e, t = 100, n) {
  const r = n({ ...e, keyframes: [0, t] }), s = Math.min(mi(r), Mn);
  return {
    type: "keyframes",
    ease: (a) => r.next(s * a).value / t,
    duration: /* @__PURE__ */ be(s)
  };
}
const jh = 5;
function Ha(e, t, n) {
  const r = Math.max(t - jh, 0);
  return ka(n - e(r), t - r);
}
const J = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
}, rr = 1e-3;
function _h({ duration: e = J.duration, bounce: t = J.bounce, velocity: n = J.velocity, mass: r = J.mass }) {
  let s, a;
  St(e <= /* @__PURE__ */ Te(J.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - t;
  o = Re(J.minDamping, J.maxDamping, o), e = Re(J.minDuration, J.maxDuration, /* @__PURE__ */ be(e)), o < 1 ? (s = (u) => {
    const d = u * o, h = d * e, f = d - n, g = Sr(u, o), y = Math.exp(-h);
    return rr - f / g * y;
  }, a = (u) => {
    const h = u * o * e, f = h * n + n, g = Math.pow(o, 2) * Math.pow(u, 2) * e, y = Math.exp(-h), v = Sr(Math.pow(u, 2), o);
    return (-s(u) + rr > 0 ? -1 : 1) * ((f - g) * y) / v;
  }) : (s = (u) => {
    const d = Math.exp(-u * e), h = (u - n) * e + 1;
    return -rr + d * h;
  }, a = (u) => {
    const d = Math.exp(-u * e), h = (n - u) * (e * e);
    return d * h;
  });
  const l = 5 / e, c = $h(s, a, l);
  if (e = /* @__PURE__ */ Te(e), isNaN(c))
    return {
      stiffness: J.stiffness,
      damping: J.damping,
      duration: e
    };
  {
    const u = Math.pow(c, 2) * r;
    return {
      stiffness: u,
      damping: o * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const Oh = 12;
function $h(e, t, n) {
  let r = n;
  for (let s = 1; s < Oh; s++)
    r = r - e(r) / t(r);
  return r;
}
function Sr(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const Hh = ["duration", "bounce"], Uh = ["stiffness", "damping", "mass"];
function ws(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function Wh(e) {
  let t = {
    velocity: J.velocity,
    stiffness: J.stiffness,
    damping: J.damping,
    mass: J.mass,
    isResolvedFromDuration: !1,
    ...e
  };
  if (!ws(e, Uh) && ws(e, Hh))
    if (e.visualDuration) {
      const n = e.visualDuration, r = 2 * Math.PI / (n * 1.2), s = r * r, a = 2 * Re(0.05, 1, 1 - (e.bounce || 0)) * Math.sqrt(s);
      t = {
        ...t,
        mass: J.mass,
        stiffness: s,
        damping: a
      };
    } else {
      const n = _h(e);
      t = {
        ...t,
        ...n,
        mass: J.mass
      }, t.isResolvedFromDuration = !0;
    }
  return t;
}
function Dn(e = J.visualDuration, t = J.bounce) {
  const n = typeof e != "object" ? {
    visualDuration: e,
    keyframes: [0, 1],
    bounce: t
  } : e;
  let { restSpeed: r, restDelta: s } = n;
  const a = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], l = { done: !1, value: a }, { stiffness: c, damping: u, mass: d, duration: h, velocity: f, isResolvedFromDuration: g } = Wh({
    ...n,
    velocity: -/* @__PURE__ */ be(n.velocity || 0)
  }), y = f || 0, v = u / (2 * Math.sqrt(c * d)), x = o - a, b = /* @__PURE__ */ be(Math.sqrt(c / d)), w = Math.abs(x) < 5;
  r || (r = w ? J.restSpeed.granular : J.restSpeed.default), s || (s = w ? J.restDelta.granular : J.restDelta.default);
  let k;
  if (v < 1) {
    const T = Sr(b, v);
    k = (M) => {
      const C = Math.exp(-v * b * M);
      return o - C * ((y + v * b * x) / T * Math.sin(T * M) + x * Math.cos(T * M));
    };
  } else if (v === 1)
    k = (T) => o - Math.exp(-b * T) * (x + (y + b * x) * T);
  else {
    const T = b * Math.sqrt(v * v - 1);
    k = (M) => {
      const C = Math.exp(-v * b * M), D = Math.min(T * M, 300);
      return o - C * ((y + v * b * x) * Math.sinh(D) + T * x * Math.cosh(D)) / T;
    };
  }
  const N = {
    calculatedDuration: g && h || null,
    next: (T) => {
      const M = k(T);
      if (g)
        l.done = T >= h;
      else {
        let C = T === 0 ? y : 0;
        v < 1 && (C = T === 0 ? /* @__PURE__ */ Te(y) : Ha(k, T, M));
        const D = Math.abs(C) <= r, A = Math.abs(o - M) <= s;
        l.done = D && A;
      }
      return l.value = l.done ? o : M, l;
    },
    toString: () => {
      const T = Math.min(mi(N), Mn), M = $a((C) => N.next(T * C).value, T, 30);
      return T + "ms " + M;
    },
    toTransition: () => {
    }
  };
  return N;
}
Dn.applyToOptions = (e) => {
  const t = zh(e, 100, Dn);
  return e.ease = t.ease, e.duration = /* @__PURE__ */ Te(t.duration), e.type = "keyframes", e;
};
function Tr({ keyframes: e, velocity: t = 0, power: n = 0.8, timeConstant: r = 325, bounceDamping: s = 10, bounceStiffness: a = 500, modifyTarget: o, min: l, max: c, restDelta: u = 0.5, restSpeed: d }) {
  const h = e[0], f = {
    done: !1,
    value: h
  }, g = (D) => l !== void 0 && D < l || c !== void 0 && D > c, y = (D) => l === void 0 ? c : c === void 0 || Math.abs(l - D) < Math.abs(c - D) ? l : c;
  let v = n * t;
  const x = h + v, b = o === void 0 ? x : o(x);
  b !== x && (v = b - h);
  const w = (D) => -v * Math.exp(-D / r), k = (D) => b + w(D), N = (D) => {
    const A = w(D), E = k(D);
    f.done = Math.abs(A) <= u, f.value = f.done ? b : E;
  };
  let T, M;
  const C = (D) => {
    g(f.value) && (T = D, M = Dn({
      keyframes: [f.value, y(f.value)],
      velocity: Ha(k, D, f.value),
      // TODO: This should be passing * 1000
      damping: s,
      stiffness: a,
      restDelta: u,
      restSpeed: d
    }));
  };
  return C(0), {
    calculatedDuration: null,
    next: (D) => {
      let A = !1;
      return !M && T === void 0 && (A = !0, N(D), C(D)), T !== void 0 && D >= T ? M.next(D - T) : (!A && N(D), f);
    }
  };
}
function Gh(e, t, n) {
  const r = [], s = n || Be.mix || Oa, a = e.length - 1;
  for (let o = 0; o < a; o++) {
    let l = s(e[o], e[o + 1]);
    if (t) {
      const c = Array.isArray(t) ? t[o] || xe : t;
      l = qt(c, l);
    }
    r.push(l);
  }
  return r;
}
function Kh(e, t, { clamp: n = !0, ease: r, mixer: s } = {}) {
  const a = e.length;
  if (Le(a === t.length, "Both input and output ranges must be the same length", "range-length"), a === 1)
    return () => t[0];
  if (a === 2 && t[0] === t[1])
    return () => t[1];
  const o = e[0] === e[1];
  e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
  const l = Gh(t, r, s), c = l.length, u = (d) => {
    if (o && d < e[0])
      return t[0];
    let h = 0;
    if (c > 1)
      for (; h < e.length - 2 && !(d < e[h + 1]); h++)
        ;
    const f = /* @__PURE__ */ Ut(e[h], e[h + 1], d);
    return l[h](f);
  };
  return n ? (d) => u(Re(e[0], e[a - 1], d)) : u;
}
function Xh(e, t) {
  const n = e[e.length - 1];
  for (let r = 1; r <= t; r++) {
    const s = /* @__PURE__ */ Ut(0, t, r);
    e.push(Q(n, 1, s));
  }
}
function Yh(e) {
  const t = [0];
  return Xh(t, e.length - 1), t;
}
function Zh(e, t) {
  return e.map((n) => n * t);
}
function qh(e, t) {
  return e.map(() => t || Aa).splice(0, e.length - 1);
}
function ft({ duration: e = 300, keyframes: t, times: n, ease: r = "easeInOut" }) {
  const s = ch(r) ? r.map(gs) : gs(r), a = {
    done: !1,
    value: t[0]
  }, o = Zh(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === t.length ? n : Yh(t),
    e
  ), l = Kh(o, t, {
    ease: Array.isArray(s) ? s : qh(t, s)
  });
  return {
    calculatedDuration: e,
    next: (c) => (a.value = l(c), a.done = c >= e, a)
  };
}
const Jh = (e) => e !== null;
function pi(e, { repeat: t, repeatType: n = "loop" }, r, s = 1) {
  const a = e.filter(Jh), l = s < 0 || t && n !== "loop" && t % 2 === 1 ? 0 : a.length - 1;
  return !l || r === void 0 ? a[l] : r;
}
const Qh = {
  decay: Tr,
  inertia: Tr,
  tween: ft,
  keyframes: ft,
  spring: Dn
};
function Ua(e) {
  typeof e.type == "string" && (e.type = Qh[e.type]);
}
class gi {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((t) => {
      this.resolve = t;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
}
const ef = (e) => e / 100;
class yi extends gi {
  constructor(t) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.stop = () => {
      var r, s;
      const { motionValue: n } = this.options;
      n && n.updatedAt !== pe.now() && this.tick(pe.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), (s = (r = this.options).onStop) == null || s.call(r));
    }, this.options = t, this.initAnimation(), this.play(), t.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: t } = this;
    Ua(t);
    const { type: n = ft, repeat: r = 0, repeatDelay: s = 0, repeatType: a, velocity: o = 0 } = t;
    let { keyframes: l } = t;
    const c = n || ft;
    process.env.NODE_ENV !== "production" && c !== ft && Le(l.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${l}`, "spring-two-frames"), c !== ft && typeof l[0] != "number" && (this.mixKeyframes = qt(ef, Oa(l[0], l[1])), l = [0, 100]);
    const u = c({ ...t, keyframes: l });
    a === "mirror" && (this.mirroredGenerator = c({
      ...t,
      keyframes: [...l].reverse(),
      velocity: -o
    })), u.calculatedDuration === null && (u.calculatedDuration = mi(u));
    const { calculatedDuration: d } = u;
    this.calculatedDuration = d, this.resolvedDuration = d + s, this.totalDuration = this.resolvedDuration * (r + 1) - s, this.generator = u;
  }
  updateTime(t) {
    const n = Math.round(t - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(t, n = !1) {
    const { generator: r, totalDuration: s, mixKeyframes: a, mirroredGenerator: o, resolvedDuration: l, calculatedDuration: c } = this;
    if (this.startTime === null)
      return r.next(0);
    const { delay: u = 0, keyframes: d, repeat: h, repeatType: f, repeatDelay: g, type: y, onUpdate: v, finalKeyframe: x } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, t) : this.speed < 0 && (this.startTime = Math.min(t - s / this.speed, this.startTime)), n ? this.currentTime = t : this.updateTime(t);
    const b = this.currentTime - u * (this.playbackSpeed >= 0 ? 1 : -1), w = this.playbackSpeed >= 0 ? b < 0 : b > s;
    this.currentTime = Math.max(b, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = s);
    let k = this.currentTime, N = r;
    if (h) {
      const D = Math.min(this.currentTime, s) / l;
      let A = Math.floor(D), E = D % 1;
      !E && D >= 1 && (E = 1), E === 1 && A--, A = Math.min(A, h + 1), !!(A % 2) && (f === "reverse" ? (E = 1 - E, g && (E -= g / l)) : f === "mirror" && (N = o)), k = Re(0, 1, E) * l;
    }
    const T = w ? { done: !1, value: d[0] } : N.next(k);
    a && (T.value = a(T.value));
    let { done: M } = T;
    !w && c !== null && (M = this.playbackSpeed >= 0 ? this.currentTime >= s : this.currentTime <= 0);
    const C = this.holdTime === null && (this.state === "finished" || this.state === "running" && M);
    return C && y !== Tr && (T.value = pi(d, this.options, x, this.speed)), v && v(T.value), C && this.finish(), T;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(t, n) {
    return this.finished.then(t, n);
  }
  get duration() {
    return /* @__PURE__ */ be(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ be(t);
  }
  get time() {
    return /* @__PURE__ */ be(this.currentTime);
  }
  set time(t) {
    var n;
    t = /* @__PURE__ */ Te(t), this.currentTime = t, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = t : this.driver && (this.startTime = this.driver.now() - t / this.playbackSpeed), (n = this.driver) == null || n.start(!1);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(t) {
    this.updateTime(pe.now());
    const n = this.playbackSpeed !== t;
    this.playbackSpeed = t, n && (this.time = /* @__PURE__ */ be(this.currentTime));
  }
  play() {
    var s, a;
    if (this.isStopped)
      return;
    const { driver: t = Fh, startTime: n } = this.options;
    this.driver || (this.driver = t((o) => this.tick(o))), (a = (s = this.options).onPlay) == null || a.call(s);
    const r = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = r) : this.holdTime !== null ? this.startTime = r - this.holdTime : this.startTime || (this.startTime = n ?? r), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(pe.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    var t, n;
    this.notifyFinished(), this.teardown(), this.state = "finished", (n = (t = this.options).onComplete) == null || n.call(t);
  }
  cancel() {
    var t, n;
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), (n = (t = this.options).onCancel) == null || n.call(t);
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(t) {
    return this.startTime = 0, this.tick(t, !0);
  }
  attachTimeline(t) {
    var n;
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), (n = this.driver) == null || n.stop(), t.observe(this);
  }
}
function tf(e) {
  for (let t = 1; t < e.length; t++)
    e[t] ?? (e[t] = e[t - 1]);
}
const et = (e) => e * 180 / Math.PI, Cr = (e) => {
  const t = et(Math.atan2(e[1], e[0]));
  return Pr(t);
}, nf = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
  rotate: Cr,
  rotateZ: Cr,
  skewX: (e) => et(Math.atan(e[1])),
  skewY: (e) => et(Math.atan(e[2])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2
}, Pr = (e) => (e = e % 360, e < 0 && (e += 360), e), ks = Cr, Ns = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]), Ss = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]), rf = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: Ns,
  scaleY: Ss,
  scale: (e) => (Ns(e) + Ss(e)) / 2,
  rotateX: (e) => Pr(et(Math.atan2(e[6], e[5]))),
  rotateY: (e) => Pr(et(Math.atan2(-e[2], e[0]))),
  rotateZ: ks,
  rotate: ks,
  skewX: (e) => et(Math.atan(e[4])),
  skewY: (e) => et(Math.atan(e[1])),
  skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2
};
function Mr(e) {
  return e.includes("scale") ? 1 : 0;
}
function Dr(e, t) {
  if (!e || e === "none")
    return Mr(t);
  const n = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let r, s;
  if (n)
    r = rf, s = n;
  else {
    const l = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    r = nf, s = l;
  }
  if (!s)
    return Mr(t);
  const a = r[t], o = s[1].split(",").map(of);
  return typeof a == "function" ? a(o) : o[a];
}
const sf = (e, t) => {
  const { transform: n = "none" } = getComputedStyle(e);
  return Dr(n, t);
};
function of(e) {
  return parseFloat(e.trim());
}
const Ct = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], Pt = new Set(Ct), Ts = (e) => e === Tt || e === V, af = /* @__PURE__ */ new Set(["x", "y", "z"]), lf = Ct.filter((e) => !af.has(e));
function cf(e) {
  const t = [];
  return lf.forEach((n) => {
    const r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t;
}
const rt = {
  // Dimensions
  width: ({ x: e }, { paddingLeft: t = "0", paddingRight: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  height: ({ y: e }, { paddingTop: t = "0", paddingBottom: n = "0" }) => e.max - e.min - parseFloat(t) - parseFloat(n),
  top: (e, { top: t }) => parseFloat(t),
  left: (e, { left: t }) => parseFloat(t),
  bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
  right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
  // Transform
  x: (e, { transform: t }) => Dr(t, "x"),
  y: (e, { transform: t }) => Dr(t, "y")
};
rt.translateX = rt.x;
rt.translateY = rt.y;
const it = /* @__PURE__ */ new Set();
let Ir = !1, Ar = !1, Vr = !1;
function Wa() {
  if (Ar) {
    const e = Array.from(it).filter((r) => r.needsMeasurement), t = new Set(e.map((r) => r.element)), n = /* @__PURE__ */ new Map();
    t.forEach((r) => {
      const s = cf(r);
      s.length && (n.set(r, s), r.render());
    }), e.forEach((r) => r.measureInitialState()), t.forEach((r) => {
      r.render();
      const s = n.get(r);
      s && s.forEach(([a, o]) => {
        var l;
        (l = r.getValue(a)) == null || l.set(o);
      });
    }), e.forEach((r) => r.measureEndState()), e.forEach((r) => {
      r.suspendedScrollY !== void 0 && window.scrollTo(0, r.suspendedScrollY);
    });
  }
  Ar = !1, Ir = !1, it.forEach((e) => e.complete(Vr)), it.clear();
}
function Ga() {
  it.forEach((e) => {
    e.readKeyframes(), e.needsMeasurement && (Ar = !0);
  });
}
function df() {
  Vr = !0, Ga(), Wa(), Vr = !1;
}
class vi {
  constructor(t, n, r, s, a, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...t], this.onComplete = n, this.name = r, this.motionValue = s, this.element = a, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (it.add(this), Ir || (Ir = !0, q.read(Ga), q.resolveKeyframes(Wa))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, name: n, element: r, motionValue: s } = this;
    if (t[0] === null) {
      const a = s == null ? void 0 : s.get(), o = t[t.length - 1];
      if (a !== void 0)
        t[0] = a;
      else if (r && n) {
        const l = r.readValue(n, o);
        l != null && (t[0] = l);
      }
      t[0] === void 0 && (t[0] = o), s && a === void 0 && s.set(t[0]);
    }
    tf(t);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(t = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, t), it.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (it.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const uf = (e) => e.startsWith("--");
function hf(e, t, n) {
  uf(t) ? e.style.setProperty(t, n) : e.style[t] = n;
}
const ff = /* @__PURE__ */ si(() => window.ScrollTimeline !== void 0), mf = {};
function pf(e, t) {
  const n = /* @__PURE__ */ si(e);
  return () => mf[t] ?? n();
}
const Ka = /* @__PURE__ */ pf(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), At = ([e, t, n, r]) => `cubic-bezier(${e}, ${t}, ${n}, ${r})`, Cs = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ At([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ At([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ At([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ At([0.33, 1.53, 0.69, 0.99])
};
function Xa(e, t) {
  if (e)
    return typeof e == "function" ? Ka() ? $a(e, t) : "ease-out" : Va(e) ? At(e) : Array.isArray(e) ? e.map((n) => Xa(n, t) || Cs.easeOut) : Cs[e];
}
function gf(e, t, n, { delay: r = 0, duration: s = 300, repeat: a = 0, repeatType: o = "loop", ease: l = "easeOut", times: c } = {}, u = void 0) {
  const d = {
    [t]: n
  };
  c && (d.offset = c);
  const h = Xa(l, s);
  Array.isArray(h) && (d.easing = h);
  const f = {
    delay: r,
    duration: s,
    easing: Array.isArray(h) ? "linear" : h,
    fill: "both",
    iterations: a + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return u && (f.pseudoElement = u), e.animate(d, f);
}
function Ya(e) {
  return typeof e == "function" && "applyToOptions" in e;
}
function yf({ type: e, ...t }) {
  return Ya(e) && Ka() ? e.applyToOptions(t) : (t.duration ?? (t.duration = 300), t.ease ?? (t.ease = "easeOut"), t);
}
class vf extends gi {
  constructor(t) {
    if (super(), this.finishedTime = null, this.isStopped = !1, !t)
      return;
    const { element: n, name: r, keyframes: s, pseudoElement: a, allowFlatten: o = !1, finalKeyframe: l, onComplete: c } = t;
    this.isPseudoElement = !!a, this.allowFlatten = o, this.options = t, Le(typeof t.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const u = yf(t);
    this.animation = gf(n, r, s, u, a), u.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !a) {
        const d = pi(s, this.options, l, this.speed);
        this.updateMotionValue ? this.updateMotionValue(d) : hf(n, r, d), this.animation.cancel();
      }
      c == null || c(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    var t, n;
    (n = (t = this.animation).finish) == null || n.call(t);
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: t } = this;
    t === "idle" || t === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    var t, n;
    this.isPseudoElement || (n = (t = this.animation).commitStyles) == null || n.call(t);
  }
  get duration() {
    var n, r;
    const t = ((r = (n = this.animation.effect) == null ? void 0 : n.getComputedTiming) == null ? void 0 : r.call(n).duration) || 0;
    return /* @__PURE__ */ be(Number(t));
  }
  get iterationDuration() {
    const { delay: t = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ be(t);
  }
  get time() {
    return /* @__PURE__ */ be(Number(this.animation.currentTime) || 0);
  }
  set time(t) {
    this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Te(t);
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(t) {
    t < 0 && (this.finishedTime = null), this.animation.playbackRate = t;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return Number(this.animation.startTime);
  }
  set startTime(t) {
    this.animation.startTime = t;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: t, observe: n }) {
    var r;
    return this.allowFlatten && ((r = this.animation.effect) == null || r.updateTiming({ easing: "linear" })), this.animation.onfinish = null, t && ff() ? (this.animation.timeline = t, xe) : n(this);
  }
}
const Za = {
  anticipate: Ma,
  backInOut: Pa,
  circInOut: Ia
};
function bf(e) {
  return e in Za;
}
function xf(e) {
  typeof e.ease == "string" && bf(e.ease) && (e.ease = Za[e.ease]);
}
const Ps = 10;
class wf extends vf {
  constructor(t) {
    xf(t), Ua(t), super(t), t.startTime && (this.startTime = t.startTime), this.options = t;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read commited styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(t) {
    const { motionValue: n, onUpdate: r, onComplete: s, element: a, ...o } = this.options;
    if (!n)
      return;
    if (t !== void 0) {
      n.set(t);
      return;
    }
    const l = new yi({
      ...o,
      autoplay: !1
    }), c = /* @__PURE__ */ Te(this.finishedTime ?? this.time);
    n.setWithVelocity(l.sample(c - Ps).value, l.sample(c).value, Ps), l.stop();
  }
}
const Ms = (e, t) => t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
($e.test(e) || e === "0") && // And it contains numbers and/or colors
!e.startsWith("url("));
function kf(e) {
  const t = e[0];
  if (e.length === 1)
    return !0;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t)
      return !0;
}
function Nf(e, t, n, r) {
  const s = e[0];
  if (s === null)
    return !1;
  if (t === "display" || t === "visibility")
    return !0;
  const a = e[e.length - 1], o = Ms(s, t), l = Ms(a, t);
  return St(o === l, `You are trying to animate ${t} from "${s}" to "${a}". "${o ? a : s}" is not an animatable value.`, "value-not-animatable"), !o || !l ? !1 : kf(e) || (n === "spring" || Ya(n)) && r;
}
function Er(e) {
  e.duration = 0, e.type = "keyframes";
}
const Sf = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform"
  // TODO: Could be re-enabled now we have support for linear() easing
  // "background-color"
]), Tf = /* @__PURE__ */ si(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function Cf(e) {
  var d;
  const { motionValue: t, name: n, repeatDelay: r, repeatType: s, damping: a, type: o } = e;
  if (!(((d = t == null ? void 0 : t.owner) == null ? void 0 : d.current) instanceof HTMLElement))
    return !1;
  const { onUpdate: c, transformTemplate: u } = t.owner.getProps();
  return Tf() && n && Sf.has(n) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !r && s !== "mirror" && a !== 0 && o !== "inertia";
}
const Pf = 40;
class Mf extends gi {
  constructor({ autoplay: t = !0, delay: n = 0, type: r = "keyframes", repeat: s = 0, repeatDelay: a = 0, repeatType: o = "loop", keyframes: l, name: c, motionValue: u, element: d, ...h }) {
    var y;
    super(), this.stop = () => {
      var v, x;
      this._animation && (this._animation.stop(), (v = this.stopTimeline) == null || v.call(this)), (x = this.keyframeResolver) == null || x.cancel();
    }, this.createdAt = pe.now();
    const f = {
      autoplay: t,
      delay: n,
      type: r,
      repeat: s,
      repeatDelay: a,
      repeatType: o,
      name: c,
      motionValue: u,
      element: d,
      ...h
    }, g = (d == null ? void 0 : d.KeyframeResolver) || vi;
    this.keyframeResolver = new g(l, (v, x, b) => this.onKeyframesResolved(v, x, f, !b), c, u, d), (y = this.keyframeResolver) == null || y.scheduleResolve();
  }
  onKeyframesResolved(t, n, r, s) {
    this.keyframeResolver = void 0;
    const { name: a, type: o, velocity: l, delay: c, isHandoff: u, onUpdate: d } = r;
    this.resolvedAt = pe.now(), Nf(t, a, o, l) || ((Be.instantAnimations || !c) && (d == null || d(pi(t, r, n))), t[0] = t[t.length - 1], Er(r), r.repeat = 0);
    const f = {
      startTime: s ? this.resolvedAt ? this.resolvedAt - this.createdAt > Pf ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...r,
      keyframes: t
    }, g = !u && Cf(f) ? new wf({
      ...f,
      element: f.motionValue.owner.current
    }) : new yi(f);
    g.finished.then(() => this.notifyFinished()).catch(xe), this.pendingTimeline && (this.stopTimeline = g.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = g;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(t, n) {
    return this.finished.finally(t).then(() => {
    });
  }
  get animation() {
    var t;
    return this._animation || ((t = this.keyframeResolver) == null || t.resume(), df()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(t) {
    this.animation.time = t;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(t) {
    this.animation.speed = t;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(t) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(t) : this.pendingTimeline = t, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    var t;
    this._animation && this.animation.cancel(), (t = this.keyframeResolver) == null || t.cancel();
  }
}
const Df = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function If(e) {
  const t = Df.exec(e);
  if (!t)
    return [,];
  const [, n, r, s] = t;
  return [`--${n ?? r}`, s];
}
const Af = 4;
function qa(e, t, n = 1) {
  Le(n <= Af, `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [r, s] = If(e);
  if (!r)
    return;
  const a = window.getComputedStyle(t).getPropertyValue(r);
  if (a) {
    const o = a.trim();
    return ba(o) ? parseFloat(o) : o;
  }
  return di(s) ? qa(s, t, n + 1) : s;
}
function bi(e, t) {
  return (e == null ? void 0 : e[t]) ?? (e == null ? void 0 : e.default) ?? e;
}
const Ja = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...Ct
]), Vf = {
  test: (e) => e === "auto",
  parse: (e) => e
}, Qa = (e) => (t) => t.test(e), el = [Tt, V, Ie, _e, wh, xh, Vf], Ds = (e) => el.find(Qa(e));
function Ef(e) {
  return typeof e == "number" ? e === 0 : e !== null ? e === "none" || e === "0" || wa(e) : !0;
}
const Rf = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Lf(e) {
  const [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(ui) || [];
  if (!r)
    return e;
  const s = n.replace(r, "");
  let a = Rf.has(t) ? 1 : 0;
  return r !== n && (a *= 100), t + "(" + a + s + ")";
}
const Bf = /\b([a-z-]*)\(.*?\)/gu, Rr = {
  ...$e,
  getAnimatableNone: (e) => {
    const t = e.match(Bf);
    return t ? t.map(Lf).join(" ") : e;
  }
}, Is = {
  ...Tt,
  transform: Math.round
}, Ff = {
  rotate: _e,
  rotateX: _e,
  rotateY: _e,
  rotateZ: _e,
  scale: xn,
  scaleX: xn,
  scaleY: xn,
  scaleZ: xn,
  skew: _e,
  skewX: _e,
  skewY: _e,
  distance: V,
  translateX: V,
  translateY: V,
  translateZ: V,
  x: V,
  y: V,
  z: V,
  perspective: V,
  transformPerspective: V,
  opacity: Wt,
  originX: ys,
  originY: ys,
  originZ: V
}, xi = {
  // Border props
  borderWidth: V,
  borderTopWidth: V,
  borderRightWidth: V,
  borderBottomWidth: V,
  borderLeftWidth: V,
  borderRadius: V,
  radius: V,
  borderTopLeftRadius: V,
  borderTopRightRadius: V,
  borderBottomRightRadius: V,
  borderBottomLeftRadius: V,
  // Positioning props
  width: V,
  maxWidth: V,
  height: V,
  maxHeight: V,
  top: V,
  right: V,
  bottom: V,
  left: V,
  // Spacing props
  padding: V,
  paddingTop: V,
  paddingRight: V,
  paddingBottom: V,
  paddingLeft: V,
  margin: V,
  marginTop: V,
  marginRight: V,
  marginBottom: V,
  marginLeft: V,
  // Misc
  backgroundPositionX: V,
  backgroundPositionY: V,
  ...Ff,
  zIndex: Is,
  // SVG
  fillOpacity: Wt,
  strokeOpacity: Wt,
  numOctaves: Is
}, zf = {
  ...xi,
  // Color props
  color: re,
  backgroundColor: re,
  outlineColor: re,
  fill: re,
  stroke: re,
  // Border props
  borderColor: re,
  borderTopColor: re,
  borderRightColor: re,
  borderBottomColor: re,
  borderLeftColor: re,
  filter: Rr,
  WebkitFilter: Rr
}, tl = (e) => zf[e];
function nl(e, t) {
  let n = tl(e);
  return n !== Rr && (n = $e), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0;
}
const jf = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function _f(e, t, n) {
  let r = 0, s;
  for (; r < e.length && !s; ) {
    const a = e[r];
    typeof a == "string" && !jf.has(a) && Gt(a).values.length && (s = e[r]), r++;
  }
  if (s && n)
    for (const a of t)
      e[a] = nl(n, s);
}
class Of extends vi {
  constructor(t, n, r, s, a) {
    super(t, n, r, s, a, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: t, element: n, name: r } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let c = 0; c < t.length; c++) {
      let u = t[c];
      if (typeof u == "string" && (u = u.trim(), di(u))) {
        const d = qa(u, n.current);
        d !== void 0 && (t[c] = d), c === t.length - 1 && (this.finalKeyframe = u);
      }
    }
    if (this.resolveNoneKeyframes(), !Ja.has(r) || t.length !== 2)
      return;
    const [s, a] = t, o = Ds(s), l = Ds(a);
    if (o !== l)
      if (Ts(o) && Ts(l))
        for (let c = 0; c < t.length; c++) {
          const u = t[c];
          typeof u == "string" && (t[c] = parseFloat(u));
        }
      else rt[r] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: t, name: n } = this, r = [];
    for (let s = 0; s < t.length; s++)
      (t[s] === null || Ef(t[s])) && r.push(s);
    r.length && _f(t, r, n);
  }
  measureInitialState() {
    const { element: t, unresolvedKeyframes: n, name: r } = this;
    if (!t || !t.current)
      return;
    r === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = rt[r](t.measureViewportBox(), window.getComputedStyle(t.current)), n[0] = this.measuredOrigin;
    const s = n[n.length - 1];
    s !== void 0 && t.getValue(r, s).jump(s, !1);
  }
  measureEndState() {
    var l;
    const { element: t, name: n, unresolvedKeyframes: r } = this;
    if (!t || !t.current)
      return;
    const s = t.getValue(n);
    s && s.jump(this.measuredOrigin, !1);
    const a = r.length - 1, o = r[a];
    r[a] = rt[n](t.measureViewportBox(), window.getComputedStyle(t.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), (l = this.removedTransforms) != null && l.length && this.removedTransforms.forEach(([c, u]) => {
      t.getValue(c).set(u);
    }), this.resolveNoneKeyframes();
  }
}
function $f(e, t, n) {
  if (e instanceof EventTarget)
    return [e];
  if (typeof e == "string") {
    let r = document;
    const s = (n == null ? void 0 : n[e]) ?? r.querySelectorAll(e);
    return s ? Array.from(s) : [];
  }
  return Array.from(e);
}
const rl = (e, t) => t && typeof e == "number" ? t.transform(e) : e;
function Hf(e) {
  return xa(e) && "offsetHeight" in e;
}
const As = 30, Uf = (e) => !isNaN(parseFloat(e));
class Wf {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(t, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (r) => {
      var a;
      const s = pe.now();
      if (this.updatedAt !== s && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(r), this.current !== this.prev && ((a = this.events.change) == null || a.notify(this.current), this.dependents))
        for (const o of this.dependents)
          o.dirty();
    }, this.hasAnimated = !1, this.setCurrent(t), this.owner = n.owner;
  }
  setCurrent(t) {
    this.current = t, this.updatedAt = pe.now(), this.canTrackVelocity === null && t !== void 0 && (this.canTrackVelocity = Uf(this.current));
  }
  setPrevFrameValue(t = this.current) {
    this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(t) {
    return process.env.NODE_ENV !== "production" && Fn(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", t);
  }
  on(t, n) {
    this.events[t] || (this.events[t] = new oi());
    const r = this.events[t].add(n);
    return t === "change" ? () => {
      r(), q.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : r;
  }
  clearListeners() {
    for (const t in this.events)
      this.events[t].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(t, n) {
    this.passiveEffect = t, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(t) {
    this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
  }
  setWithVelocity(t, n, r) {
    this.set(n), this.prev = void 0, this.prevFrameValue = t, this.prevUpdatedAt = this.updatedAt - r;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(t, n = !0) {
    this.updateAndNotify(t), this.prev = t, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    var t;
    (t = this.events.change) == null || t.notify(this.current);
  }
  addDependent(t) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(t);
  }
  removeDependent(t) {
    this.dependents && this.dependents.delete(t);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const t = pe.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || t - this.updatedAt > As)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, As);
    return ka(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(t) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = t(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    var t, n;
    (t = this.dependents) == null || t.clear(), (n = this.events.destroy) == null || n.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function wt(e, t) {
  return new Wf(e, t);
}
const { schedule: wi } = /* @__PURE__ */ Ea(queueMicrotask, !1), Se = {
  x: !1,
  y: !1
};
function il() {
  return Se.x || Se.y;
}
function Gf(e) {
  return e === "x" || e === "y" ? Se[e] ? null : (Se[e] = !0, () => {
    Se[e] = !1;
  }) : Se.x || Se.y ? null : (Se.x = Se.y = !0, () => {
    Se.x = Se.y = !1;
  });
}
function sl(e, t) {
  const n = $f(e), r = new AbortController(), s = {
    passive: !0,
    ...t,
    signal: r.signal
  };
  return [n, s, () => r.abort()];
}
function Vs(e) {
  return !(e.pointerType === "touch" || il());
}
function Kf(e, t, n = {}) {
  const [r, s, a] = sl(e, n), o = (l) => {
    if (!Vs(l))
      return;
    const { target: c } = l, u = t(c, l);
    if (typeof u != "function" || !c)
      return;
    const d = (h) => {
      Vs(h) && (u(h), c.removeEventListener("pointerleave", d));
    };
    c.addEventListener("pointerleave", d, s);
  };
  return r.forEach((l) => {
    l.addEventListener("pointerenter", o, s);
  }), a;
}
const ol = (e, t) => t ? e === t ? !0 : ol(e, t.parentElement) : !1, ki = (e) => e.pointerType === "mouse" ? typeof e.button != "number" || e.button <= 0 : e.isPrimary !== !1, Xf = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function Yf(e) {
  return Xf.has(e.tagName) || e.tabIndex !== -1;
}
const Nn = /* @__PURE__ */ new WeakSet();
function Es(e) {
  return (t) => {
    t.key === "Enter" && e(t);
  };
}
function ir(e, t) {
  e.dispatchEvent(new PointerEvent("pointer" + t, { isPrimary: !0, bubbles: !0 }));
}
const Zf = (e, t) => {
  const n = e.currentTarget;
  if (!n)
    return;
  const r = Es(() => {
    if (Nn.has(n))
      return;
    ir(n, "down");
    const s = Es(() => {
      ir(n, "up");
    }), a = () => ir(n, "cancel");
    n.addEventListener("keyup", s, t), n.addEventListener("blur", a, t);
  });
  n.addEventListener("keydown", r, t), n.addEventListener("blur", () => n.removeEventListener("keydown", r), t);
};
function Rs(e) {
  return ki(e) && !il();
}
function qf(e, t, n = {}) {
  const [r, s, a] = sl(e, n), o = (l) => {
    const c = l.currentTarget;
    if (!Rs(l))
      return;
    Nn.add(c);
    const u = t(c, l), d = (g, y) => {
      window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", f), Nn.has(c) && Nn.delete(c), Rs(g) && typeof u == "function" && u(g, { success: y });
    }, h = (g) => {
      d(g, c === window || c === document || n.useGlobalTarget || ol(c, g.target));
    }, f = (g) => {
      d(g, !1);
    };
    window.addEventListener("pointerup", h, s), window.addEventListener("pointercancel", f, s);
  };
  return r.forEach((l) => {
    (n.useGlobalTarget ? window : l).addEventListener("pointerdown", o, s), Hf(l) && (l.addEventListener("focus", (u) => Zf(u, s)), !Yf(l) && !l.hasAttribute("tabindex") && (l.tabIndex = 0));
  }), a;
}
function al(e) {
  return xa(e) && "ownerSVGElement" in e;
}
function Jf(e) {
  return al(e) && e.tagName === "svg";
}
const le = (e) => !!(e && e.getVelocity), Qf = [...el, re, $e], em = (e) => Qf.find(Qa(e)), ll = Nt({
  transformPagePoint: (e) => e,
  isStatic: !1,
  reducedMotion: "never"
});
function tm(e = !0) {
  const t = me(ni);
  if (t === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: r, register: s } = t, a = $r();
  Ae(() => {
    if (e)
      return s(a);
  }, [e]);
  const o = De(() => e && r && r(a), [a, r, e]);
  return !n && r ? [!1, o] : [!0];
}
const cl = Nt({ strict: !1 }), Ls = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
}, kt = {};
for (const e in Ls)
  kt[e] = {
    isEnabled: (t) => Ls[e].some((n) => !!t[n])
  };
function nm(e) {
  for (const t in e)
    kt[t] = {
      ...kt[t],
      ...e[t]
    };
}
const rm = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport"
]);
function In(e) {
  return e.startsWith("while") || e.startsWith("drag") && e !== "draggable" || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || rm.has(e);
}
let dl = (e) => !In(e);
function im(e) {
  typeof e == "function" && (dl = (t) => t.startsWith("on") ? !In(t) : e(t));
}
try {
  im(require("@emotion/is-prop-valid").default);
} catch {
}
function sm(e, t, n) {
  const r = {};
  for (const s in e)
    s === "values" && typeof e.values == "object" || (dl(s) || n === !0 && In(s) || !t && !In(s) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && s.startsWith("onDrag")) && (r[s] = e[s]);
  return r;
}
const zn = /* @__PURE__ */ Nt({});
function jn(e) {
  return e !== null && typeof e == "object" && typeof e.start == "function";
}
function Kt(e) {
  return typeof e == "string" || Array.isArray(e);
}
const Ni = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], Si = ["initial", ...Ni];
function _n(e) {
  return jn(e.animate) || Si.some((t) => Kt(e[t]));
}
function ul(e) {
  return !!(_n(e) || e.variants);
}
function om(e, t) {
  if (_n(e)) {
    const { initial: n, animate: r } = e;
    return {
      initial: n === !1 || Kt(n) ? n : void 0,
      animate: Kt(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function am(e) {
  const { initial: t, animate: n } = om(e, me(zn));
  return Zt(() => ({ initial: t, animate: n }), [Bs(t), Bs(n)]);
}
function Bs(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
const Xt = {};
function lm(e) {
  for (const t in e)
    Xt[t] = e[t], ci(t) && (Xt[t].isCSSVariable = !0);
}
function hl(e, { layout: t, layoutId: n }) {
  return Pt.has(e) || e.startsWith("origin") || (t || n !== void 0) && (!!Xt[e] || e === "opacity");
}
const cm = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, dm = Ct.length;
function um(e, t, n) {
  let r = "", s = !0;
  for (let a = 0; a < dm; a++) {
    const o = Ct[a], l = e[o];
    if (l === void 0)
      continue;
    let c = !0;
    if (typeof l == "number" ? c = l === (o.startsWith("scale") ? 1 : 0) : c = parseFloat(l) === 0, !c || n) {
      const u = rl(l, xi[o]);
      if (!c) {
        s = !1;
        const d = cm[o] || o;
        r += `${d}(${u}) `;
      }
      n && (t[o] = u);
    }
  }
  return r = r.trim(), n ? r = n(t, s ? "" : r) : s && (r = "none"), r;
}
function Ti(e, t, n) {
  const { style: r, vars: s, transformOrigin: a } = e;
  let o = !1, l = !1;
  for (const c in t) {
    const u = t[c];
    if (Pt.has(c)) {
      o = !0;
      continue;
    } else if (ci(c)) {
      s[c] = u;
      continue;
    } else {
      const d = rl(u, xi[c]);
      c.startsWith("origin") ? (l = !0, a[c] = d) : r[c] = d;
    }
  }
  if (t.transform || (o || n ? r.transform = um(t, e.transform, n) : r.transform && (r.transform = "none")), l) {
    const { originX: c = "50%", originY: u = "50%", originZ: d = 0 } = a;
    r.transformOrigin = `${c} ${u} ${d}`;
  }
}
const Ci = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function fl(e, t, n) {
  for (const r in t)
    !le(t[r]) && !hl(r, n) && (e[r] = t[r]);
}
function hm({ transformTemplate: e }, t) {
  return Zt(() => {
    const n = Ci();
    return Ti(n, t, e), Object.assign({}, n.vars, n.style);
  }, [t]);
}
function fm(e, t) {
  const n = e.style || {}, r = {};
  return fl(r, n, e), Object.assign(r, hm(e, t)), r;
}
function mm(e, t) {
  const n = {}, r = fm(e, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, r.userSelect = r.WebkitUserSelect = r.WebkitTouchCallout = "none", r.touchAction = e.drag === !0 ? "none" : `pan-${e.drag === "x" ? "y" : "x"}`), e.tabIndex === void 0 && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = r, n;
}
const pm = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, gm = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function ym(e, t, n = 1, r = 0, s = !0) {
  e.pathLength = 1;
  const a = s ? pm : gm;
  e[a.offset] = V.transform(-r);
  const o = V.transform(t), l = V.transform(n);
  e[a.array] = `${o} ${l}`;
}
function ml(e, {
  attrX: t,
  attrY: n,
  attrScale: r,
  pathLength: s,
  pathSpacing: a = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...l
}, c, u, d) {
  if (Ti(e, l, u), c) {
    e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
    return;
  }
  e.attrs = e.style, e.style = {};
  const { attrs: h, style: f } = e;
  h.transform && (f.transform = h.transform, delete h.transform), (f.transform || h.transformOrigin) && (f.transformOrigin = h.transformOrigin ?? "50% 50%", delete h.transformOrigin), f.transform && (f.transformBox = (d == null ? void 0 : d.transformBox) ?? "fill-box", delete h.transformBox), t !== void 0 && (h.x = t), n !== void 0 && (h.y = n), r !== void 0 && (h.scale = r), s !== void 0 && ym(h, s, a, o, !1);
}
const pl = () => ({
  ...Ci(),
  attrs: {}
}), gl = (e) => typeof e == "string" && e.toLowerCase() === "svg";
function vm(e, t, n, r) {
  const s = Zt(() => {
    const a = pl();
    return ml(a, t, gl(r), e.transformTemplate, e.style), {
      ...a.attrs,
      style: { ...a.style }
    };
  }, [t]);
  if (e.style) {
    const a = {};
    fl(a, e.style, e), s.style = { ...a, ...s.style };
  }
  return s;
}
const bm = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Pi(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(bm.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(e))
    )
  );
}
function xm(e, t, n, { latestValues: r }, s, a = !1) {
  const l = (Pi(e) ? vm : mm)(t, r, s, e), c = sm(t, typeof e == "string", a), u = e !== Bo ? { ...c, ...l, ref: n } : {}, { children: d } = t, h = Zt(() => le(d) ? d.get() : d, [d]);
  return Cc(e, {
    ...u,
    children: h
  });
}
function Fs(e) {
  const t = [{}, {}];
  return e == null || e.values.forEach((n, r) => {
    t[0][r] = n.get(), t[1][r] = n.getVelocity();
  }), t;
}
function Mi(e, t, n, r) {
  if (typeof t == "function") {
    const [s, a] = Fs(r);
    t = t(n !== void 0 ? n : e.custom, s, a);
  }
  if (typeof t == "string" && (t = e.variants && e.variants[t]), typeof t == "function") {
    const [s, a] = Fs(r);
    t = t(n !== void 0 ? n : e.custom, s, a);
  }
  return t;
}
function Sn(e) {
  return le(e) ? e.get() : e;
}
function wm({ scrapeMotionValuesFromProps: e, createRenderState: t }, n, r, s) {
  return {
    latestValues: km(n, r, s, e),
    renderState: t()
  };
}
function km(e, t, n, r) {
  const s = {}, a = r(e, {});
  for (const f in a)
    s[f] = Sn(a[f]);
  let { initial: o, animate: l } = e;
  const c = _n(e), u = ul(e);
  t && u && !c && e.inherit !== !1 && (o === void 0 && (o = t.initial), l === void 0 && (l = t.animate));
  let d = n ? n.initial === !1 : !1;
  d = d || o === !1;
  const h = d ? l : o;
  if (h && typeof h != "boolean" && !jn(h)) {
    const f = Array.isArray(h) ? h : [h];
    for (let g = 0; g < f.length; g++) {
      const y = Mi(e, f[g]);
      if (y) {
        const { transitionEnd: v, transition: x, ...b } = y;
        for (const w in b) {
          let k = b[w];
          if (Array.isArray(k)) {
            const N = d ? k.length - 1 : 0;
            k = k[N];
          }
          k !== null && (s[w] = k);
        }
        for (const w in v)
          s[w] = v[w];
      }
    }
  }
  return s;
}
const yl = (e) => (t, n) => {
  const r = me(zn), s = me(ni), a = () => wm(e, t, r, s);
  return n ? a() : th(a);
};
function Di(e, t, n) {
  var a;
  const { style: r } = e, s = {};
  for (const o in r)
    (le(r[o]) || t.style && le(t.style[o]) || hl(o, e) || ((a = n == null ? void 0 : n.getValue(o)) == null ? void 0 : a.liveStyle) !== void 0) && (s[o] = r[o]);
  return s;
}
const Nm = /* @__PURE__ */ yl({
  scrapeMotionValuesFromProps: Di,
  createRenderState: Ci
});
function vl(e, t, n) {
  const r = Di(e, t, n);
  for (const s in e)
    if (le(e[s]) || le(t[s])) {
      const a = Ct.indexOf(s) !== -1 ? "attr" + s.charAt(0).toUpperCase() + s.substring(1) : s;
      r[a] = e[s];
    }
  return r;
}
const Sm = /* @__PURE__ */ yl({
  scrapeMotionValuesFromProps: vl,
  createRenderState: pl
}), Tm = Symbol.for("motionComponentSymbol");
function mt(e) {
  return e && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function Cm(e, t, n) {
  return De(
    (r) => {
      r && e.onMount && e.onMount(r), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : mt(n) && (n.current = r));
    },
    /**
     * Include externalRef in dependencies to ensure the callback updates
     * when the ref changes, allowing proper ref forwarding.
     */
    [t]
  );
}
const Ii = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(), Pm = "framerAppearId", bl = "data-" + Ii(Pm), xl = Nt({});
function Mm(e, t, n, r, s) {
  var v, x;
  const { visualElement: a } = me(zn), o = me(cl), l = me(ni), c = me(ll).reducedMotion, u = Ee(null);
  r = r || o.renderer, !u.current && r && (u.current = r(e, {
    visualState: t,
    parent: a,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: c
  }));
  const d = u.current, h = me(xl);
  d && !d.projection && s && (d.type === "html" || d.type === "svg") && Dm(u.current, n, s, h);
  const f = Ee(!1);
  Pc(() => {
    d && f.current && d.update(n, l);
  });
  const g = n[bl], y = Ee(!!g && !((v = window.MotionHandoffIsComplete) != null && v.call(window, g)) && ((x = window.MotionHasOptimisedAnimation) == null ? void 0 : x.call(window, g)));
  return nh(() => {
    d && (f.current = !0, window.MotionIsMounted = !0, d.updateFeatures(), d.scheduleRenderMicrotask(), y.current && d.animationState && d.animationState.animateChanges());
  }), Ae(() => {
    d && (!y.current && d.animationState && d.animationState.animateChanges(), y.current && (queueMicrotask(() => {
      var b;
      (b = window.MotionHandoffMarkAsComplete) == null || b.call(window, g);
    }), y.current = !1), d.enteringChildren = void 0);
  }), d;
}
function Dm(e, t, n, r) {
  const { layoutId: s, layout: a, drag: o, dragConstraints: l, layoutScroll: c, layoutRoot: u, layoutCrossfade: d } = t;
  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : wl(e.parent)), e.projection.setOptions({
    layoutId: s,
    layout: a,
    alwaysMeasureLayout: !!o || l && mt(l),
    visualElement: e,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: r,
    crossfade: d,
    layoutScroll: c,
    layoutRoot: u
  });
}
function wl(e) {
  if (e)
    return e.options.allowProjection !== !1 ? e.projection : wl(e.parent);
}
function sr(e, { forwardMotionProps: t = !1 } = {}, n, r) {
  n && nm(n);
  const s = Pi(e) ? Sm : Nm;
  function a(l, c) {
    let u;
    const d = {
      ...me(ll),
      ...l,
      layoutId: Im(l)
    }, { isStatic: h } = d, f = am(l), g = s(l, h);
    if (!h && ti) {
      Am(d, n);
      const y = Vm(d);
      u = y.MeasureLayout, f.visualElement = Mm(e, g, d, r, y.ProjectionNode);
    }
    return p(zn.Provider, { value: f, children: [u && f.visualElement ? i(u, { visualElement: f.visualElement, ...d }) : null, xm(e, l, Cm(g, f.visualElement, c), g, h, t)] });
  }
  a.displayName = `motion.${typeof e == "string" ? e : `create(${e.displayName ?? e.name ?? ""})`}`;
  const o = Mc(a);
  return o[Tm] = e, o;
}
function Im({ layoutId: e }) {
  const t = me(va).id;
  return t && e !== void 0 ? t + "-" + e : e;
}
function Am(e, t) {
  const n = me(cl).strict;
  if (process.env.NODE_ENV !== "production" && t && n) {
    const r = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    e.ignoreStrict ? St(!1, r, "lazy-strict-mode") : Le(!1, r, "lazy-strict-mode");
  }
}
function Vm(e) {
  const { drag: t, layout: n } = kt;
  if (!t && !n)
    return {};
  const r = { ...t, ...n };
  return {
    MeasureLayout: t != null && t.isEnabled(e) || n != null && n.isEnabled(e) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
function Em(e, t) {
  if (typeof Proxy > "u")
    return sr;
  const n = /* @__PURE__ */ new Map(), r = (a, o) => sr(a, o, e, t), s = (a, o) => (process.env.NODE_ENV !== "production" && Fn(!1, "motion() is deprecated. Use motion.create() instead."), r(a, o));
  return new Proxy(s, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (a, o) => o === "create" ? r : (n.has(o) || n.set(o, sr(o, void 0, e, t)), n.get(o))
  });
}
function kl({ top: e, left: t, right: n, bottom: r }) {
  return {
    x: { min: t, max: n },
    y: { min: e, max: r }
  };
}
function Rm({ x: e, y: t }) {
  return { top: t.min, right: e.max, bottom: t.max, left: e.min };
}
function Lm(e, t) {
  if (!t)
    return e;
  const n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function or(e) {
  return e === void 0 || e === 1;
}
function Lr({ scale: e, scaleX: t, scaleY: n }) {
  return !or(e) || !or(t) || !or(n);
}
function Je(e) {
  return Lr(e) || Nl(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY;
}
function Nl(e) {
  return zs(e.x) || zs(e.y);
}
function zs(e) {
  return e && e !== "0%";
}
function An(e, t, n) {
  const r = e - n, s = t * r;
  return n + s;
}
function js(e, t, n, r, s) {
  return s !== void 0 && (e = An(e, s, r)), An(e, n, r) + t;
}
function Br(e, t = 0, n = 1, r, s) {
  e.min = js(e.min, t, n, r, s), e.max = js(e.max, t, n, r, s);
}
function Sl(e, { x: t, y: n }) {
  Br(e.x, t.translate, t.scale, t.originPoint), Br(e.y, n.translate, n.scale, n.originPoint);
}
const _s = 0.999999999999, Os = 1.0000000000001;
function Bm(e, t, n, r = !1) {
  const s = n.length;
  if (!s)
    return;
  t.x = t.y = 1;
  let a, o;
  for (let l = 0; l < s; l++) {
    a = n[l], o = a.projectionDelta;
    const { visualElement: c } = a.options;
    c && c.props.style && c.props.style.display === "contents" || (r && a.options.layoutScroll && a.scroll && a !== a.root && gt(e, {
      x: -a.scroll.offset.x,
      y: -a.scroll.offset.y
    }), o && (t.x *= o.x.scale, t.y *= o.y.scale, Sl(e, o)), r && Je(a.latestValues) && gt(e, a.latestValues));
  }
  t.x < Os && t.x > _s && (t.x = 1), t.y < Os && t.y > _s && (t.y = 1);
}
function pt(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function $s(e, t, n, r, s = 0.5) {
  const a = Q(e.min, e.max, s);
  Br(e, t, n, a, r);
}
function gt(e, t) {
  $s(e.x, t.x, t.scaleX, t.scale, t.originX), $s(e.y, t.y, t.scaleY, t.scale, t.originY);
}
function Tl(e, t) {
  return kl(Lm(e.getBoundingClientRect(), t));
}
function Fm(e, t, n) {
  const r = Tl(e, n), { scroll: s } = t;
  return s && (pt(r.x, s.offset.x), pt(r.y, s.offset.y)), r;
}
const Hs = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), yt = () => ({
  x: Hs(),
  y: Hs()
}), Us = () => ({ min: 0, max: 0 }), ne = () => ({
  x: Us(),
  y: Us()
}), Vn = { current: null }, Ai = { current: !1 };
function Cl() {
  if (Ai.current = !0, !!ti)
    if (window.matchMedia) {
      const e = window.matchMedia("(prefers-reduced-motion)"), t = () => Vn.current = e.matches;
      e.addEventListener("change", t), t();
    } else
      Vn.current = !1;
}
const zm = /* @__PURE__ */ new WeakMap();
function jm(e, t, n) {
  for (const r in t) {
    const s = t[r], a = n[r];
    if (le(s))
      e.addValue(r, s);
    else if (le(a))
      e.addValue(r, wt(s, { owner: e }));
    else if (a !== s)
      if (e.hasValue(r)) {
        const o = e.getValue(r);
        o.liveStyle === !0 ? o.jump(s) : o.hasAnimated || o.set(s);
      } else {
        const o = e.getStaticValue(r);
        e.addValue(r, wt(o !== void 0 ? o : s, { owner: e }));
      }
  }
  for (const r in n)
    t[r] === void 0 && e.removeValue(r);
  return t;
}
const Ws = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
class _m {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(t, n, r) {
    return {};
  }
  constructor({ parent: t, props: n, presenceContext: r, reducedMotionConfig: s, blockInitialAnimation: a, visualState: o }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = vi, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = pe.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, q.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: u } = o;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = n.initial ? { ...c } : {}, this.renderState = u, this.parent = t, this.props = n, this.presenceContext = r, this.depth = t ? t.depth + 1 : 0, this.reducedMotionConfig = s, this.options = l, this.blockInitialAnimation = !!a, this.isControllingVariants = _n(n), this.isVariantNode = ul(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(t && t.current);
    const { willChange: d, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in h) {
      const g = h[f];
      c[f] !== void 0 && le(g) && g.set(c[f]);
    }
  }
  mount(t) {
    var n;
    this.current = t, zm.set(t, this), this.projection && !this.projection.instance && this.projection.mount(t), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((r, s) => this.bindToMotionValue(s, r)), Ai.current || Cl(), this.shouldReduceMotion = this.reducedMotionConfig === "never" ? !1 : this.reducedMotionConfig === "always" ? !0 : Vn.current, process.env.NODE_ENV !== "production" && Fn(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), (n = this.parent) == null || n.addChild(this), this.update(this.props, this.presenceContext);
  }
  unmount() {
    var t;
    this.projection && this.projection.unmount(), Oe(this.notifyUpdate), Oe(this.render), this.valueSubscriptions.forEach((n) => n()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), (t = this.parent) == null || t.removeChild(this);
    for (const n in this.events)
      this.events[n].clear();
    for (const n in this.features) {
      const r = this.features[n];
      r && (r.unmount(), r.isMounted = !1);
    }
    this.current = null;
  }
  addChild(t) {
    this.children.add(t), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(t);
  }
  removeChild(t) {
    this.children.delete(t), this.enteringChildren && this.enteringChildren.delete(t);
  }
  bindToMotionValue(t, n) {
    this.valueSubscriptions.has(t) && this.valueSubscriptions.get(t)();
    const r = Pt.has(t);
    r && this.onBindTransform && this.onBindTransform();
    const s = n.on("change", (o) => {
      this.latestValues[t] = o, this.props.onUpdate && q.preRender(this.notifyUpdate), r && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let a;
    window.MotionCheckAppearSync && (a = window.MotionCheckAppearSync(this, t, n)), this.valueSubscriptions.set(t, () => {
      s(), a && a(), n.owner && n.stop();
    });
  }
  sortNodePosition(t) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== t.type ? 0 : this.sortInstanceNodePosition(this.current, t.current);
  }
  updateFeatures() {
    let t = "animation";
    for (t in kt) {
      const n = kt[t];
      if (!n)
        continue;
      const { isEnabled: r, Feature: s } = n;
      if (!this.features[t] && s && r(this.props) && (this.features[t] = new s(this)), this.features[t]) {
        const a = this.features[t];
        a.isMounted ? a.update() : (a.mount(), a.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ne();
  }
  getStaticValue(t) {
    return this.latestValues[t];
  }
  setStaticValue(t, n) {
    this.latestValues[t] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(t, n) {
    (t.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = t, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let r = 0; r < Ws.length; r++) {
      const s = Ws[r];
      this.propEventSubscriptions[s] && (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
      const a = "on" + s, o = t[a];
      o && (this.propEventSubscriptions[s] = this.on(s, o));
    }
    this.prevMotionValues = jm(this, this.scrapeMotionValuesFromProps(t, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(t) {
    return this.props.variants ? this.props.variants[t] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(t) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(t), () => n.variantChildren.delete(t);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(t, n) {
    const r = this.values.get(t);
    n !== r && (r && this.removeValue(t), this.bindToMotionValue(t, n), this.values.set(t, n), this.latestValues[t] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(t) {
    this.values.delete(t);
    const n = this.valueSubscriptions.get(t);
    n && (n(), this.valueSubscriptions.delete(t)), delete this.latestValues[t], this.removeValueFromRenderState(t, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(t) {
    return this.values.has(t);
  }
  getValue(t, n) {
    if (this.props.values && this.props.values[t])
      return this.props.values[t];
    let r = this.values.get(t);
    return r === void 0 && n !== void 0 && (r = wt(n === null ? void 0 : n, { owner: this }), this.addValue(t, r)), r;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(t, n) {
    let r = this.latestValues[t] !== void 0 || !this.current ? this.latestValues[t] : this.getBaseTargetFromProps(this.props, t) ?? this.readValueFromInstance(this.current, t, this.options);
    return r != null && (typeof r == "string" && (ba(r) || wa(r)) ? r = parseFloat(r) : !em(r) && $e.test(n) && (r = nl(t, n)), this.setBaseTarget(t, le(r) ? r.get() : r)), le(r) ? r.get() : r;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(t, n) {
    this.baseTarget[t] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(t) {
    var a;
    const { initial: n } = this.props;
    let r;
    if (typeof n == "string" || typeof n == "object") {
      const o = Mi(this.props, n, (a = this.presenceContext) == null ? void 0 : a.custom);
      o && (r = o[t]);
    }
    if (n && r !== void 0)
      return r;
    const s = this.getBaseTargetFromProps(this.props, t);
    return s !== void 0 && !le(s) ? s : this.initialValues[t] !== void 0 && r === void 0 ? void 0 : this.baseTarget[t];
  }
  on(t, n) {
    return this.events[t] || (this.events[t] = new oi()), this.events[t].add(n);
  }
  notify(t, ...n) {
    this.events[t] && this.events[t].notify(...n);
  }
  scheduleRenderMicrotask() {
    wi.render(this.render);
  }
}
class Pl extends _m {
  constructor() {
    super(...arguments), this.KeyframeResolver = Of;
  }
  sortInstanceNodePosition(t, n) {
    return t.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(t, n) {
    return t.style ? t.style[n] : void 0;
  }
  removeValueFromRenderState(t, { vars: n, style: r }) {
    delete n[t], delete r[t];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: t } = this.props;
    le(t) && (this.childSubscription = t.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
function Ml(e, { style: t, vars: n }, r, s) {
  const a = e.style;
  let o;
  for (o in t)
    a[o] = t[o];
  s == null || s.applyProjectionStyles(a, r);
  for (o in n)
    a.setProperty(o, n[o]);
}
function Om(e) {
  return window.getComputedStyle(e);
}
class $m extends Pl {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Ml;
  }
  readValueFromInstance(t, n) {
    var r;
    if (Pt.has(n))
      return (r = this.projection) != null && r.isProjecting ? Mr(n) : sf(t, n);
    {
      const s = Om(t), a = (ci(n) ? s.getPropertyValue(n) : s[n]) || 0;
      return typeof a == "string" ? a.trim() : a;
    }
  }
  measureInstanceViewportBox(t, { transformPagePoint: n }) {
    return Tl(t, n);
  }
  build(t, n, r) {
    Ti(t, n, r.transformTemplate);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return Di(t, n, r);
  }
}
const Dl = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]);
function Hm(e, t, n, r) {
  Ml(e, t, void 0, r);
  for (const s in t.attrs)
    e.setAttribute(Dl.has(s) ? s : Ii(s), t.attrs[s]);
}
class Um extends Pl {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ne;
  }
  getBaseTargetFromProps(t, n) {
    return t[n];
  }
  readValueFromInstance(t, n) {
    if (Pt.has(n)) {
      const r = tl(n);
      return r && r.default || 0;
    }
    return n = Dl.has(n) ? n : Ii(n), t.getAttribute(n);
  }
  scrapeMotionValuesFromProps(t, n, r) {
    return vl(t, n, r);
  }
  build(t, n, r) {
    ml(t, n, this.isSVGTag, r.transformTemplate, r.style);
  }
  renderInstance(t, n, r, s) {
    Hm(t, n, r, s);
  }
  mount(t) {
    this.isSVGTag = gl(t.tagName), super.mount(t);
  }
}
const Wm = (e, t) => Pi(e) ? new Um(t) : new $m(t, {
  allowProjection: e !== Bo
});
function vt(e, t, n) {
  const r = e.getProps();
  return Mi(r, t, n !== void 0 ? n : r.custom, e);
}
const Fr = (e) => Array.isArray(e);
function Gm(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, wt(n));
}
function Km(e) {
  return Fr(e) ? e[e.length - 1] || 0 : e;
}
function Xm(e, t) {
  const n = vt(e, t);
  let { transitionEnd: r = {}, transition: s = {}, ...a } = n || {};
  a = { ...a, ...r };
  for (const o in a) {
    const l = Km(a[o]);
    Gm(e, o, l);
  }
}
function Ym(e) {
  return !!(le(e) && e.add);
}
function zr(e, t) {
  const n = e.getValue("willChange");
  if (Ym(n))
    return n.add(t);
  if (!n && Be.WillChange) {
    const r = new Be.WillChange("auto");
    e.addValue("willChange", r), r.add(t);
  }
}
function Il(e) {
  return e.props[bl];
}
const Zm = (e) => e !== null;
function qm(e, { repeat: t, repeatType: n = "loop" }, r) {
  const s = e.filter(Zm), a = t && n !== "loop" && t % 2 === 1 ? 0 : s.length - 1;
  return s[a];
}
const Jm = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, Qm = (e) => ({
  type: "spring",
  stiffness: 550,
  damping: e === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), ep = {
  type: "keyframes",
  duration: 0.8
}, tp = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, np = (e, { keyframes: t }) => t.length > 2 ? ep : Pt.has(e) ? e.startsWith("scale") ? Qm(t[1]) : Jm : tp;
function rp({ when: e, delay: t, delayChildren: n, staggerChildren: r, staggerDirection: s, repeat: a, repeatType: o, repeatDelay: l, from: c, elapsed: u, ...d }) {
  return !!Object.keys(d).length;
}
const Vi = (e, t, n, r = {}, s, a) => (o) => {
  const l = bi(r, e) || {}, c = l.delay || r.delay || 0;
  let { elapsed: u = 0 } = r;
  u = u - /* @__PURE__ */ Te(c);
  const d = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: t.getVelocity(),
    ...l,
    delay: -u,
    onUpdate: (f) => {
      t.set(f), l.onUpdate && l.onUpdate(f);
    },
    onComplete: () => {
      o(), l.onComplete && l.onComplete();
    },
    name: e,
    motionValue: t,
    element: a ? void 0 : s
  };
  rp(l) || Object.assign(d, np(e, d)), d.duration && (d.duration = /* @__PURE__ */ Te(d.duration)), d.repeatDelay && (d.repeatDelay = /* @__PURE__ */ Te(d.repeatDelay)), d.from !== void 0 && (d.keyframes[0] = d.from);
  let h = !1;
  if ((d.type === !1 || d.duration === 0 && !d.repeatDelay) && (Er(d), d.delay === 0 && (h = !0)), (Be.instantAnimations || Be.skipAnimations) && (h = !0, Er(d), d.delay = 0), d.allowFlatten = !l.type && !l.ease, h && !a && t.get() !== void 0) {
    const f = qm(d.keyframes, l);
    if (f !== void 0) {
      q.update(() => {
        d.onUpdate(f), d.onComplete();
      });
      return;
    }
  }
  return l.isSync ? new yi(d) : new Mf(d);
};
function ip({ protectedKeys: e, needsAnimating: t }, n) {
  const r = e.hasOwnProperty(n) && t[n] !== !0;
  return t[n] = !1, r;
}
function Al(e, t, { delay: n = 0, transitionOverride: r, type: s } = {}) {
  let { transition: a = e.getDefaultTransition(), transitionEnd: o, ...l } = t;
  r && (a = r);
  const c = [], u = s && e.animationState && e.animationState.getState()[s];
  for (const d in l) {
    const h = e.getValue(d, e.latestValues[d] ?? null), f = l[d];
    if (f === void 0 || u && ip(u, d))
      continue;
    const g = {
      delay: n,
      ...bi(a || {}, d)
    }, y = h.get();
    if (y !== void 0 && !h.isAnimating && !Array.isArray(f) && f === y && !g.velocity)
      continue;
    let v = !1;
    if (window.MotionHandoffAnimation) {
      const b = Il(e);
      if (b) {
        const w = window.MotionHandoffAnimation(b, d, q);
        w !== null && (g.startTime = w, v = !0);
      }
    }
    zr(e, d), h.start(Vi(d, h, f, e.shouldReduceMotion && Ja.has(d) ? { type: !1 } : g, e, v));
    const x = h.animation;
    x && c.push(x);
  }
  return o && Promise.all(c).then(() => {
    q.update(() => {
      o && Xm(e, o);
    });
  }), c;
}
function Vl(e, t, n, r = 0, s = 1) {
  const a = Array.from(e).sort((u, d) => u.sortNodePosition(d)).indexOf(t), o = e.size, l = (o - 1) * r;
  return typeof n == "function" ? n(a, o) : s === 1 ? a * r : l - a * r;
}
function jr(e, t, n = {}) {
  var c;
  const r = vt(e, t, n.type === "exit" ? (c = e.presenceContext) == null ? void 0 : c.custom : void 0);
  let { transition: s = e.getDefaultTransition() || {} } = r || {};
  n.transitionOverride && (s = n.transitionOverride);
  const a = r ? () => Promise.all(Al(e, r, n)) : () => Promise.resolve(), o = e.variantChildren && e.variantChildren.size ? (u = 0) => {
    const { delayChildren: d = 0, staggerChildren: h, staggerDirection: f } = s;
    return sp(e, t, u, d, h, f, n);
  } : () => Promise.resolve(), { when: l } = s;
  if (l) {
    const [u, d] = l === "beforeChildren" ? [a, o] : [o, a];
    return u().then(() => d());
  } else
    return Promise.all([a(), o(n.delay)]);
}
function sp(e, t, n = 0, r = 0, s = 0, a = 1, o) {
  const l = [];
  for (const c of e.variantChildren)
    c.notify("AnimationStart", t), l.push(jr(c, t, {
      ...o,
      delay: n + (typeof r == "function" ? 0 : r) + Vl(e.variantChildren, c, r, s, a)
    }).then(() => c.notify("AnimationComplete", t)));
  return Promise.all(l);
}
function op(e, t, n = {}) {
  e.notify("AnimationStart", t);
  let r;
  if (Array.isArray(t)) {
    const s = t.map((a) => jr(e, a, n));
    r = Promise.all(s);
  } else if (typeof t == "string")
    r = jr(e, t, n);
  else {
    const s = typeof t == "function" ? vt(e, t, n.custom) : t;
    r = Promise.all(Al(e, s, n));
  }
  return r.then(() => {
    e.notify("AnimationComplete", t);
  });
}
function El(e, t) {
  if (!Array.isArray(t))
    return !1;
  const n = t.length;
  if (n !== e.length)
    return !1;
  for (let r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
const ap = Si.length;
function Rl(e) {
  if (!e)
    return;
  if (!e.isControllingVariants) {
    const n = e.parent ? Rl(e.parent) || {} : {};
    return e.props.initial !== void 0 && (n.initial = e.props.initial), n;
  }
  const t = {};
  for (let n = 0; n < ap; n++) {
    const r = Si[n], s = e.props[r];
    (Kt(s) || s === !1) && (t[r] = s);
  }
  return t;
}
const lp = [...Ni].reverse(), cp = Ni.length;
function dp(e) {
  return (t) => Promise.all(t.map(({ animation: n, options: r }) => op(e, n, r)));
}
function up(e) {
  let t = dp(e), n = Gs(), r = !0;
  const s = (c) => (u, d) => {
    var f;
    const h = vt(e, d, c === "exit" ? (f = e.presenceContext) == null ? void 0 : f.custom : void 0);
    if (h) {
      const { transition: g, transitionEnd: y, ...v } = h;
      u = { ...u, ...v, ...y };
    }
    return u;
  };
  function a(c) {
    t = c(e);
  }
  function o(c) {
    const { props: u } = e, d = Rl(e.parent) || {}, h = [], f = /* @__PURE__ */ new Set();
    let g = {}, y = 1 / 0;
    for (let x = 0; x < cp; x++) {
      const b = lp[x], w = n[b], k = u[b] !== void 0 ? u[b] : d[b], N = Kt(k), T = b === c ? w.isActive : null;
      T === !1 && (y = x);
      let M = k === d[b] && k !== u[b] && N;
      if (M && r && e.manuallyAnimateOnMount && (M = !1), w.protectedKeys = { ...g }, // If it isn't active and hasn't *just* been set as inactive
      !w.isActive && T === null || // If we didn't and don't have any defined prop for this animation type
      !k && !w.prevProp || // Or if the prop doesn't define an animation
      jn(k) || typeof k == "boolean")
        continue;
      const C = hp(w.prevProp, k);
      let D = C || // If we're making this variant active, we want to always make it active
      b === c && w.isActive && !M && N || // If we removed a higher-priority variant (i is in reverse order)
      x > y && N, A = !1;
      const E = Array.isArray(k) ? k : [k];
      let R = E.reduce(s(b), {});
      T === !1 && (R = {});
      const { prevResolvedValues: B = {} } = w, ee = {
        ...B,
        ...R
      }, Ce = (_) => {
        D = !0, f.has(_) && (A = !0, f.delete(_)), w.needsAnimating[_] = !0;
        const L = e.getValue(_);
        L && (L.liveStyle = !1);
      };
      for (const _ in ee) {
        const L = R[_], oe = B[_];
        if (g.hasOwnProperty(_))
          continue;
        let we = !1;
        Fr(L) && Fr(oe) ? we = !El(L, oe) : we = L !== oe, we ? L != null ? Ce(_) : f.add(_) : L !== void 0 && f.has(_) ? Ce(_) : w.protectedKeys[_] = !0;
      }
      w.prevProp = k, w.prevResolvedValues = R, w.isActive && (g = { ...g, ...R }), r && e.blockInitialAnimation && (D = !1);
      const Y = M && C;
      D && (!Y || A) && h.push(...E.map((_) => {
        const L = { type: b };
        if (typeof _ == "string" && r && !Y && e.manuallyAnimateOnMount && e.parent) {
          const { parent: oe } = e, we = vt(oe, _);
          if (oe.enteringChildren && we) {
            const { delayChildren: Ue } = we.transition || {};
            L.delay = Vl(oe.enteringChildren, e, Ue);
          }
        }
        return {
          animation: _,
          options: L
        };
      }));
    }
    if (f.size) {
      const x = {};
      if (typeof u.initial != "boolean") {
        const b = vt(e, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        b && b.transition && (x.transition = b.transition);
      }
      f.forEach((b) => {
        const w = e.getBaseTarget(b), k = e.getValue(b);
        k && (k.liveStyle = !0), x[b] = w ?? null;
      }), h.push({ animation: x });
    }
    let v = !!h.length;
    return r && (u.initial === !1 || u.initial === u.animate) && !e.manuallyAnimateOnMount && (v = !1), r = !1, v ? t(h) : Promise.resolve();
  }
  function l(c, u) {
    var h;
    if (n[c].isActive === u)
      return Promise.resolve();
    (h = e.variantChildren) == null || h.forEach((f) => {
      var g;
      return (g = f.animationState) == null ? void 0 : g.setActive(c, u);
    }), n[c].isActive = u;
    const d = o(c);
    for (const f in n)
      n[f].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: o,
    setActive: l,
    setAnimateFunction: a,
    getState: () => n,
    reset: () => {
      n = Gs();
    }
  };
}
function hp(e, t) {
  return typeof t == "string" ? t !== e : Array.isArray(t) ? !El(t, e) : !1;
}
function qe(e = !1) {
  return {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Gs() {
  return {
    animate: qe(!0),
    whileInView: qe(),
    whileHover: qe(),
    whileTap: qe(),
    whileDrag: qe(),
    whileFocus: qe(),
    exit: qe()
  };
}
class He {
  constructor(t) {
    this.isMounted = !1, this.node = t;
  }
  update() {
  }
}
class fp extends He {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(t) {
    super(t), t.animationState || (t.animationState = up(t));
  }
  updateAnimationControlsSubscription() {
    const { animate: t } = this.node.getProps();
    jn(t) && (this.unmountControls = t.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: t } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    t !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    var t;
    this.node.animationState.reset(), (t = this.unmountControls) == null || t.call(this);
  }
}
let mp = 0;
class pp extends He {
  constructor() {
    super(...arguments), this.id = mp++;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: t, onExitComplete: n } = this.node.presenceContext, { isPresent: r } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || t === r)
      return;
    const s = this.node.animationState.setActive("exit", !t);
    n && !t && s.then(() => {
      n(this.id);
    });
  }
  mount() {
    const { register: t, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), t && (this.unmount = t(this.id));
  }
  unmount() {
  }
}
const gp = {
  animation: {
    Feature: fp
  },
  exit: {
    Feature: pp
  }
};
function Yt(e, t, n, r = { passive: !0 }) {
  return e.addEventListener(t, n, r), () => e.removeEventListener(t, n);
}
function en(e) {
  return {
    point: {
      x: e.pageX,
      y: e.pageY
    }
  };
}
const yp = (e) => (t) => ki(t) && e(t, en(t));
function Bt(e, t, n, r) {
  return Yt(e, t, yp(n), r);
}
const Ll = 1e-4, vp = 1 - Ll, bp = 1 + Ll, Bl = 0.01, xp = 0 - Bl, wp = 0 + Bl;
function de(e) {
  return e.max - e.min;
}
function kp(e, t, n) {
  return Math.abs(e - t) <= n;
}
function Ks(e, t, n, r = 0.5) {
  e.origin = r, e.originPoint = Q(t.min, t.max, e.origin), e.scale = de(n) / de(t), e.translate = Q(n.min, n.max, e.origin) - e.originPoint, (e.scale >= vp && e.scale <= bp || isNaN(e.scale)) && (e.scale = 1), (e.translate >= xp && e.translate <= wp || isNaN(e.translate)) && (e.translate = 0);
}
function Ft(e, t, n, r) {
  Ks(e.x, t.x, n.x, r ? r.originX : void 0), Ks(e.y, t.y, n.y, r ? r.originY : void 0);
}
function Xs(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + de(t);
}
function Np(e, t, n) {
  Xs(e.x, t.x, n.x), Xs(e.y, t.y, n.y);
}
function Ys(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + de(t);
}
function zt(e, t, n) {
  Ys(e.x, t.x, n.x), Ys(e.y, t.y, n.y);
}
function ve(e) {
  return [e("x"), e("y")];
}
const Fl = ({ current: e }) => e ? e.ownerDocument.defaultView : null, Zs = (e, t) => Math.abs(e - t);
function Sp(e, t) {
  const n = Zs(e.x, t.x), r = Zs(e.y, t.y);
  return Math.sqrt(n ** 2 + r ** 2);
}
class zl {
  constructor(t, n, { transformPagePoint: r, contextWindow: s = window, dragSnapToOrigin: a = !1, distanceThreshold: o = 3 } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const f = lr(this.lastMoveEventInfo, this.history), g = this.startEvent !== null, y = Sp(f.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!g && !y)
        return;
      const { point: v } = f, { timestamp: x } = ae;
      this.history.push({ ...v, timestamp: x });
      const { onStart: b, onMove: w } = this.handlers;
      g || (b && b(this.lastMoveEvent, f), this.startEvent = this.lastMoveEvent), w && w(this.lastMoveEvent, f);
    }, this.handlePointerMove = (f, g) => {
      this.lastMoveEvent = f, this.lastMoveEventInfo = ar(g, this.transformPagePoint), q.update(this.updatePoint, !0);
    }, this.handlePointerUp = (f, g) => {
      this.end();
      const { onEnd: y, onSessionEnd: v, resumeAnimation: x } = this.handlers;
      if (this.dragSnapToOrigin && x && x(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const b = lr(f.type === "pointercancel" ? this.lastMoveEventInfo : ar(g, this.transformPagePoint), this.history);
      this.startEvent && y && y(f, b), v && v(f, b);
    }, !ki(t))
      return;
    this.dragSnapToOrigin = a, this.handlers = n, this.transformPagePoint = r, this.distanceThreshold = o, this.contextWindow = s || window;
    const l = en(t), c = ar(l, this.transformPagePoint), { point: u } = c, { timestamp: d } = ae;
    this.history = [{ ...u, timestamp: d }];
    const { onSessionStart: h } = n;
    h && h(t, lr(c, this.history)), this.removeListeners = qt(Bt(this.contextWindow, "pointermove", this.handlePointerMove), Bt(this.contextWindow, "pointerup", this.handlePointerUp), Bt(this.contextWindow, "pointercancel", this.handlePointerUp));
  }
  updateHandlers(t) {
    this.handlers = t;
  }
  end() {
    this.removeListeners && this.removeListeners(), Oe(this.updatePoint);
  }
}
function ar(e, t) {
  return t ? { point: t(e.point) } : e;
}
function qs(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function lr({ point: e }, t) {
  return {
    point: e,
    delta: qs(e, jl(t)),
    offset: qs(e, Tp(t)),
    velocity: Cp(t, 0.1)
  };
}
function Tp(e) {
  return e[0];
}
function jl(e) {
  return e[e.length - 1];
}
function Cp(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  let n = e.length - 1, r = null;
  const s = jl(e);
  for (; n >= 0 && (r = e[n], !(s.timestamp - r.timestamp > /* @__PURE__ */ Te(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  const a = /* @__PURE__ */ be(s.timestamp - r.timestamp);
  if (a === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (s.x - r.x) / a,
    y: (s.y - r.y) / a
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function Pp(e, { min: t, max: n }, r) {
  return t !== void 0 && e < t ? e = r ? Q(t, e, r.min) : Math.max(e, t) : n !== void 0 && e > n && (e = r ? Q(n, e, r.max) : Math.min(e, n)), e;
}
function Js(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function Mp(e, { top: t, left: n, bottom: r, right: s }) {
  return {
    x: Js(e.x, n, s),
    y: Js(e.y, t, r)
  };
}
function Qs(e, t) {
  let n = t.min - e.min, r = t.max - e.max;
  return t.max - t.min < e.max - e.min && ([n, r] = [r, n]), { min: n, max: r };
}
function Dp(e, t) {
  return {
    x: Qs(e.x, t.x),
    y: Qs(e.y, t.y)
  };
}
function Ip(e, t) {
  let n = 0.5;
  const r = de(e), s = de(t);
  return s > r ? n = /* @__PURE__ */ Ut(t.min, t.max - r, e.min) : r > s && (n = /* @__PURE__ */ Ut(e.min, e.max - s, t.min)), Re(0, 1, n);
}
function Ap(e, t) {
  const n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
const _r = 0.35;
function Vp(e = _r) {
  return e === !1 ? e = 0 : e === !0 && (e = _r), {
    x: eo(e, "left", "right"),
    y: eo(e, "top", "bottom")
  };
}
function eo(e, t, n) {
  return {
    min: to(e, t),
    max: to(e, n)
  };
}
function to(e, t) {
  return typeof e == "number" ? e : e[t] || 0;
}
const Ep = /* @__PURE__ */ new WeakMap();
class Rp {
  constructor(t) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ne(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = t;
  }
  start(t, { snapToCursor: n = !1, distanceThreshold: r } = {}) {
    const { presenceContext: s } = this.visualElement;
    if (s && s.isPresent === !1)
      return;
    const a = (h) => {
      const { dragSnapToOrigin: f } = this.getProps();
      f ? this.pauseAnimation() : this.stopAnimation(), n && this.snapToCursor(en(h).point);
    }, o = (h, f) => {
      const { drag: g, dragPropagation: y, onDragStart: v } = this.getProps();
      if (g && !y && (this.openDragLock && this.openDragLock(), this.openDragLock = Gf(g), !this.openDragLock))
        return;
      this.latestPointerEvent = h, this.latestPanInfo = f, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), ve((b) => {
        let w = this.getAxisMotionValue(b).get() || 0;
        if (Ie.test(w)) {
          const { projection: k } = this.visualElement;
          if (k && k.layout) {
            const N = k.layout.layoutBox[b];
            N && (w = de(N) * (parseFloat(w) / 100));
          }
        }
        this.originPoint[b] = w;
      }), v && q.postRender(() => v(h, f)), zr(this.visualElement, "transform");
      const { animationState: x } = this.visualElement;
      x && x.setActive("whileDrag", !0);
    }, l = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f;
      const { dragPropagation: g, dragDirectionLock: y, onDirectionLock: v, onDrag: x } = this.getProps();
      if (!g && !this.openDragLock)
        return;
      const { offset: b } = f;
      if (y && this.currentDirection === null) {
        this.currentDirection = Lp(b), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", f.point, b), this.updateAxis("y", f.point, b), this.visualElement.render(), x && x(h, f);
    }, c = (h, f) => {
      this.latestPointerEvent = h, this.latestPanInfo = f, this.stop(h, f), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, u = () => ve((h) => {
      var f;
      return this.getAnimationState(h) === "paused" && ((f = this.getAxisMotionValue(h).animation) == null ? void 0 : f.play());
    }), { dragSnapToOrigin: d } = this.getProps();
    this.panSession = new zl(t, {
      onSessionStart: a,
      onStart: o,
      onMove: l,
      onSessionEnd: c,
      resumeAnimation: u
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: d,
      distanceThreshold: r,
      contextWindow: Fl(this.visualElement)
    });
  }
  /**
   * @internal
   */
  stop(t, n) {
    const r = t || this.latestPointerEvent, s = n || this.latestPanInfo, a = this.isDragging;
    if (this.cancel(), !a || !s || !r)
      return;
    const { velocity: o } = s;
    this.startAnimation(o);
    const { onDragEnd: l } = this.getProps();
    l && q.postRender(() => l(r, s));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: t, animationState: n } = this.visualElement;
    t && (t.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
    const { dragPropagation: r } = this.getProps();
    !r && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  updateAxis(t, n, r) {
    const { drag: s } = this.getProps();
    if (!r || !wn(t, s, this.currentDirection))
      return;
    const a = this.getAxisMotionValue(t);
    let o = this.originPoint[t] + r[t];
    this.constraints && this.constraints[t] && (o = Pp(o, this.constraints[t], this.elastic[t])), a.set(o);
  }
  resolveConstraints() {
    var a;
    const { dragConstraints: t, dragElastic: n } = this.getProps(), r = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : (a = this.visualElement.projection) == null ? void 0 : a.layout, s = this.constraints;
    t && mt(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && r ? this.constraints = Mp(r.layoutBox, t) : this.constraints = !1, this.elastic = Vp(n), s !== this.constraints && r && this.constraints && !this.hasMutatedConstraints && ve((o) => {
      this.constraints !== !1 && this.getAxisMotionValue(o) && (this.constraints[o] = Ap(r.layoutBox[o], this.constraints[o]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: t, onMeasureDragConstraints: n } = this.getProps();
    if (!t || !mt(t))
      return !1;
    const r = t.current;
    Le(r !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: s } = this.visualElement;
    if (!s || !s.layout)
      return !1;
    const a = Fm(r, s.root, this.visualElement.getTransformPagePoint());
    let o = Dp(s.layout.layoutBox, a);
    if (n) {
      const l = n(Rm(o));
      this.hasMutatedConstraints = !!l, l && (o = kl(l));
    }
    return o;
  }
  startAnimation(t) {
    const { drag: n, dragMomentum: r, dragElastic: s, dragTransition: a, dragSnapToOrigin: o, onDragTransitionEnd: l } = this.getProps(), c = this.constraints || {}, u = ve((d) => {
      if (!wn(d, n, this.currentDirection))
        return;
      let h = c && c[d] || {};
      o && (h = { min: 0, max: 0 });
      const f = s ? 200 : 1e6, g = s ? 40 : 1e7, y = {
        type: "inertia",
        velocity: r ? t[d] : 0,
        bounceStiffness: f,
        bounceDamping: g,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...a,
        ...h
      };
      return this.startAxisValueAnimation(d, y);
    });
    return Promise.all(u).then(l);
  }
  startAxisValueAnimation(t, n) {
    const r = this.getAxisMotionValue(t);
    return zr(this.visualElement, t), r.start(Vi(t, r, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    ve((t) => this.getAxisMotionValue(t).stop());
  }
  pauseAnimation() {
    ve((t) => {
      var n;
      return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.pause();
    });
  }
  getAnimationState(t) {
    var n;
    return (n = this.getAxisMotionValue(t).animation) == null ? void 0 : n.state;
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(t) {
    const n = `_drag${t.toUpperCase()}`, r = this.visualElement.getProps(), s = r[n];
    return s || this.visualElement.getValue(t, (r.initial ? r.initial[t] : void 0) || 0);
  }
  snapToCursor(t) {
    ve((n) => {
      const { drag: r } = this.getProps();
      if (!wn(n, r, this.currentDirection))
        return;
      const { projection: s } = this.visualElement, a = this.getAxisMotionValue(n);
      if (s && s.layout) {
        const { min: o, max: l } = s.layout.layoutBox[n];
        a.set(t[n] - Q(o, l, 0.5));
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: t, dragConstraints: n } = this.getProps(), { projection: r } = this.visualElement;
    if (!mt(n) || !r || !this.constraints)
      return;
    this.stopAnimation();
    const s = { x: 0, y: 0 };
    ve((o) => {
      const l = this.getAxisMotionValue(o);
      if (l && this.constraints !== !1) {
        const c = l.get();
        s[o] = Ip({ min: c, max: c }, this.constraints[o]);
      }
    });
    const { transformTemplate: a } = this.visualElement.getProps();
    this.visualElement.current.style.transform = a ? a({}, "") : "none", r.root && r.root.updateScroll(), r.updateLayout(), this.resolveConstraints(), ve((o) => {
      if (!wn(o, t, null))
        return;
      const l = this.getAxisMotionValue(o), { min: c, max: u } = this.constraints[o];
      l.set(Q(c, u, s[o]));
    });
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    Ep.set(this.visualElement, this);
    const t = this.visualElement.current, n = Bt(t, "pointerdown", (c) => {
      const { drag: u, dragListener: d = !0 } = this.getProps();
      u && d && this.start(c);
    }), r = () => {
      const { dragConstraints: c } = this.getProps();
      mt(c) && c.current && (this.constraints = this.resolveRefConstraints());
    }, { projection: s } = this.visualElement, a = s.addEventListener("measure", r);
    s && !s.layout && (s.root && s.root.updateScroll(), s.updateLayout()), q.read(r);
    const o = Yt(window, "resize", () => this.scalePositionWithinConstraints()), l = s.addEventListener("didUpdate", (({ delta: c, hasLayoutChanged: u }) => {
      this.isDragging && u && (ve((d) => {
        const h = this.getAxisMotionValue(d);
        h && (this.originPoint[d] += c[d].translate, h.set(h.get() + c[d].translate));
      }), this.visualElement.render());
    }));
    return () => {
      o(), n(), a(), l && l();
    };
  }
  getProps() {
    const t = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: r = !1, dragPropagation: s = !1, dragConstraints: a = !1, dragElastic: o = _r, dragMomentum: l = !0 } = t;
    return {
      ...t,
      drag: n,
      dragDirectionLock: r,
      dragPropagation: s,
      dragConstraints: a,
      dragElastic: o,
      dragMomentum: l
    };
  }
}
function wn(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function Lp(e, t = 10) {
  let n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
class Bp extends He {
  constructor(t) {
    super(t), this.removeGroupControls = xe, this.removeListeners = xe, this.controls = new Rp(t);
  }
  mount() {
    const { dragControls: t } = this.node.getProps();
    t && (this.removeGroupControls = t.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || xe;
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners();
  }
}
const no = (e) => (t, n) => {
  e && q.postRender(() => e(t, n));
};
class Fp extends He {
  constructor() {
    super(...arguments), this.removePointerDownListener = xe;
  }
  onPointerDown(t) {
    this.session = new zl(t, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Fl(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: t, onPanStart: n, onPan: r, onPanEnd: s } = this.node.getProps();
    return {
      onSessionStart: no(t),
      onStart: no(n),
      onMove: r,
      onEnd: (a, o) => {
        delete this.session, s && q.postRender(() => s(a, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = Bt(this.node.current, "pointerdown", (t) => this.onPointerDown(t));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
const Tn = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
};
function ro(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
const Dt = {
  correct: (e, t) => {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (V.test(e))
        e = parseFloat(e);
      else
        return e;
    const n = ro(e, t.target.x), r = ro(e, t.target.y);
    return `${n}% ${r}%`;
  }
}, zp = {
  correct: (e, { treeScale: t, projectionDelta: n }) => {
    const r = e, s = $e.parse(e);
    if (s.length > 5)
      return r;
    const a = $e.createTransformer(e), o = typeof s[0] != "number" ? 1 : 0, l = n.x.scale * t.x, c = n.y.scale * t.y;
    s[0 + o] /= l, s[1 + o] /= c;
    const u = Q(l, c, 0.5);
    return typeof s[2 + o] == "number" && (s[2 + o] /= u), typeof s[3 + o] == "number" && (s[3 + o] /= u), a(s);
  }
};
let cr = !1;
class jp extends Dc {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r, layoutId: s } = this.props, { projection: a } = t;
    lm(_p), a && (n.group && n.group.add(a), r && r.register && s && r.register(a), cr && a.root.didUpdate(), a.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), a.setOptions({
      ...a.options,
      onExitComplete: () => this.safeToRemove()
    })), Tn.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(t) {
    const { layoutDependency: n, visualElement: r, drag: s, isPresent: a } = this.props, { projection: o } = r;
    return o && (o.isPresent = a, cr = !0, s || t.layoutDependency !== n || n === void 0 || t.isPresent !== a ? o.willUpdate() : this.safeToRemove(), t.isPresent !== a && (a ? o.promote() : o.relegate() || q.postRender(() => {
      const l = o.getStack();
      (!l || !l.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { projection: t } = this.props.visualElement;
    t && (t.root.didUpdate(), wi.postRender(() => {
      !t.currentAnimation && t.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: t, layoutGroup: n, switchLayoutGroup: r } = this.props, { projection: s } = t;
    cr = !0, s && (s.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(s), r && r.deregister && r.deregister(s));
  }
  safeToRemove() {
    const { safeToRemove: t } = this.props;
    t && t();
  }
  render() {
    return null;
  }
}
function _l(e) {
  const [t, n] = tm(), r = me(va);
  return i(jp, { ...e, layoutGroup: r, switchLayoutGroup: me(xl), isPresent: t, safeToRemove: n });
}
const _p = {
  borderRadius: {
    ...Dt,
    applyTo: [
      "borderTopLeftRadius",
      "borderTopRightRadius",
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]
  },
  borderTopLeftRadius: Dt,
  borderTopRightRadius: Dt,
  borderBottomLeftRadius: Dt,
  borderBottomRightRadius: Dt,
  boxShadow: zp
};
function Op(e, t, n) {
  const r = le(e) ? e : wt(e);
  return r.start(Vi("", r, t, n)), r.animation;
}
const $p = (e, t) => e.depth - t.depth;
class Hp {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(t) {
    ri(this.children, t), this.isDirty = !0;
  }
  remove(t) {
    ii(this.children, t), this.isDirty = !0;
  }
  forEach(t) {
    this.isDirty && this.children.sort($p), this.isDirty = !1, this.children.forEach(t);
  }
}
function Up(e, t) {
  const n = pe.now(), r = ({ timestamp: s }) => {
    const a = s - n;
    a >= t && (Oe(r), e(a - t));
  };
  return q.setup(r, !0), () => Oe(r);
}
const Ol = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Wp = Ol.length, io = (e) => typeof e == "string" ? parseFloat(e) : e, so = (e) => typeof e == "number" || V.test(e);
function Gp(e, t, n, r, s, a) {
  s ? (e.opacity = Q(0, n.opacity ?? 1, Kp(r)), e.opacityExit = Q(t.opacity ?? 1, 0, Xp(r))) : a && (e.opacity = Q(t.opacity ?? 1, n.opacity ?? 1, r));
  for (let o = 0; o < Wp; o++) {
    const l = `border${Ol[o]}Radius`;
    let c = oo(t, l), u = oo(n, l);
    if (c === void 0 && u === void 0)
      continue;
    c || (c = 0), u || (u = 0), c === 0 || u === 0 || so(c) === so(u) ? (e[l] = Math.max(Q(io(c), io(u), r), 0), (Ie.test(u) || Ie.test(c)) && (e[l] += "%")) : e[l] = u;
  }
  (t.rotate || n.rotate) && (e.rotate = Q(t.rotate || 0, n.rotate || 0, r));
}
function oo(e, t) {
  return e[t] !== void 0 ? e[t] : e.borderRadius;
}
const Kp = /* @__PURE__ */ $l(0, 0.5, Da), Xp = /* @__PURE__ */ $l(0.5, 0.95, xe);
function $l(e, t, n) {
  return (r) => r < e ? 0 : r > t ? 1 : n(/* @__PURE__ */ Ut(e, t, r));
}
function ao(e, t) {
  e.min = t.min, e.max = t.max;
}
function ye(e, t) {
  ao(e.x, t.x), ao(e.y, t.y);
}
function lo(e, t) {
  e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin;
}
function co(e, t, n, r, s) {
  return e -= t, e = An(e, 1 / n, r), s !== void 0 && (e = An(e, 1 / s, r)), e;
}
function Yp(e, t = 0, n = 1, r = 0.5, s, a = e, o = e) {
  if (Ie.test(t) && (t = parseFloat(t), t = Q(o.min, o.max, t / 100) - o.min), typeof t != "number")
    return;
  let l = Q(a.min, a.max, r);
  e === a && (l -= t), e.min = co(e.min, t, n, l, s), e.max = co(e.max, t, n, l, s);
}
function uo(e, t, [n, r, s], a, o) {
  Yp(e, t[n], t[r], t[s], t.scale, a, o);
}
const Zp = ["x", "scaleX", "originX"], qp = ["y", "scaleY", "originY"];
function ho(e, t, n, r) {
  uo(e.x, t, Zp, n ? n.x : void 0, r ? r.x : void 0), uo(e.y, t, qp, n ? n.y : void 0, r ? r.y : void 0);
}
function fo(e) {
  return e.translate === 0 && e.scale === 1;
}
function Hl(e) {
  return fo(e.x) && fo(e.y);
}
function mo(e, t) {
  return e.min === t.min && e.max === t.max;
}
function Jp(e, t) {
  return mo(e.x, t.x) && mo(e.y, t.y);
}
function po(e, t) {
  return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max);
}
function Ul(e, t) {
  return po(e.x, t.x) && po(e.y, t.y);
}
function go(e) {
  return de(e.x) / de(e.y);
}
function yo(e, t) {
  return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint;
}
class Qp {
  constructor() {
    this.members = [];
  }
  add(t) {
    ri(this.members, t), t.scheduleRender();
  }
  remove(t) {
    if (ii(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(t) {
    const n = this.members.findIndex((s) => t === s);
    if (n === 0)
      return !1;
    let r;
    for (let s = n; s >= 0; s--) {
      const a = this.members[s];
      if (a.isPresent !== !1) {
        r = a;
        break;
      }
    }
    return r ? (this.promote(r), !0) : !1;
  }
  promote(t, n) {
    const r = this.lead;
    if (t !== r && (this.prevLead = r, this.lead = t, t.show(), r)) {
      r.instance && r.scheduleRender(), t.scheduleRender(), t.resumeFrom = r, n && (t.resumeFrom.preserveOpacity = !0), r.snapshot && (t.snapshot = r.snapshot, t.snapshot.latestValues = r.animationValues || r.latestValues), t.root && t.root.isUpdating && (t.isLayoutDirty = !0);
      const { crossfade: s } = t.options;
      s === !1 && r.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((t) => {
      const { options: n, resumingFrom: r } = t;
      n.onExitComplete && n.onExitComplete(), r && r.options.onExitComplete && r.options.onExitComplete();
    });
  }
  scheduleRender() {
    this.members.forEach((t) => {
      t.instance && t.scheduleRender(!1);
    });
  }
  /**
   * Clear any leads that have been removed this render to prevent them from being
   * used in future animations and to prevent memory leaks
   */
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
  }
}
function eg(e, t, n) {
  let r = "";
  const s = e.x.translate / t.x, a = e.y.translate / t.y, o = (n == null ? void 0 : n.z) || 0;
  if ((s || a || o) && (r = `translate3d(${s}px, ${a}px, ${o}px) `), (t.x !== 1 || t.y !== 1) && (r += `scale(${1 / t.x}, ${1 / t.y}) `), n) {
    const { transformPerspective: u, rotate: d, rotateX: h, rotateY: f, skewX: g, skewY: y } = n;
    u && (r = `perspective(${u}px) ${r}`), d && (r += `rotate(${d}deg) `), h && (r += `rotateX(${h}deg) `), f && (r += `rotateY(${f}deg) `), g && (r += `skewX(${g}deg) `), y && (r += `skewY(${y}deg) `);
  }
  const l = e.x.scale * t.x, c = e.y.scale * t.y;
  return (l !== 1 || c !== 1) && (r += `scale(${l}, ${c})`), r || "none";
}
const dr = ["", "X", "Y", "Z"], tg = 1e3;
let ng = 0;
function ur(e, t, n, r) {
  const { latestValues: s } = t;
  s[e] && (n[e] = s[e], t.setStaticValue(e, 0), r && (r[e] = 0));
}
function Wl(e) {
  if (e.hasCheckedOptimisedAppear = !0, e.root === e)
    return;
  const { visualElement: t } = e.options;
  if (!t)
    return;
  const n = Il(t);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: s, layoutId: a } = e.options;
    window.MotionCancelOptimisedAnimation(n, "transform", q, !(s || a));
  }
  const { parent: r } = e;
  r && !r.hasCheckedOptimisedAppear && Wl(r);
}
function Gl({ attachResizeListener: e, defaultParent: t, measureScroll: n, checkIsScrollRoot: r, resetTransform: s }) {
  return class {
    constructor(o = {}, l = t == null ? void 0 : t()) {
      this.id = ng++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(sg), this.nodes.forEach(cg), this.nodes.forEach(dg), this.nodes.forEach(og);
      }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = l ? l.root || l : this, this.path = l ? [...l.path, l] : [], this.parent = l, this.depth = l ? l.depth + 1 : 0;
      for (let c = 0; c < this.path.length; c++)
        this.path[c].shouldResetTransform = !0;
      this.root === this && (this.nodes = new Hp());
    }
    addEventListener(o, l) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new oi()), this.eventHandlers.get(o).add(l);
    }
    notifyListeners(o, ...l) {
      const c = this.eventHandlers.get(o);
      c && c.notify(...l);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = al(o) && !Jf(o), this.instance = o;
      const { layoutId: l, layout: c, visualElement: u } = this.options;
      if (u && !u.current && u.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (c || l) && (this.isLayoutDirty = !0), e) {
        let d, h = 0;
        const f = () => this.root.updateBlockedByResize = !1;
        q.read(() => {
          h = window.innerWidth;
        }), e(o, () => {
          const g = window.innerWidth;
          g !== h && (h = g, this.root.updateBlockedByResize = !0, d && d(), d = Up(f, 250), Tn.hasAnimatedSinceResize && (Tn.hasAnimatedSinceResize = !1, this.nodes.forEach(xo)));
        });
      }
      l && this.root.registerSharedNode(l, this), this.options.animate !== !1 && u && (l || c) && this.addEventListener("didUpdate", ({ delta: d, hasLayoutChanged: h, hasRelativeLayoutChanged: f, layout: g }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const y = this.options.transition || u.getDefaultTransition() || pg, { onLayoutAnimationStart: v, onLayoutAnimationComplete: x } = u.getProps(), b = !this.targetLayout || !Ul(this.targetLayout, g), w = !h && f;
        if (this.options.layoutRoot || this.resumeFrom || w || h && (b || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const k = {
            ...bi(y, "layout"),
            onPlay: v,
            onComplete: x
          };
          (u.shouldReduceMotion || this.options.layoutRoot) && (k.delay = 0, k.type = !1), this.startAnimation(k), this.setAnimationOrigin(d, w);
        } else
          h || xo(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = g;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), Oe(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(ug), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && Wl(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let d = 0; d < this.path.length; d++) {
        const h = this.path[d];
        h.shouldResetTransform = !0, h.updateScroll("snapshot"), h.options.layoutRoot && h.willUpdate(!1);
      }
      const { layoutId: l, layout: c } = this.options;
      if (l === void 0 && !c)
        return;
      const u = this.getTransformTemplate();
      this.prevTransformTemplateValue = u ? u(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(vo);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(bo);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(lg), this.nodes.forEach(rg), this.nodes.forEach(ig)) : this.nodes.forEach(bo), this.clearAllSnapshots();
      const l = pe.now();
      ae.delta = Re(0, 1e3 / 60, l - ae.timestamp), ae.timestamp = l, ae.isProcessing = !0, Qn.update.process(ae), Qn.preRender.process(ae), Qn.render.process(ae), ae.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, wi.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(ag), this.sharedNodes.forEach(hg);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, q.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      q.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !de(this.snapshot.measuredBox.x) && !de(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let c = 0; c < this.path.length; c++)
          this.path[c].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutCorrected = ne(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: l } = this.options;
      l && l.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let l = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (l = !1), l && this.instance) {
        const c = r(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: c,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : c
        };
      }
    }
    resetTransform() {
      if (!s)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, l = this.projectionDelta && !Hl(this.projectionDelta), c = this.getTransformTemplate(), u = c ? c(this.latestValues, "") : void 0, d = u !== this.prevTransformTemplateValue;
      o && this.instance && (l || Je(this.latestValues) || d) && (s(this.instance, u), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const l = this.measurePageBox();
      let c = this.removeElementScroll(l);
      return o && (c = this.removeTransform(c)), gg(c), {
        animationId: this.root.animationId,
        measuredBox: l,
        layoutBox: c,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      var u;
      const { visualElement: o } = this.options;
      if (!o)
        return ne();
      const l = o.measureViewportBox();
      if (!(((u = this.scroll) == null ? void 0 : u.wasRoot) || this.path.some(yg))) {
        const { scroll: d } = this.root;
        d && (pt(l.x, d.offset.x), pt(l.y, d.offset.y));
      }
      return l;
    }
    removeElementScroll(o) {
      var c;
      const l = ne();
      if (ye(l, o), (c = this.scroll) != null && c.wasRoot)
        return l;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u], { scroll: h, options: f } = d;
        d !== this.root && h && f.layoutScroll && (h.wasRoot && ye(l, o), pt(l.x, h.offset.x), pt(l.y, h.offset.y));
      }
      return l;
    }
    applyTransform(o, l = !1) {
      const c = ne();
      ye(c, o);
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        !l && d.options.layoutScroll && d.scroll && d !== d.root && gt(c, {
          x: -d.scroll.offset.x,
          y: -d.scroll.offset.y
        }), Je(d.latestValues) && gt(c, d.latestValues);
      }
      return Je(this.latestValues) && gt(c, this.latestValues), c;
    }
    removeTransform(o) {
      const l = ne();
      ye(l, o);
      for (let c = 0; c < this.path.length; c++) {
        const u = this.path[c];
        if (!u.instance || !Je(u.latestValues))
          continue;
        Lr(u.latestValues) && u.updateSnapshot();
        const d = ne(), h = u.measurePageBox();
        ye(d, h), ho(l, u.latestValues, u.snapshot ? u.snapshot.layoutBox : void 0, d);
      }
      return Je(this.latestValues) && ho(l, this.latestValues), l;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== ae.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      var f;
      const l = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = l.isSharedProjectionDirty);
      const c = !!this.resumingFrom || this !== l;
      if (!(o || c && this.isSharedProjectionDirty || this.isProjectionDirty || (f = this.parent) != null && f.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: d, layoutId: h } = this.options;
      if (!(!this.layout || !(d || h))) {
        if (this.resolvedRelativeTargetAt = ae.timestamp, !this.targetDelta && !this.relativeTarget) {
          const g = this.getClosestProjectingParent();
          g && g.layout && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ne(), this.relativeTargetOrigin = ne(), zt(this.relativeTargetOrigin, this.layout.layoutBox, g.layout.layoutBox), ye(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
        if (!(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = ne(), this.targetWithTransforms = ne()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), Np(this.target, this.relativeTarget, this.relativeParent.target)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : ye(this.target, this.layout.layoutBox), Sl(this.target, this.targetDelta)) : ye(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget)) {
          this.attemptToResolveRelativeTarget = !1;
          const g = this.getClosestProjectingParent();
          g && !!g.resumingFrom == !!this.resumingFrom && !g.options.layoutScroll && g.target && this.animationProgress !== 1 ? (this.relativeParent = g, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ne(), this.relativeTargetOrigin = ne(), zt(this.relativeTargetOrigin, this.target, g.target), ye(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0;
        }
      }
    }
    getClosestProjectingParent() {
      if (!(!this.parent || Lr(this.parent.latestValues) || Nl(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    calcProjection() {
      var y;
      const o = this.getLead(), l = !!this.resumingFrom || this !== o;
      let c = !0;
      if ((this.isProjectionDirty || (y = this.parent) != null && y.isProjectionDirty) && (c = !1), l && (this.isSharedProjectionDirty || this.isTransformDirty) && (c = !1), this.resolvedRelativeTargetAt === ae.timestamp && (c = !1), c)
        return;
      const { layout: u, layoutId: d } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(u || d))
        return;
      ye(this.layoutCorrected, this.layout.layoutBox);
      const h = this.treeScale.x, f = this.treeScale.y;
      Bm(this.layoutCorrected, this.treeScale, this.path, l), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = ne());
      const { target: g } = o;
      if (!g) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (lo(this.prevProjectionDelta.x, this.projectionDelta.x), lo(this.prevProjectionDelta.y, this.projectionDelta.y)), Ft(this.projectionDelta, this.layoutCorrected, g, this.latestValues), (this.treeScale.x !== h || this.treeScale.y !== f || !yo(this.projectionDelta.x, this.prevProjectionDelta.x) || !yo(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      var l;
      if ((l = this.options.visualElement) == null || l.scheduleRender(), o) {
        const c = this.getStack();
        c && c.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = yt(), this.projectionDelta = yt(), this.projectionDeltaWithTransform = yt();
    }
    setAnimationOrigin(o, l = !1) {
      const c = this.snapshot, u = c ? c.latestValues : {}, d = { ...this.latestValues }, h = yt();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !l;
      const f = ne(), g = c ? c.source : void 0, y = this.layout ? this.layout.source : void 0, v = g !== y, x = this.getStack(), b = !x || x.members.length <= 1, w = !!(v && !b && this.options.crossfade === !0 && !this.path.some(mg));
      this.animationProgress = 0;
      let k;
      this.mixTargetDelta = (N) => {
        const T = N / 1e3;
        wo(h.x, o.x, T), wo(h.y, o.y, T), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (zt(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox), fg(this.relativeTarget, this.relativeTargetOrigin, f, T), k && Jp(this.relativeTarget, k) && (this.isProjectionDirty = !1), k || (k = ne()), ye(k, this.relativeTarget)), v && (this.animationValues = d, Gp(d, u, this.latestValues, T, w, b)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = T;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      var l, c, u;
      this.notifyListeners("animationStart"), (l = this.currentAnimation) == null || l.stop(), (u = (c = this.resumingFrom) == null ? void 0 : c.currentAnimation) == null || u.stop(), this.pendingAnimation && (Oe(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = q.update(() => {
        Tn.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = wt(0)), this.currentAnimation = Op(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (d) => {
            this.mixTargetDelta(d), o.onUpdate && o.onUpdate(d);
          },
          onStop: () => {
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(tg), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: l, target: c, layout: u, latestValues: d } = o;
      if (!(!l || !c || !u)) {
        if (this !== o && this.layout && u && Kl(this.options.animationType, this.layout.layoutBox, u.layoutBox)) {
          c = this.target || ne();
          const h = de(this.layout.layoutBox.x);
          c.x.min = o.target.x.min, c.x.max = c.x.min + h;
          const f = de(this.layout.layoutBox.y);
          c.y.min = o.target.y.min, c.y.max = c.y.min + f;
        }
        ye(l, c), gt(l, d), Ft(this.projectionDeltaWithTransform, this.layoutCorrected, l, d);
      }
    }
    registerSharedNode(o, l) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new Qp()), this.sharedNodes.get(o).add(l);
      const u = l.options.initialPromotionConfig;
      l.promote({
        transition: u ? u.transition : void 0,
        preserveFollowOpacity: u && u.shouldPreserveFollowOpacity ? u.shouldPreserveFollowOpacity(l) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      var l;
      const { layoutId: o } = this.options;
      return o ? ((l = this.getStack()) == null ? void 0 : l.lead) || this : this;
    }
    getPrevLead() {
      var l;
      const { layoutId: o } = this.options;
      return o ? (l = this.getStack()) == null ? void 0 : l.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: l, preserveFollowOpacity: c } = {}) {
      const u = this.getStack();
      u && u.promote(this, c), o && (this.projectionDelta = void 0, this.needsReset = !0), l && this.setOptions({ transition: l });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let l = !1;
      const { latestValues: c } = o;
      if ((c.z || c.rotate || c.rotateX || c.rotateY || c.rotateZ || c.skewX || c.skewY) && (l = !0), !l)
        return;
      const u = {};
      c.z && ur("z", o, u, this.animationValues);
      for (let d = 0; d < dr.length; d++)
        ur(`rotate${dr[d]}`, o, u, this.animationValues), ur(`skew${dr[d]}`, o, u, this.animationValues);
      o.render();
      for (const d in u)
        o.setStaticValue(d, u[d]), this.animationValues && (this.animationValues[d] = u[d]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, l) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const c = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = Sn(l == null ? void 0 : l.pointerEvents) || "", o.transform = c ? c(this.latestValues, "") : "none";
        return;
      }
      const u = this.getLead();
      if (!this.projectionDelta || !this.layout || !u.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = Sn(l == null ? void 0 : l.pointerEvents) || ""), this.hasProjected && !Je(this.latestValues) && (o.transform = c ? c({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const d = u.animationValues || u.latestValues;
      this.applyTransformsToTarget();
      let h = eg(this.projectionDeltaWithTransform, this.treeScale, d);
      c && (h = c(d, h)), o.transform = h;
      const { x: f, y: g } = this.projectionDelta;
      o.transformOrigin = `${f.origin * 100}% ${g.origin * 100}% 0`, u.animationValues ? o.opacity = u === this ? d.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : d.opacityExit : o.opacity = u === this ? d.opacity !== void 0 ? d.opacity : "" : d.opacityExit !== void 0 ? d.opacityExit : 0;
      for (const y in Xt) {
        if (d[y] === void 0)
          continue;
        const { correct: v, applyTo: x, isCSSVariable: b } = Xt[y], w = h === "none" ? d[y] : v(d[y], u);
        if (x) {
          const k = x.length;
          for (let N = 0; N < k; N++)
            o[x[N]] = w;
        } else
          b ? this.options.visualElement.renderState.vars[y] = w : o[y] = w;
      }
      this.options.layoutId && (o.pointerEvents = u === this ? Sn(l == null ? void 0 : l.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => {
        var l;
        return (l = o.currentAnimation) == null ? void 0 : l.stop();
      }), this.root.nodes.forEach(vo), this.root.sharedNodes.clear();
    }
  };
}
function rg(e) {
  e.updateLayout();
}
function ig(e) {
  var n;
  const t = ((n = e.resumeFrom) == null ? void 0 : n.snapshot) || e.snapshot;
  if (e.isLead() && e.layout && t && e.hasListeners("didUpdate")) {
    const { layoutBox: r, measuredBox: s } = e.layout, { animationType: a } = e.options, o = t.source !== e.layout.source;
    a === "size" ? ve((h) => {
      const f = o ? t.measuredBox[h] : t.layoutBox[h], g = de(f);
      f.min = r[h].min, f.max = f.min + g;
    }) : Kl(a, t.layoutBox, r) && ve((h) => {
      const f = o ? t.measuredBox[h] : t.layoutBox[h], g = de(r[h]);
      f.max = f.min + g, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[h].max = e.relativeTarget[h].min + g);
    });
    const l = yt();
    Ft(l, r, t.layoutBox);
    const c = yt();
    o ? Ft(c, e.applyTransform(s, !0), t.measuredBox) : Ft(c, r, t.layoutBox);
    const u = !Hl(l);
    let d = !1;
    if (!e.resumeFrom) {
      const h = e.getClosestProjectingParent();
      if (h && !h.resumeFrom) {
        const { snapshot: f, layout: g } = h;
        if (f && g) {
          const y = ne();
          zt(y, t.layoutBox, f.layoutBox);
          const v = ne();
          zt(v, r, g.layoutBox), Ul(y, v) || (d = !0), h.options.layoutRoot && (e.relativeTarget = v, e.relativeTargetOrigin = y, e.relativeParent = h);
        }
      }
    }
    e.notifyListeners("didUpdate", {
      layout: r,
      snapshot: t,
      delta: c,
      layoutDelta: l,
      hasLayoutChanged: u,
      hasRelativeLayoutChanged: d
    });
  } else if (e.isLead()) {
    const { onExitComplete: r } = e.options;
    r && r();
  }
  e.options.transition = void 0;
}
function sg(e) {
  e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty));
}
function og(e) {
  e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1;
}
function ag(e) {
  e.clearSnapshot();
}
function vo(e) {
  e.clearMeasurements();
}
function bo(e) {
  e.isLayoutDirty = !1;
}
function lg(e) {
  const { visualElement: t } = e.options;
  t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform();
}
function xo(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0;
}
function cg(e) {
  e.resolveTargetDelta();
}
function dg(e) {
  e.calcProjection();
}
function ug(e) {
  e.resetSkewAndRotation();
}
function hg(e) {
  e.removeLeadSnapshot();
}
function wo(e, t, n) {
  e.translate = Q(t.translate, 0, n), e.scale = Q(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function ko(e, t, n, r) {
  e.min = Q(t.min, n.min, r), e.max = Q(t.max, n.max, r);
}
function fg(e, t, n, r) {
  ko(e.x, t.x, n.x, r), ko(e.y, t.y, n.y, r);
}
function mg(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
const pg = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, No = (e) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e), So = No("applewebkit/") && !No("chrome/") ? Math.round : xe;
function To(e) {
  e.min = So(e.min), e.max = So(e.max);
}
function gg(e) {
  To(e.x), To(e.y);
}
function Kl(e, t, n) {
  return e === "position" || e === "preserve-aspect" && !kp(go(t), go(n), 0.2);
}
function yg(e) {
  var t;
  return e !== e.root && ((t = e.scroll) == null ? void 0 : t.wasRoot);
}
const vg = Gl({
  attachResizeListener: (e, t) => Yt(e, "resize", t),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body.scrollLeft,
    y: document.documentElement.scrollTop || document.body.scrollTop
  }),
  checkIsScrollRoot: () => !0
}), hr = {
  current: void 0
}, Xl = Gl({
  measureScroll: (e) => ({
    x: e.scrollLeft,
    y: e.scrollTop
  }),
  defaultParent: () => {
    if (!hr.current) {
      const e = new vg({});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), hr.current = e;
    }
    return hr.current;
  },
  resetTransform: (e, t) => {
    e.style.transform = t !== void 0 ? t : "none";
  },
  checkIsScrollRoot: (e) => window.getComputedStyle(e).position === "fixed"
}), bg = {
  pan: {
    Feature: Fp
  },
  drag: {
    Feature: Bp,
    ProjectionNode: Xl,
    MeasureLayout: _l
  }
};
function Co(e, t, n) {
  const { props: r } = e;
  e.animationState && r.whileHover && e.animationState.setActive("whileHover", n === "Start");
  const s = "onHover" + n, a = r[s];
  a && q.postRender(() => a(t, en(t)));
}
class xg extends He {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = Kf(t, (n, r) => (Co(this.node, r, "Start"), (s) => Co(this.node, s, "End"))));
  }
  unmount() {
  }
}
class wg extends He {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let t = !1;
    try {
      t = this.node.current.matches(":focus-visible");
    } catch {
      t = !0;
    }
    !t || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = qt(Yt(this.node.current, "focus", () => this.onFocus()), Yt(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function Po(e, t, n) {
  const { props: r } = e;
  if (e.current instanceof HTMLButtonElement && e.current.disabled)
    return;
  e.animationState && r.whileTap && e.animationState.setActive("whileTap", n === "Start");
  const s = "onTap" + (n === "End" ? "" : n), a = r[s];
  a && q.postRender(() => a(t, en(t)));
}
class kg extends He {
  mount() {
    const { current: t } = this.node;
    t && (this.unmount = qf(t, (n, r) => (Po(this.node, r, "Start"), (s, { success: a }) => Po(this.node, s, a ? "End" : "Cancel")), { useGlobalTarget: this.node.props.globalTapTarget }));
  }
  unmount() {
  }
}
const Or = /* @__PURE__ */ new WeakMap(), fr = /* @__PURE__ */ new WeakMap(), Ng = (e) => {
  const t = Or.get(e.target);
  t && t(e);
}, Sg = (e) => {
  e.forEach(Ng);
};
function Tg({ root: e, ...t }) {
  const n = e || document;
  fr.has(n) || fr.set(n, {});
  const r = fr.get(n), s = JSON.stringify(t);
  return r[s] || (r[s] = new IntersectionObserver(Sg, { root: e, ...t })), r[s];
}
function Cg(e, t, n) {
  const r = Tg(t);
  return Or.set(e, n), r.observe(e), () => {
    Or.delete(e), r.unobserve(e);
  };
}
const Pg = {
  some: 0,
  all: 1
};
class Mg extends He {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.unmount();
    const { viewport: t = {} } = this.node.getProps(), { root: n, margin: r, amount: s = "some", once: a } = t, o = {
      root: n ? n.current : void 0,
      rootMargin: r,
      threshold: typeof s == "number" ? s : Pg[s]
    }, l = (c) => {
      const { isIntersecting: u } = c;
      if (this.isInView === u || (this.isInView = u, a && !u && this.hasEnteredView))
        return;
      u && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", u);
      const { onViewportEnter: d, onViewportLeave: h } = this.node.getProps(), f = u ? d : h;
      f && f(c);
    };
    return Cg(this.node.current, o, l);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: t, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(Dg(t, n)) && this.startObserver();
  }
  unmount() {
  }
}
function Dg({ viewport: e = {} }, { viewport: t = {} } = {}) {
  return (n) => e[n] !== t[n];
}
const Ig = {
  inView: {
    Feature: Mg
  },
  tap: {
    Feature: kg
  },
  focus: {
    Feature: wg
  },
  hover: {
    Feature: xg
  }
}, Ag = {
  layout: {
    ProjectionNode: Xl,
    MeasureLayout: _l
  }
}, Vg = {
  ...gp,
  ...Ig,
  ...bg,
  ...Ag
}, Yl = /* @__PURE__ */ Em(Vg, Wm);
function Eg() {
  !Ai.current && Cl();
  const [e] = se(Vn.current);
  return process.env.NODE_ENV !== "production" && Fn(e !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), e;
}
function Rg({ children: e }) {
  return /* @__PURE__ */ i("div", { className: "flex flex-col items-center justify-between w-full", children: e });
}
function Lg({
  onRefetch: e,
  filterRevealComponent: t,
  hasExpandableRows: n = !1,
  showMyRecords: r = !1,
  onToggleMyRecords: s,
  isFilterPanelVisible: a,
  expandedRows: o,
  onCollapseAllRows: l,
  onSearch: c,
  onClear: u,
  searchLabel: d = "Search",
  clearLabel: h = "Clear",
  additionalActions: f
}) {
  const [g] = se(!0), y = a ?? g, v = j((N) => N.isTunecore), x = o !== void 0 && Object.keys(o).length > 0;
  return /* @__PURE__ */ i(ce, { children: /* @__PURE__ */ i("div", { className: "flex flex-row items-center justify-between w-full", children: /* @__PURE__ */ i("div", { className: "flex flex-row w-full", children: /* @__PURE__ */ i(Fg, { isVisible: y, isTunecore: v, children: /* @__PURE__ */ p(
    "form",
    {
      className: "flex flex-col gap-4 p-2",
      onSubmit: (N) => {
        N.preventDefault(), c == null || c();
      },
      children: [
        /* @__PURE__ */ i("div", { className: "grid items-start flex-1 min-w-0 gap-4 px-4 grid-cols-[repeat(auto-fit,minmax(200px,1fr))]", children: t }),
        (!!s || !!e || n && x && !!l || !!f || (!!u || !!c)) && /* @__PURE__ */ p("div", { className: "flex flex-row items-center self-center gap-2 w-min", children: [
          s != null && /* @__PURE__ */ i(
            $,
            {
              type: "button",
              label: r ? /* @__PURE__ */ i(bd, { size: "md", className: v ? "stroke-white" : "stroke-ink-primary" }) : /* @__PURE__ */ i(vd, { size: "md", className: v ? "stroke-white" : "stroke-ink-primary" }),
              onClick: () => s(!r),
              tooltip: !0,
              tooltipText: r ? "Show All Records" : "Show My Records",
              variant: v ? "primary" : "iconAction",
              className: m(v && "p-2 bg-layer-raised")
            }
          ),
          e != null && /* @__PURE__ */ i(
            $,
            {
              type: "button",
              label: /* @__PURE__ */ i(fd, { size: "md", className: v ? "stroke-white" : "stroke-ink-primary" }),
              tooltip: !0,
              tooltipText: "Refetch Data",
              onClick: e,
              variant: v ? "primary" : "iconAction",
              className: m(v && "p-2 bg-layer-raised")
            }
          ),
          n && x && l != null && /* @__PURE__ */ i(
            $,
            {
              type: "button",
              label: /* @__PURE__ */ i(Et, { size: "md", className: m("rotate-180", v ? "stroke-white" : "stroke-ink-primary") }),
              tooltip: !0,
              tooltipText: "Collapse All Table Rows",
              variant: v ? "primary" : "iconAction",
              onClick: l,
              className: m(v && "p-2 bg-layer-raised")
            }
          ),
          f,
          u != null && /* @__PURE__ */ i(
            $,
            {
              type: "button",
              label: h,
              onClick: u,
              variant: "secondary"
            }
          ),
          c != null && /* @__PURE__ */ i(
            $,
            {
              type: "submit",
              label: d,
              variant: "primary"
            }
          )
        ] })
      ]
    }
  ) }) }) }) });
}
const Bg = {
  open: {
    height: "auto",
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 700,
      damping: 45,
      duration: 0.15
    }
  },
  closed: {
    height: 0,
    opacity: 0,
    transition: {
      type: "spring",
      stiffness: 700,
      damping: 45,
      duration: 0.15
    }
  }
};
function Fg({ children: e, isVisible: t, isTunecore: n = !1 }) {
  return /* @__PURE__ */ i(
    Yl.div,
    {
      initial: t ? "open" : "closed",
      animate: t ? "open" : "closed",
      variants: Bg,
      className: "w-full overflow-hidden",
      children: /* @__PURE__ */ i("div", { className: m("flex flex-col w-full gap-4", n ? "bg-layer-inverse" : "bg-layer-default"), children: e })
    }
  );
}
const Zl = [10, 25, 50, 100, 250, 500];
function ql(e, t) {
  const [n, r] = se(""), s = e.getState().pagination.pageIndex + 1, a = e.getState().pagination.pageSize, o = e.getPageCount(), l = typeof o == "number" && o > 0, c = l ? o : 1;
  return {
    currentPage: s,
    currentPageSize: a,
    effectivePageCount: c,
    controlsDisabled: t || !l,
    jumpToPage: n,
    setJumpToPage: r,
    commitJumpToPage: () => {
      const h = Number(n);
      Number.isInteger(h) && h >= 1 && h <= c && e.setPageIndex(h - 1), r("");
    },
    changePageSize: (h) => {
      const f = Number(h);
      setTimeout(() => {
        e.setPageSize(f);
      }, 0);
    }
  };
}
function Mo({ table: e, isLoading: t = !1 }) {
  const n = j((y) => y.isTunecore), r = $r(), {
    currentPage: s,
    currentPageSize: a,
    effectivePageCount: o,
    controlsDisabled: l,
    jumpToPage: c,
    setJumpToPage: u,
    commitJumpToPage: d,
    changePageSize: h
  } = ql(e, t), f = n ? "secondary" : "iconAction", g = n ? "stroke-white" : "stroke-ink-primary";
  return /* @__PURE__ */ p(
    "nav",
    {
      "aria-label": "Table pagination, bottom",
      "data-slot": "table-pagination",
      className: "relative z-10 flex flex-col items-center justify-between w-full gap-2 mt-2 sm:flex-row",
      children: [
        /* @__PURE__ */ i("div", { className: "p-1", children: /* @__PURE__ */ p(
          da,
          {
            value: String(a),
            onValueChange: h,
            disabled: t,
            children: [
              /* @__PURE__ */ i(Jr, { className: "w-auto", children: /* @__PURE__ */ i(ua, { placeholder: `Show ${a} rows` }) }),
              /* @__PURE__ */ i(Qr, { children: Zl.map((y) => /* @__PURE__ */ p(ei, { value: String(y), children: [
                "Show",
                " ",
                y,
                " ",
                "rows"
              ] }, y)) })
            ]
          }
        ) }),
        /* @__PURE__ */ p("div", { className: "flex flex-col items-center gap-2 sm:flex-row", children: [
          /* @__PURE__ */ p(
            "div",
            {
              className: m(
                "flex h-8 items-center gap-1 whitespace-nowrap text-ink-primary",
                n ? "font-tunecore" : "font-sentric-alt",
                l && "opacity-60"
              ),
              children: [
                /* @__PURE__ */ i(W, { as: "bodySm", children: "Page" }),
                /* @__PURE__ */ i("label", { htmlFor: r, className: "sr-only", children: "Go to page" }),
                /* @__PURE__ */ i(
                  "input",
                  {
                    id: r,
                    type: "number",
                    min: 1,
                    max: o,
                    step: 1,
                    value: c,
                    onChange: (y) => u(y.target.value),
                    onKeyDown: (y) => {
                      y.key === "Enter" && d();
                    },
                    placeholder: String(s),
                    disabled: l,
                    className: m(
                      "h-8 w-10 rounded-sm border px-1 text-center text-xs outline-none transition-all disabled:cursor-not-allowed disabled:opacity-40 sm:text-sm",
                      "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                      n ? "font-tunecore border-stroke-subtle" : "font-sentric-alt border-stroke-heavy",
                      "bg-layer-default text-ink-primary placeholder:text-ink-secondary focus:border-stroke-primary"
                    )
                  }
                ),
                /* @__PURE__ */ p(W, { as: "bodySm", children: [
                  "of",
                  " ",
                  o.toLocaleString()
                ] })
              ]
            }
          ),
          /* @__PURE__ */ p("div", { className: "flex gap-2 mr-2", children: [
            /* @__PURE__ */ i(
              $,
              {
                variant: f,
                onClick: () => e.firstPage(),
                disabled: l || e.getCanPreviousPage() === !1,
                "aria-label": "Go to first page",
                label: /* @__PURE__ */ i(sd, { size: "md", className: g })
              }
            ),
            /* @__PURE__ */ i(
              $,
              {
                variant: f,
                onClick: () => e.previousPage(),
                disabled: l || e.getCanPreviousPage() === !1,
                "aria-label": "Go to previous page",
                label: /* @__PURE__ */ i(ld, { size: "md", className: g })
              }
            ),
            /* @__PURE__ */ i(
              $,
              {
                variant: f,
                onClick: () => e.nextPage(),
                disabled: l || e.getCanNextPage() === !1,
                "aria-label": "Go to next page",
                label: /* @__PURE__ */ i(ad, { size: "md", className: g })
              }
            ),
            /* @__PURE__ */ i(
              $,
              {
                variant: f,
                onClick: () => e.lastPage(),
                disabled: l || e.getCanNextPage() === !1,
                "aria-label": "Go to last page",
                label: /* @__PURE__ */ i(od, { size: "md", className: g })
              }
            )
          ] })
        ] })
      ]
    }
  );
}
const zg = ["w-3/4", "w-1/2", "w-2/3"], jg = Array.from({ length: 20 }, (e, t) => `skeleton-row-${t}`);
function _g({
  visibleColumns: e,
  rowCount: t = 5,
  density: n = "roomy"
}) {
  return /* @__PURE__ */ i(ce, { children: jg.slice(0, t).map((r, s) => /* @__PURE__ */ i("tr", { className: Me[n].rowHeight, children: e.map((a, o) => /* @__PURE__ */ i("td", { className: Me[n].cellPadding, children: /* @__PURE__ */ i(Yu, { className: m("h-4", zg[(s + o) % 3]) }) }, a.id)) }, r)) });
}
function Og({ table: e, isLoading: t = !1 }) {
  const n = j((f) => f.isTunecore), r = $r(), {
    currentPage: s,
    currentPageSize: a,
    effectivePageCount: o,
    controlsDisabled: l,
    jumpToPage: c,
    setJumpToPage: u,
    commitJumpToPage: d,
    changePageSize: h
  } = ql(e, t);
  return /* @__PURE__ */ p(
    "nav",
    {
      "aria-label": "Table pagination, top",
      "data-slot": "table-top-pagination",
      className: "flex flex-wrap items-center justify-end gap-2 sm:gap-3",
      children: [
        /* @__PURE__ */ p(da, { value: String(a), onValueChange: h, disabled: t, children: [
          /* @__PURE__ */ i(Jr, { customWidth: !0, smallFont: !0, className: "hidden min-w-35 bg-layer-default lg:flex", children: /* @__PURE__ */ i(ua, { placeholder: `Show ${a} rows` }) }),
          /* @__PURE__ */ i(Qr, { children: Zl.map((f) => /* @__PURE__ */ p(ei, { value: String(f), children: [
            "Show",
            " ",
            f,
            " ",
            "rows"
          ] }, f)) })
        ] }),
        /* @__PURE__ */ p(
          "div",
          {
            className: m(
              "flex h-8 items-center gap-1 whitespace-nowrap text-ink-primary",
              n ? "font-tunecore" : "font-sentric-alt",
              l && "opacity-60"
            ),
            children: [
              /* @__PURE__ */ i(W, { as: "bodySm", children: "Page" }),
              /* @__PURE__ */ i("label", { htmlFor: r, className: "sr-only", children: "Go to page" }),
              /* @__PURE__ */ i(
                "input",
                {
                  id: r,
                  type: "number",
                  min: 1,
                  max: o,
                  step: 1,
                  value: c,
                  onChange: (f) => u(f.target.value),
                  onKeyDown: (f) => {
                    f.key === "Enter" && d();
                  },
                  placeholder: String(s),
                  disabled: l,
                  className: m(
                    "h-8 w-10 rounded-sm border px-1 text-center text-xs outline-none transition-all disabled:cursor-not-allowed disabled:opacity-40 sm:text-sm",
                    "[appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none",
                    n ? "border-stroke-subtle" : "border-stroke-heavy",
                    "bg-layer-default text-ink-primary placeholder:text-ink-secondary focus:border-stroke-primary"
                  )
                }
              ),
              /* @__PURE__ */ p(W, { as: "bodySm", children: [
                "of",
                " ",
                o.toLocaleString()
              ] })
            ]
          }
        ),
        /* @__PURE__ */ p("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ i(
            $,
            {
              type: "button",
              "aria-label": "Go to previous page",
              onClick: () => e.previousPage(),
              disabled: l || e.getCanPreviousPage() === !1,
              variant: "iconAction",
              label: /* @__PURE__ */ i(Ur, { size: "md", className: "stroke-ink-primary" })
            }
          ),
          /* @__PURE__ */ i(
            $,
            {
              type: "button",
              "aria-label": "Go to next page",
              onClick: () => e.nextPage(),
              disabled: l || e.getCanNextPage() === !1,
              variant: "iconAction",
              label: /* @__PURE__ */ i(Wr, { size: "md", className: "stroke-ink-primary" })
            }
          )
        ] })
      ]
    }
  );
}
const Me = {
  roomy: {
    rowHeight: "h-12",
    cellPadding: "py-2 px-3",
    fontSize: "text-lg"
  },
  compact: {
    rowHeight: "h-12",
    cellPadding: "py-2 px-3",
    fontSize: "text-xs"
  },
  condensed: {
    rowHeight: "h-10",
    fontSize: "text-lg",
    cellPadding: "py-1 px-2"
  },
  expanded: {
    rowHeight: "h-10 max-h-24",
    cellPadding: "p-4",
    fontSize: "text-xs"
  }
}, Do = {
  roomy: 56,
  compact: 48,
  condensed: 40,
  expanded: 56
}, $g = [], Hg = () => null, Ug = () => !1;
function Wg() {
}
const Gg = () => !1;
function Jl(e) {
  return e.column.columnDef.meta ?? {};
}
function Kg(e) {
  return e ?? {};
}
function Xg(e, t, n) {
  return e ? m(
    "[--fade-color-solid:var(--color-layer-inverse)]",
    "even:[--fade-color-solid:var(--color-layer-raised)]",
    t && "[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]",
    t && "even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]",
    n && "hover:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]",
    n && "hover:even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-inverse))]"
  ) : m(
    t ? [
      "[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]",
      "even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]"
    ] : [
      "[--fade-color-solid:var(--color-layer-default)]",
      "even:[--fade-color-solid:var(--color-layer-raised)]"
    ],
    n && "hover:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]",
    n && "hover:even:[--fade-color-solid:color-mix(in_srgb,var(--color-ink-secondary)_50%,var(--color-layer-default))]"
  );
}
function Yg(e) {
  if (e == null)
    return null;
  const t = String(e);
  return t === "" ? null : t;
}
function mr({ cell: e, isTunecore: t, className: n }) {
  const {
    copyable: r = !1,
    getCopyValue: s,
    copyTooltipText: a = "Copy",
    copySuccessText: o = "Copied to clipboard",
    copyErrorText: l = "Failed to copy to clipboard"
  } = Jl(e);
  if (!r)
    return null;
  const c = e.getValue(), u = Yg(
    (s == null ? void 0 : s(e)) ?? (typeof c == "string" || typeof c == "number" || typeof c == "boolean" ? c : null)
  );
  if (u == null)
    return null;
  const d = async (h) => {
    var f;
    h.preventDefault(), h.stopPropagation();
    try {
      if (typeof navigator > "u" || ((f = navigator.clipboard) == null ? void 0 : f.writeText) == null)
        throw new Error("Clipboard API unavailable");
      await navigator.clipboard.writeText(u), as.success(o);
    } catch {
      as.error(l);
    }
  };
  return /* @__PURE__ */ i(_t, { children: /* @__PURE__ */ p(Ot, { delayDuration: 200, children: [
    /* @__PURE__ */ i($t, { asChild: !0, children: /* @__PURE__ */ i(
      "button",
      {
        type: "button",
        "aria-label": a,
        className: m(
          n,
          "copy-cell-btn z-10 flex h-6 w-6 shrink-0 items-center justify-center opacity-0 transition-opacity duration-150 focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stroke-primary group-hover:opacity-100"
        ),
        onMouseDown: (h) => h.stopPropagation(),
        onClick: (h) => {
          d(h);
        },
        children: /* @__PURE__ */ i(
          kd,
          {
            className: m(
              "h-3.5 w-3.5",
              t ? "stroke-white" : "stroke-ink-primary dark:stroke-white"
            )
          }
        )
      }
    ) }),
    /* @__PURE__ */ i(xt, { side: "top", children: /* @__PURE__ */ i(W, { className: "max-w-72", children: a }) })
  ] }) });
}
function Zg({
  row: e,
  isExpanded: t,
  density: n,
  isTunecore: r,
  enableVirtualization: s,
  virtualStart: a,
  virtualSize: o,
  getRowCanExpand: l,
  isRowClickable: c,
  onRowClick: u,
  renderSubComponent: d,
  handleMouseDown: h,
  handleMouseUp: f,
  isTextSelectedRef: g,
  rowOriginalsSignature: y,
  darkMode: v = !0,
  enableColumnResizing: x = !0,
  hasPinnedActionFade: b = !0
}) {
  const w = l(e), k = c(e.original), N = k, T = e.index % 2 === 1, M = K.useMemo(() => {
    if (k)
      return () => {
        g.current || u(e.original), g.current = !1;
      };
  }, [k, e, u, g]);
  return /* @__PURE__ */ p(K.Fragment, { children: [
    /* @__PURE__ */ i(
      "tr",
      {
        onMouseDown: h,
        onMouseUp: f,
        onClick: M,
        className: m(
          "even:bg-layer-raised",
          t && "bg-ink-secondary/50!",
          b && Xg(r, t, N),
          Me[n].rowHeight,
          N && "cursor-pointer hover:bg-ink-secondary/50 even:hover:bg-ink-secondary/50",
          s && "absolute w-full block"
        ),
        style: s ? {
          transform: `translateY(${a}px)`,
          height: `${o}px`
        } : void 0,
        children: e.getVisibleCells().map((C) => {
          const D = C.column.getIsPinned(), A = Jl(C), E = A.pinnedBackground, R = !!D && !E && A.pinnedActionFade !== !1;
          return /* @__PURE__ */ i(
            "td",
            {
              className: m(
                "group relative",
                "text-xs md:text-sm font-sentric-alt",
                r ? "text-white stroke-white" : t ? v ? "transition-colors duration-300 ease-in-out text-ink-primary stroke-ink-primary" : "transition-colors duration-500 ease-out text-ink-primary stroke-ink-primary" : "text-ink-primary stroke-ink-primary",
                R ? "p-0" : Me[n].cellPadding,
                D === "left" && "sticky left-0 z-15",
                D === "right" && "sticky right-0 z-15",
                !!D && !!E && (r ? "bg-layer-inverse" : "bg-layer-default"),
                // pinnedActionFade cells own their own colour via --fade-color-solid.
                !!D && t && !R && "bg-ink-secondary/50",
                x && C.column.getCanResize() && "overflow-hidden"
              ),
              style: {
                width: C.column.getSize(),
                minWidth: x && C.column.getCanResize() ? void 0 : C.column.columnDef.minSize,
                maxWidth: C.column.columnDef.maxSize,
                left: D === "left" ? `${C.column.getStart()}px` : void 0,
                right: D === "right" ? `${C.column.getAfter()}px` : void 0
              },
              children: R ? (
                // --fade-color-solid is set on the <tr> (getActionFadeVarClasses) and
                // inherits down here via CSS custom property inheritance.
                // Stops propagation so the gradient's empty space (and any padding not
                // already covered by the consumer's own cell content) can't bubble up
                // to the row's onClick/onMouseDown and trigger navigation or expand.
                /* @__PURE__ */ i(
                  "div",
                  {
                    className: "relative z-10 flex h-full w-full",
                    onClick: (B) => B.stopPropagation(),
                    onMouseDown: (B) => B.stopPropagation(),
                    children: D === "left" ? /* @__PURE__ */ p(ce, { children: [
                      /* @__PURE__ */ p("div", { className: "flex w-fit shrink-0 items-center gap-2 px-2 bg-(--fade-color-solid)", children: [
                        Vt(C.column.columnDef.cell, C.getContext()),
                        /* @__PURE__ */ i(mr, { cell: C, isTunecore: r, className: "" })
                      ] }),
                      /* @__PURE__ */ i("div", { className: "flex-1 bg-[linear-gradient(90deg,var(--fade-color-solid)_0%,color-mix(in_srgb,var(--fade-color-solid)_75%,transparent)_18%,color-mix(in_srgb,var(--fade-color-solid)_30%,transparent)_45%,transparent_100%)]" })
                    ] }) : /* @__PURE__ */ p(ce, { children: [
                      /* @__PURE__ */ i("div", { className: "flex-1 bg-[linear-gradient(90deg,transparent_0%,color-mix(in_srgb,var(--fade-color-solid)_30%,transparent)_55%,color-mix(in_srgb,var(--fade-color-solid)_75%,transparent)_82%,var(--fade-color-solid)_100%)]" }),
                      /* @__PURE__ */ p("div", { className: "flex w-fit shrink-0 items-center gap-2 px-2 bg-(--fade-color-solid)", children: [
                        Vt(C.column.columnDef.cell, C.getContext()),
                        /* @__PURE__ */ i(mr, { cell: C, isTunecore: r, className: "" })
                      ] })
                    ] })
                  }
                )
              ) : /* @__PURE__ */ p(
                "span",
                {
                  className: m(
                    // copy to clipboard border styles over text in cell
                    "inline-flex w-full max-w-full items-center gap-2 rounded-md px-1.5 py-1 transition-[background-color,box-shadow,transform] duration-50 has-[button:active]:scale-[0.98]",
                    r ? "has-[.copy-cell-btn:hover]:bg-layer-inverse/15 has-[.copy-cell-btn:hover]:ring-1 has-[.copy-cell-btn:hover]:ring-layer-inverse has-[.copy-cell-btn:active]:bg-layer-inverse/25 has-[.copy-cell-btn:focus-visible]:ring-2 has-[.copy-cell-btn:focus-visible]:ring-stroke-primary" : T ? "has-[.copy-cell-btn:hover]:bg-layer-strong has-[.copy-cell-btn:hover]:ring-1 has-[.copy-cell-btn:hover]:ring-stroke-strong has-[.copy-cell-btn:active]:bg-layer-strong has-[.copy-cell-btn:focus-visible]:ring-2 has-[.copy-cell-btn:focus-visible]:ring-stroke-primary" : "has-[.copy-cell-btn:hover]:bg-layer-raised/50 has-[.copy-cell-btn:hover]:ring-1 has-[.copy-cell-btn:hover]:ring-stroke-subtle has-[.copy-cell-btn:active]:bg-layer-raised/70 has-[.copy-cell-btn:focus-visible]:ring-2 has-[.copy-cell-btn:focus-visible]:ring-stroke-primary",
                    N && "cursor-text",
                    x && C.column.getCanResize() && "overflow-hidden"
                  ),
                  children: [
                    /* @__PURE__ */ i(
                      "span",
                      {
                        className: m(
                          x && C.column.getCanResize() && "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap"
                        ),
                        children: Vt(C.column.columnDef.cell, C.getContext())
                      }
                    ),
                    /* @__PURE__ */ i(mr, { cell: C, isTunecore: r, className: "" })
                  ]
                }
              )
            },
            C.id
          );
        })
      }
    ),
    w && t && /* @__PURE__ */ i("tr", { className: "transition-opacity duration-150 ease-in-out", children: /* @__PURE__ */ i("td", { colSpan: e.getVisibleCells().length, children: d({ row: e }) }) })
  ] });
}
const Io = K.memo(
  Zg,
  (e, t) => e.row.original === t.row.original && e.isExpanded === t.isExpanded && e.isSelected === t.isSelected && e.density === t.density && e.isTunecore === t.isTunecore && e.enableVirtualization === t.enableVirtualization && e.virtualStart === t.virtualStart && e.virtualSize === t.virtualSize && e.rowOriginalsSignature === t.rowOriginalsSignature && e.darkMode === t.darkMode && e.hasPinnedActionFade === t.hasPinnedActionFade
);
function p1({
  data: e,
  pageCount: t,
  paginationComponent: n = !0,
  columns: r,
  noDataMessage: s = "No data",
  statsBlock: a = $g,
  renderSubComponent: o = Hg,
  getRowCanExpand: l = Ug,
  getRowId: c,
  onRowClick: u = Wg,
  isRowClickable: d = Gg,
  isRefetchingData: h = !1,
  pagination: f,
  onPaginationChange: g,
  hasFilters: y = !0,
  isFilterPanelVisible: v,
  onToggleFilterPanel: x,
  filterContent: b,
  filterToggleStyle: w = "default",
  onRefetch: k,
  showMyRecords: N,
  onToggleMyRecords: T,
  expandedRows: M,
  onCollapseAllRows: C,
  hasExpandableRows: D,
  onSearch: A,
  hasActiveFilters: E = !0,
  onClear: R,
  additionalActions: B,
  tableTopContent: ee,
  searchLabel: Ce = "Search",
  clearLabel: Y = "Clear",
  fetchingLabel: z = "Fetching...",
  noResultsTitle: _ = "No results found",
  noResultsDescription: L = "No records match the currently applied filters.",
  noResultsClearLabel: oe = "Clear filters",
  noDataAvailableLabel: we = "No Data Available",
  canExpandToDialog: Ue = !1,
  dialogTitle: Fe,
  dialogDensity: We = "expanded",
  enableVirtualization: te = !1,
  estimatedRowHeight: tn = 48,
  enableColumnPinning: nn = !0,
  height: Ge,
  highlightColour: rn = "#EC542E",
  sorting: Ke,
  onSortingChange: ze,
  manualSorting: ue = !1,
  expanded: lt,
  onExpandedChange: sn,
  clearExpandedOnDataChange: on = !0,
  tableId: Xe,
  enableColumnResizing: ge = !0,
  isLoading: U = !1,
  skeletonRowCount: Ye,
  elevation: O = "default",
  rowSelection: G,
  onRowSelectionChange: ke,
  defaultPageSize: On = 50,
  paginationPosition: an = "both"
}) {
  var ns;
  const he = j((I) => I.isTunecore), [ec, tc] = se({
    pageIndex: 0,
    pageSize: On
  }), $n = f ?? ec, nc = Math.min(Ye ?? $n.pageSize, 20), rc = (I) => {
    const F = typeof I == "function" ? I($n) : I;
    (g ?? tc)(F);
  }, [ic, sc] = se([]), Ei = Ke ?? ic, oc = (I) => {
    const F = typeof I == "function" ? I(Ei) : I;
    (ze ?? sc)(F);
  }, [ac, Ri] = se({}), ln = lt ?? ac, cn = sn ?? Ri, lc = K.useCallback(
    (I) => {
      if (typeof I == "function") {
        const F = I(ln);
        cn(typeof F == "boolean" ? {} : F);
      } else
        cn(typeof I == "boolean" ? {} : I);
    },
    [ln, cn]
  ), Li = K.useCallback(() => {
    Ri({});
  }, []);
  K.useEffect(() => {
    on && lt === void 0 && Li();
  }, [e, on, lt, Li]);
  const [cc, dc] = se(!0), ct = v ?? cc, Hn = x ?? (() => dc((I) => !I)), [Bi, Fi] = se(!1), uc = () => {
    Fi(!0), A == null || A();
  }, zi = () => {
    Fi(!1), R == null || R();
  }, hc = K.useMemo(() => {
    const I = [], F = [];
    return r.forEach((H) => {
      var Pe;
      H.enablePinning && typeof H.id == "string" && H.id.length > 0 && (((Pe = H.meta) == null ? void 0 : Pe.pinSide) === "right" ? F.push(H.id) : I.push(H.id));
    }), { left: I, right: F };
  }, [r]), [fc, mc] = se(hc), dn = Ee(!1), pc = Ee({ x: 0, y: 0 }), ji = Ee(null), [_i, Oi] = se(48);
  Ae(() => {
    const I = ji.current;
    if (I == null)
      return;
    const F = new ResizeObserver(() => {
      Oi(I.getBoundingClientRect().height);
    });
    return F.observe(I), Oi(I.getBoundingClientRect().height), () => F.disconnect();
  }, []);
  const $i = (I) => {
    pc.current = { x: I.clientX, y: I.clientY }, dn.current = !1;
  }, Hi = () => {
    const I = window.getSelection();
    I && I.toString().length > 0 && (dn.current = !0);
  }, dt = Xe != null ? `tableColumnSizing:${Xe}` : null, [un, gc] = se(() => {
    if (dt == null)
      return {};
    try {
      const I = localStorage.getItem(dt);
      return I == null ? {} : JSON.parse(I);
    } catch {
      return {};
    }
  }), [Ui, hn] = se(!1), yc = K.useCallback(
    (I) => {
      gc((F) => typeof I == "function" ? I(F) : I);
    },
    []
  );
  K.useEffect(() => {
    if (!Ui && dt != null)
      try {
        Object.keys(un).length > 0 ? localStorage.setItem(dt, JSON.stringify(un)) : localStorage.removeItem(dt);
      } catch {
      }
  }, [Ui, un, dt]);
  const fn = Ee(!1), Wi = K.useMemo(
    () => r.some((I) => {
      const F = I.meta;
      return !!(F != null && F.pinSide) && !(F != null && F.pinnedBackground) && (F == null ? void 0 : F.pinnedActionFade) !== !1;
    }),
    [r]
  ), fe = $c({
    data: e,
    columns: ge ? r.map((I) => ({ ...I, minSize: I.minSize != null ? Math.min(I.minSize, 50) : void 0 })) : r,
    manualPagination: !!f,
    manualSorting: ue,
    pageCount: t,
    getRowId: c,
    autoResetPageIndex: !1,
    state: {
      pagination: $n,
      expanded: ln,
      sorting: Ei,
      columnPinning: nn ? fc : void 0,
      columnSizing: ge ? un : {},
      rowSelection: G ?? {}
    },
    onPaginationChange: rc,
    onExpandedChange: lc,
    onSortingChange: oc,
    onColumnPinningChange: nn ? mc : void 0,
    enableColumnResizing: ge,
    columnResizeMode: "onChange",
    onColumnSizingChange: ge ? yc : void 0,
    enableColumnPinning: nn,
    enableRowSelection: ke !== void 0 || G !== void 0,
    onRowSelectionChange: ke !== void 0 ? (I) => ke(
      typeof I == "function" ? I(G ?? {}) : I
    ) : void 0,
    getCoreRowModel: Gc(),
    getSortedRowModel: ue ? void 0 : Wc(),
    getPaginationRowModel: n ? Uc() : void 0,
    getExpandedRowModel: Hc(),
    getRowCanExpand: l
  }), ut = "roomy", Gi = K.useRef(null), mn = K.useMemo(
    () => Do[ut],
    [tn]
  ), Ki = Kc({
    count: fe.getRowModel().rows.length,
    getScrollElement: () => Gi.current,
    estimateSize: () => mn,
    overscan: 10,
    enabled: te
  }), Mt = te ? Ki.getVirtualItems() : fe.getRowModel().rows.map((I, F) => ({
    index: F,
    start: F * mn,
    size: mn,
    row: I
  })), Xi = K.useMemo(
    () => fe.getRowModel().rows.map((I) => I.original),
    [fe]
  ), Un = te ? ((ns = Mt == null ? void 0 : Mt[0]) == null ? void 0 : ns.start) ?? 0 : 0, Yi = te ? Ki.getTotalSize() - (Un + Mt.length * mn) : 0, Zi = (I) => fe.getHeaderGroups().map((F) => /* @__PURE__ */ i("tr", { className: Me[I].rowHeight, children: F.headers.map((H) => {
    const Pe = H.column.getIsPinned(), rs = Kg(H.column.columnDef.meta).pinnedBackground, Xn = ge && H.column.getCanResize();
    return /* @__PURE__ */ p(
      "th",
      {
        onClick: (Ne) => {
          var je;
          if (fn.current) {
            fn.current = !1;
            return;
          }
          H.column.columnDef.enableSorting !== !1 && ((je = H.column.getToggleSortingHandler()) == null || je(Ne));
        },
        className: m(
          "py-2 px-2 text-left text-sm font-medium",
          Me[I].cellPadding,
          H.column.columnDef.enableSorting !== !1 && [
            "cursor-pointer",
            "hover:underline",
            "transition-colors duration-150"
          ],
          Pe === "left" && "sticky left-0 z-10",
          Pe === "right" && "sticky right-0 z-10",
          !!Pe && !!rs && "bg-layer-raised",
          Xn && "relative overflow-hidden"
        ),
        style: {
          width: H.getSize(),
          minWidth: ge ? void 0 : H.column.columnDef.minSize,
          maxWidth: H.column.columnDef.maxSize,
          left: Pe === "left" ? `${H.column.getStart()}px` : void 0,
          right: Pe === "right" ? `${H.column.getAfter()}px` : void 0
        },
        children: [
          H.isPlaceholder ? null : /* @__PURE__ */ p(
            "div",
            {
              className: m(
                "flex items-center",
                Xn && "overflow-hidden whitespace-nowrap"
              ),
              children: [
                Vt(H.column.columnDef.header, H.getContext()),
                /* @__PURE__ */ i("span", { className: "inline-flex w-4 ml-1", children: H.column.getIsSorted() === "asc" ? /* @__PURE__ */ i(Ho, { size: "md", className: he ? "stroke-white" : "stroke-ink-primary" }) : H.column.getIsSorted() === "desc" ? /* @__PURE__ */ i(Et, { size: "md", className: he ? "stroke-white" : "stroke-ink-primary" }) : /* @__PURE__ */ i(Et, { size: "md", className: "invisible" }) })
              ]
            }
          ),
          Xn && /* @__PURE__ */ i(
            "div",
            {
              onMouseDown: (Ne) => {
                Ne.stopPropagation(), H.getResizeHandler()(Ne), hn(!0), fn.current = !0;
                const je = () => {
                  hn(!1), document.removeEventListener("mouseup", je);
                };
                document.addEventListener("mouseup", je);
              },
              onTouchStart: (Ne) => {
                Ne.stopPropagation(), H.getResizeHandler()(Ne), hn(!0), fn.current = !0;
                const je = () => {
                  hn(!1), document.removeEventListener("touchend", je);
                };
                document.addEventListener("touchend", je);
              },
              onClick: (Ne) => {
                Ne.stopPropagation();
              },
              onDoubleClick: (Ne) => {
                Ne.stopPropagation(), H.column.resetSize();
              },
              className: m(
                "absolute top-0 right-0 w-0.75 h-full cursor-col-resize select-none touch-none transition-colors duration-150",
                H.column.getIsResizing() ? "bg-action-primary" : he ? "bg-layer-inverse/50 hover:bg-action-primary" : "bg-ink-secondary/40 hover:bg-action-primary"
              ),
              role: "separator",
              "aria-orientation": "vertical",
              tabIndex: -1
            }
          )
        ]
      },
      H.id
    );
  }) }, F.id)), qi = () => fe.getFooterGroups().map((I) => /* @__PURE__ */ i("tr", { children: I.headers.map((F) => {
    const H = F.isPlaceholder ? null : Vt(F.column.columnDef.footer, F.getContext()), Pe = H == null || typeof H == "string" && H.trim() === "";
    return /* @__PURE__ */ i("th", { className: "px-4 py-2", children: Pe ? /* @__PURE__ */ i("span", { className: "sr-only", children: "Empty footer cell" }) : H }, F.id);
  }) }, I.id)), Wn = b != null, Gn = n && (an === "top" || an === "both"), Ji = n && (an === "bottom" || an === "both"), Kn = a.length > 0 || y || Wn || Ue || Gn, Qi = s === "No data" || s === "No Data", pn = Bi && E && Qi && R != null, es = !Bi, ts = (I) => /* @__PURE__ */ i("div", { className: "flex min-h-32 flex-col items-center justify-center gap-2 px-4 py-4 text-center", children: I ? /* @__PURE__ */ p(ce, { children: [
    /* @__PURE__ */ i(dd, { size: "xl", className: "stroke-ink-secondary" }),
    /* @__PURE__ */ i(W, { as: "subtitle", children: _ }),
    /* @__PURE__ */ i(W, { as: "p", className: "max-w-md text-ink-secondary", children: L }),
    /* @__PURE__ */ i(
      $,
      {
        type: "button",
        label: oe,
        variant: "secondary",
        onClick: zi,
        className: "mt-2"
      }
    )
  ] }) : /* @__PURE__ */ p(ce, { children: [
    /* @__PURE__ */ i(ud, { size: "xl", className: "stroke-ink-secondary" }),
    /* @__PURE__ */ i(W, { as: "subtitle", children: Qi ? we : s })
  ] }) });
  return /* @__PURE__ */ p("div", { className: "flex w-full flex-col", children: [
    /* @__PURE__ */ p(
      "div",
      {
        "data-slot": "table-surface",
        className: m(
          "flex w-full flex-col rounded-sm",
          O === "default" && "shadow-md",
          O === "system" && "shadow-system"
        ),
        children: [
          Kn && /* @__PURE__ */ p(
            "div",
            {
              className: m(
                "flex w-full flex-col items-stretch gap-2 rounded-t-sm p-2 md:flex-row md:items-center md:gap-0",
                "bg-layer-raised"
              ),
              children: [
                a.length > 0 && /* @__PURE__ */ i("div", { className: "flex min-w-0 w-full flex-wrap gap-x-8 gap-y-2 md:w-auto", children: a.map((I) => /* @__PURE__ */ p(
                  W,
                  {
                    as: "bodySm",
                    className: m(
                      "font-semibold uppercase text-ink-primary",
                      he ? "font-tunecore" : "font-sentric"
                    ),
                    children: [
                      /* @__PURE__ */ p("span", { className: "block sm:inline", children: [
                        I.title,
                        ": "
                      ] }),
                      /* @__PURE__ */ i("span", { style: { color: I.highlight ? rn : "" }, children: I.value })
                    ]
                  },
                  I.title
                )) }),
                /* @__PURE__ */ p("div", { className: "flex w-full shrink-0 flex-wrap items-center justify-end gap-2 md:ml-auto md:w-auto md:flex-nowrap", children: [
                  Gn && /* @__PURE__ */ i(Og, { table: fe, isLoading: U }),
                  Ue && /* @__PURE__ */ p(Zo, { children: [
                    /* @__PURE__ */ i(Hd, { asChild: !0, children: /* @__PURE__ */ i(
                      $,
                      {
                        label: /* @__PURE__ */ i(
                          gd,
                          {
                            size: "md",
                            className: m(
                              "transition-colors duration-300",
                              he ? "stroke-white group-hover:stroke-action-primary" : "stroke-black group-hover:stroke-black"
                            )
                          }
                        ),
                        "aria-label": "Expand table",
                        tooltip: !0,
                        tooltipText: "Expand table",
                        variant: "primary",
                        size: "icon-sm",
                        className: "p-1 ring-0"
                      }
                    ) }),
                    /* @__PURE__ */ p(Kr, { className: "max-w-[95vw] max-h-[95vh] w-full h-full", children: [
                      Fe != null && Fe !== "" && /* @__PURE__ */ i(Xr, { children: /* @__PURE__ */ i(Yr, { children: /* @__PURE__ */ i(W, { as: "subtitle", children: Fe }) }) }),
                      /* @__PURE__ */ p("div", { className: "flex flex-col w-full h-full pt-4 shadow-md", children: [
                        /* @__PURE__ */ i("div", { className: "w-0 min-w-full overflow-x-auto overflow-y-auto rounded-lg", children: /* @__PURE__ */ p("table", { className: "w-full bg-layer-default table-fixed", children: [
                          /* @__PURE__ */ i(
                            "thead",
                            {
                              className: m(
                                "sticky top-0 z-20 uppercase font-sentric-alt text-nowrap bg-layer-raised text-ink-primary"
                              ),
                              children: Zi(We)
                            }
                          ),
                          /* @__PURE__ */ p("tbody", { children: [
                            fe.getRowModel().rows.map((I) => /* @__PURE__ */ i(
                              Io,
                              {
                                row: I,
                                isExpanded: I.getIsExpanded(),
                                isSelected: I.getIsSelected(),
                                density: We,
                                isTunecore: he,
                                enableVirtualization: !1,
                                virtualStart: 0,
                                virtualSize: Do[We] ?? tn,
                                getRowCanExpand: l,
                                isRowClickable: d,
                                onRowClick: u,
                                renderSubComponent: o,
                                handleMouseDown: $i,
                                handleMouseUp: Hi,
                                isTextSelectedRef: dn,
                                rowOriginalsSignature: Xi,
                                darkMode: !1,
                                enableColumnResizing: ge,
                                hasPinnedActionFade: Wi
                              },
                              I.id
                            )),
                            e.length === 0 && /* @__PURE__ */ i("tr", { className: Me[We].rowHeight, children: /* @__PURE__ */ i(
                              "td",
                              {
                                colSpan: fe.getAllColumns().length,
                                className: m(
                                  "text-center font-sentric text-ink-primary",
                                  Me[We].cellPadding
                                ),
                                children: pn || es ? ts(pn) : s
                              }
                            ) })
                          ] }),
                          /* @__PURE__ */ i(
                            "tfoot",
                            {
                              className: m(
                                "uppercase text-ink-primary bg-layer-raised",
                                he ? "font-tunecore" : "font-sentric"
                              ),
                              children: qi()
                            }
                          )
                        ] }) }),
                        (Gn || Ji) && /* @__PURE__ */ i(Mo, { table: fe, isLoading: U })
                      ] })
                    ] })
                  ] }),
                  (y || Wn) && (w === "chevron" ? /* @__PURE__ */ p(
                    "button",
                    {
                      type: "button",
                      "aria-label": ct ? "Hide filters" : "Show filters",
                      "aria-expanded": ct,
                      onClick: Hn,
                      className: "flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-transparent hover:bg-layer-raised/80 focus-visible:outline-none",
                      children: [
                        /* @__PURE__ */ i(
                          Et,
                          {
                            size: "md",
                            className: m(
                              "transition-transform duration-200 stroke-ink-primary",
                              !ct && "rotate-180"
                            )
                          }
                        ),
                        /* @__PURE__ */ i("span", { className: "sr-only", children: ct ? "Hide filters" : "Show filters" })
                      ]
                    }
                  ) : /* @__PURE__ */ i(
                    $,
                    {
                      label: /* @__PURE__ */ i(md, { size: "md", className: m("transition-colors duration-300", he ? "stroke-white group-hover:stroke-action-primary" : "stroke-ink-on-accent") }),
                      "aria-label": ct ? "Hide filters" : "Show filters",
                      variant: he ? "primary" : "iconAction",
                      onClick: Hn,
                      className: m(he ? "p-1" : "bg-action-primary border-action-primary hover:bg-action-primary-hover hover:border-action-primary-hover active:bg-action-primary-pressed active:border-action-primary-pressed")
                    }
                  ))
                ] })
              ]
            }
          ),
          Wn && /* @__PURE__ */ i(Rg, { children: /* @__PURE__ */ i(
            Lg,
            {
              filterRevealComponent: b,
              isFilterPanelVisible: ct,
              onToggleFilterPanel: Hn,
              onRefetch: k,
              showMyRecords: N,
              onToggleMyRecords: T,
              expandedRows: M ?? (D ? ln : void 0),
              onCollapseAllRows: C ?? (D ? () => cn({}) : void 0),
              onSearch: uc,
              onClear: zi,
              searchLabel: Ce,
              clearLabel: Y,
              hasExpandableRows: D === !0 || M !== void 0,
              additionalActions: B
            }
          ) }),
          ee != null && /* @__PURE__ */ i("div", { className: m("px-2 py-1.5 border-stroke-subtle bg-layer-default", !Kn && "rounded-t-sm"), children: ee }),
          /* @__PURE__ */ p(
            Gr,
            {
              className: m(
                // w-0 min-w-full (not w-full): zeroes this box's max-content contribution so
                // a flex/grid ancestor can't be floored by the table's own width, then
                // stretches back to the available space. Matches the dialog-mode wrapper.
                "w-0 min-w-full overflow-hidden",
                Kn || ee != null ? "rounded-b-sm" : "rounded-sm"
              ),
              style: Ge != null && Ge !== "" ? { height: Ge } : { maxHeight: "100%" },
              showScrollIndicators: !0,
              indicatorOrientation: "horizontal",
              indicatorTopInset: _i,
              indicatorBottomInset: 0,
              children: [
                h && !U && /* @__PURE__ */ i(
                  "div",
                  {
                    className: m(
                      "absolute inset-0 z-10 flex items-center justify-center backdrop-blur-sm",
                      he ? "bg-layer-inverse/75" : "bg-layer-default/75"
                    ),
                    children: /* @__PURE__ */ i(W, { as: "bodyLg", className: "text-ink-primary", children: z })
                  }
                ),
                /* @__PURE__ */ p("table", { className: m("w-full table-fixed", he ? "bg-layer-inverse" : "bg-layer-default"), children: [
                  /* @__PURE__ */ i(
                    "thead",
                    {
                      ref: ji,
                      className: m(
                        "sticky top-0 z-20 uppercase font-sentric-alt text-nowrap bg-layer-raised text-ink-primary"
                      ),
                      children: Zi(ut)
                    }
                  ),
                  /* @__PURE__ */ i(
                    "tbody",
                    {
                      ref: Gi,
                      className: m(
                        "relative",
                        te && "w-full block"
                      ),
                      children: U ? /* @__PURE__ */ i(
                        _g,
                        {
                          visibleColumns: fe.getVisibleLeafColumns(),
                          rowCount: nc,
                          density: ut
                        }
                      ) : /* @__PURE__ */ p(ce, { children: [
                        Un > 0 && /* @__PURE__ */ i("tr", { children: /* @__PURE__ */ i("td", { style: { height: `${Un}px` } }) }),
                        Mt.map((I) => {
                          const F = te && !("row" in I) ? fe.getRowModel().rows[I.index] : I.row;
                          return /* @__PURE__ */ i(
                            Io,
                            {
                              row: F,
                              isExpanded: F.getIsExpanded(),
                              isSelected: F.getIsSelected(),
                              density: ut,
                              isTunecore: he,
                              enableVirtualization: te,
                              virtualStart: I.start,
                              virtualSize: I.size,
                              getRowCanExpand: l,
                              isRowClickable: d,
                              onRowClick: u,
                              renderSubComponent: o,
                              handleMouseDown: $i,
                              handleMouseUp: Hi,
                              isTextSelectedRef: dn,
                              rowOriginalsSignature: Xi,
                              darkMode: !0,
                              enableColumnResizing: ge,
                              hasPinnedActionFade: Wi
                            },
                            F.id
                          );
                        }),
                        Yi > 0 && /* @__PURE__ */ i("tr", { children: /* @__PURE__ */ i("td", { style: { height: `${Yi}px` } }) }),
                        e.length === 0 && /* @__PURE__ */ i("tr", { className: Me[ut].rowHeight, children: /* @__PURE__ */ i(
                          "td",
                          {
                            colSpan: fe.getAllColumns().length,
                            className: m(
                              "text-center font-sentric text-ink-primary",
                              Me[ut].cellPadding
                            ),
                            children: pn || es ? ts(pn) : s
                          }
                        ) })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ i(
                    "tfoot",
                    {
                      className: m(
                        "border-none uppercase text-ink-primary",
                        he ? "font-tunecore" : "font-sentric"
                      ),
                      children: qi()
                    }
                  )
                ] }),
                /* @__PURE__ */ i(Cn, { orientation: "horizontal" }),
                /* @__PURE__ */ i(Cn, { orientation: "vertical", className: "z-10", style: { top: _i } })
              ]
            }
          )
        ]
      }
    ),
    Ji && /* @__PURE__ */ i(Mo, { table: fe, isLoading: U })
  ] });
}
const Ao = {
  default: "bg-layer-raised",
  primary: "bg-action-primary",
  secondary: "bg-canvas-secondary",
  success: "bg-layer-success",
  warning: "bg-canvas-secondary",
  danger: "bg-action-primary",
  info: "bg-action-secondary",
  neutral: "bg-ink-secondary",
  muted: "bg-ink-secondary",
  outline: "bg-transparent border border-stroke-subtle"
};
function qg({ label: e, children: t, disabled: n = !1 }) {
  return n ? /* @__PURE__ */ i(
    Ln,
    {
      disabled: !0,
      className: "opacity-50 cursor-not-allowed",
      children: e
    }
  ) : /* @__PURE__ */ p(Jd, { children: [
    /* @__PURE__ */ i(ea, { className: "cursor-pointer", children: e }),
    /* @__PURE__ */ i(ta, { className: "bg-layer-default border border-stroke-subtle", children: t })
  ] });
}
function g1({ label: e, onClick: t, statusVariant: n }) {
  return /* @__PURE__ */ p(
    Ln,
    {
      onClick: t,
      className: "flex items-center gap-2 cursor-pointer",
      children: [
        n && /* @__PURE__ */ i(
          "span",
          {
            className: `w-3 h-3 rounded-full shrink-0 ${Ao[n] ?? Ao.default}`
          }
        ),
        e
      ]
    }
  );
}
const y1 = ({ children: e, ariaLabel: t, disabled: n = !1, onOpenChange: r }) => {
  const [s, a] = K.useState(!1), o = (d) => {
    a(d), r == null || r(d);
  }, l = (d) => {
    d.stopPropagation();
  }, u = (Array.isArray(e) ? e.flat() : [e]).map((d, h) => {
    if (!K.isValidElement(d))
      return null;
    if (d.type === qg)
      return d;
    const f = d.props;
    if (f.variant === "dropdown") {
      const g = !!f.disabled;
      return /* @__PURE__ */ p(
        Ln,
        {
          disabled: g,
          onClick: g ? void 0 : f.onClick,
          className: g ? void 0 : "cursor-pointer",
          children: [
            f.icon != null && /* @__PURE__ */ i("span", { className: "mr-2", children: f.icon }),
            f.label
          ]
        },
        h
      );
    }
    return d;
  });
  return /* @__PURE__ */ i("div", { className: "flex justify-end w-full group", children: /* @__PURE__ */ p(Zd, { open: s, onOpenChange: o, children: [
    /* @__PURE__ */ i(qd, { asChild: !0, children: /* @__PURE__ */ i(
      $,
      {
        label: /* @__PURE__ */ i(pd, { size: "md" }),
        disabled: n,
        variant: "iconAction",
        "aria-label": t,
        onClick: l
      }
    ) }),
    /* @__PURE__ */ i(na, { align: "end", children: u })
  ] }) });
};
function v1({ isExpanded: e, onToggle: t, className: n }) {
  const r = j((a) => a.isTunecore), s = e ? Ho : Et;
  return /* @__PURE__ */ i(
    "button",
    {
      type: "button",
      "aria-label": e ? "Collapse row" : "Expand row",
      "aria-expanded": e,
      onClick: (a) => {
        a.stopPropagation(), t();
      },
      onMouseDown: (a) => a.stopPropagation(),
      className: m(
        "inline-flex h-4 w-4 shrink-0 cursor-pointer items-center justify-center rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stroke-primary",
        n
      ),
      children: /* @__PURE__ */ i(s, { className: m("h-4 w-4", r ? "stroke-white" : "stroke-ink-primary") })
    }
  );
}
const Jg = {
  roomy: {
    subcomponentContainer: "py-6 px-10 gap-6",
    subcomponentColGap: "gap-4",
    fieldsGap: "gap-4"
  },
  compact: {
    subcomponentContainer: "py-5 px-6 gap-4",
    subcomponentColGap: "gap-3",
    fieldsGap: "gap-3"
  },
  condensed: {
    subcomponentContainer: "py-4 px-4 gap-3",
    subcomponentColGap: "gap-2",
    fieldsGap: "gap-2"
  }
}, b1 = ({
  children: e,
  density: t = "roomy"
}) => /* @__PURE__ */ i(
  "div",
  {
    className: m(
      "flex flex-col p-4 transition-all duration-150 ease-in-out bg-layer-raised/50 rounded-md",
      Jg[t].subcomponentContainer
    ),
    children: e
  }
), x1 = at.Root, Qg = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  at.List,
  {
    ref: n,
    className: m(
      "inline-flex w-full gap-1 items-center font-sentric-alt justify-evenly rounded-lg p-1 bg-layer-default border border-stroke-subtle text-ink-primary",
      e
    ),
    ...t
  }
));
Qg.displayName = at.List.displayName;
const ey = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  at.Trigger,
  {
    ref: n,
    className: m(
      "inline-flex w-full items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm ring-offset-layer-raised transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
      "hover:bg-layer-raised data-[state=active]:bg-layer-raised data-[state=active]:text-ink-primary data-[state=active]:shadow-sm",
      e
    ),
    ...t
  }
));
ey.displayName = at.Trigger.displayName;
const ty = S.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ i(
  at.Content,
  {
    ref: n,
    className: m(
      "ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
ty.displayName = at.Content.displayName;
function w1({ position: e = "top-center", ...t }) {
  const n = j((a) => a.isTunecore);
  return /* @__PURE__ */ p(ce, { children: [
    /* @__PURE__ */ i("style", { children: `
          [data-sonner-toaster] [data-type="success"] {
            background-color: var(--success-bg) !important;
            border-color: var(--success-border) !important;
            color: var(--success-text) !important;
          }

          [data-sonner-toaster] [data-type="error"] {
            background-color: var(--error-bg) !important;
            border-color: var(--error-border) !important;
            color: var(--error-text) !important;
          }

          [data-sonner-toaster] [data-type="warning"] {
            background-color: var(--warning-bg) !important;
            border-color: var(--warning-border) !important;
            color: var(--warning-text) !important;
          }

          [data-sonner-toaster] [data-type="info"] {
            background-color: var(--normal-bg) !important;
            border-color: var(--normal-border) !important;
            color: var(--normal-text) !important;
          }

          [data-sonner-toaster] [data-type="default"] {
            background-color: var(--normal-bg) !important;
            border-color: var(--normal-border) !important;
            color: var(--normal-text) !important;
          }

          /* sonner's built-in theme="dark" stylesheet sets [data-description] to a
             fixed light grey (hsl(0, 0%, 91%)), overriding the colours above on the
             description child regardless of our per-type background. Force it back
             to match the title on every type. */
          [data-sonner-toaster] [data-type="success"] [data-description] {
            color: var(--success-text) !important;
          }

          [data-sonner-toaster] [data-type="error"] [data-description] {
            color: var(--error-text) !important;
          }

          [data-sonner-toaster] [data-type="warning"] [data-description] {
            color: var(--warning-text) !important;
          }

          [data-sonner-toaster] [data-type="info"] [data-description] {
            color: var(--normal-text) !important;
          }

          [data-sonner-toaster] [data-type="default"] [data-description] {
            color: var(--normal-text) !important;
          }
        ` }),
    /* @__PURE__ */ i(
      Xc,
      {
        theme: n ? "dark" : "light",
        className: `toaster group ${n ? "font-tunecore" : "font-sentric-alt"}`,
        style: n ? {
          "--normal-bg": "#282828",
          // tunecore-dark-element
          "--normal-text": "#fff",
          "--normal-border": "#555555",
          // tunecore-light-grey
          "--success-bg": "#00ef86",
          // tunecore-green
          "--success-text": "#000",
          "--success-border": "#00ef86",
          "--error-bg": "#F44336",
          // tunecore-error-red
          "--error-text": "#000",
          "--error-border": "#F44336",
          "--warning-bg": "#EE9E26",
          // tunecore-warning-orange
          "--warning-text": "#000",
          "--warning-border": "#EE9E26"
        } : {
          "--normal-bg": "#E9E8E8",
          // sentric-rebrand-light-grey
          "--normal-text": "#231F20",
          // sentric-rebrand-dark-grey
          "--normal-border": "#D9D9D9",
          // sentric-rebrand-mid-grey
          "--success-bg": "#25BCBB",
          // sentric-teal
          "--success-text": "#000",
          "--success-border": "#25BCBB",
          "--error-bg": "#ef4444",
          "--error-text": "#000",
          "--error-border": "#ef4444",
          "--warning-bg": "#fb923c",
          "--warning-text": "#000",
          "--warning-border": "#fb923c"
        },
        position: e,
        ...t
      }
    )
  ] });
}
const ny = Ve(
  "isolate inline-grid shrink-0 grid-flow-col auto-cols-[minmax(max-content,1fr)] items-center overflow-hidden rounded-full border border-stroke-default bg-layer-disabled gap-0.5 shadow-[inset_0_1px_9.7px_var(--color-layer-disabled)]",
  {
    variants: {
      size: {
        sm: "h-6 p-0.5",
        lg: "h-8 p-1"
      }
    },
    defaultVariants: {
      size: "sm"
    }
  }
), ry = Ve(
  "relative flex h-full items-center justify-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action-primary",
  {
    variants: {
      size: {
        sm: "min-w-18 px-3",
        lg: "min-w-22 px-4"
      },
      state: {
        active: "text-ink-on-accent cursor-default rounded-full",
        inactive: "text-ink-secondary hover:text-ink-primary cursor-pointer rounded",
        activeDisabled: "text-ink-disabled cursor-default opacity-50 rounded-full",
        inactiveDisabled: "text-ink-disabled cursor-not-allowed rounded"
      },
      hasIcon: {
        true: "gap-1.5",
        false: ""
      }
    },
    defaultVariants: {
      size: "sm",
      state: "inactive",
      hasIcon: !1
    }
  }
);
function k1({
  value: e,
  onChange: t,
  options: n,
  disabled: r,
  size: s,
  className: a,
  ariaLabel: o = "Toggle",
  label: l,
  smallFont: c
}) {
  const u = S.useId(), d = /* @__PURE__ */ i(
    "div",
    {
      role: "radiogroup",
      "aria-labelledby": l !== void 0 && l !== "" ? u : void 0,
      "aria-label": l !== void 0 && l !== "" ? void 0 : o,
      className: m(ny({ size: s }), a),
      children: n.map((h) => /* @__PURE__ */ i(
        iy,
        {
          option: h,
          isSelected: e === h.value,
          isDisabled: r ?? h.disabled,
          onChange: t,
          pillLayoutId: `${u}-pill`,
          size: s
        },
        h.value
      ))
    }
  );
  return l === void 0 || l === "" ? d : /* @__PURE__ */ p("div", { className: "flex flex-col items-start gap-1", children: [
    /* @__PURE__ */ i(W, { as: c ? "label" : "bodySm", id: u, className: "font-medium", children: l }),
    d
  ] });
}
const Ql = S.forwardRef(({ option: e, isSelected: t, isDisabled: n, onChange: r, onClick: s, pillLayoutId: a, size: o, ...l }, c) => {
  const u = Eg(), d = !t && (n === !1 || n === void 0), h = t ? n === !0 ? "activeDisabled" : "active" : n === !0 ? "inactiveDisabled" : "inactive", f = e.icon !== void 0 && e.icon !== null, g = (e.label === void 0 || e.label === null || e.label === "") && e.tooltip !== void 0 && e.tooltip !== null && e.tooltip !== "" ? e.tooltip : void 0;
  return /* @__PURE__ */ p(
    "button",
    {
      ...l,
      ref: c,
      type: "button",
      role: "radio",
      "aria-checked": t,
      "aria-disabled": n === !0 || void 0,
      "aria-label": g,
      tabIndex: d ? 0 : -1,
      onClick: (v) => {
        v.stopPropagation(), s == null || s(v), d && r(e.value);
      },
      className: m(ry({ size: o, state: h, hasIcon: f })),
      children: [
        t && /* @__PURE__ */ i(
          Yl.span,
          {
            layoutId: a,
            transition: u === !0 ? { duration: 0 } : { type: "tween", duration: 0.5, ease: [0.65, 0, 0.35, 1] },
            className: "absolute inset-0 -z-10 rounded-full bg-action-primary shadow-small-orange"
          }
        ),
        e.icon !== void 0 && e.icon !== null && /* @__PURE__ */ i("span", { className: "flex items-center", children: e.icon }),
        e.label !== void 0 && e.label !== null && e.label !== "" && /* @__PURE__ */ i(
          W,
          {
            as: "label",
            className: "whitespace-nowrap text-inherit [text-box-edge:cap_alphabetic] [text-box-trim:trim-both]",
            children: e.label
          }
        )
      ]
    }
  );
});
Ql.displayName = "ToggleButtonInner";
function iy({
  option: e,
  isSelected: t,
  isDisabled: n,
  onChange: r,
  pillLayoutId: s,
  size: a
}) {
  const o = /* @__PURE__ */ i(
    Ql,
    {
      option: e,
      isSelected: t,
      isDisabled: n,
      onChange: r,
      pillLayoutId: s,
      size: a
    }
  );
  return e.tooltip !== void 0 && e.tooltip !== "" ? /* @__PURE__ */ i(_t, { children: /* @__PURE__ */ p(Ot, { children: [
    /* @__PURE__ */ i($t, { asChild: !0, children: o }),
    /* @__PURE__ */ i(xt, { children: /* @__PURE__ */ i("p", { children: e.tooltip }) })
  ] }) }) : o;
}
const sy = S.forwardRef(
  ({
    label: e = "",
    value: t,
    onChange: n,
    column: r = !0,
    smallFont: s = !1,
    className: a,
    labelClassName: o,
    id: l,
    hasError: c = !1,
    readOnly: u = !1,
    disabled: d = !1,
    showTooltip: h = !0,
    tooltipContentClassName: f,
    tooltipSideOffset: g = 4,
    binaryOnly: y = !1,
    ...v
  }, x) => {
    const b = S.useId(), w = l ?? `triStateCheckbox-${b}`, k = De((B) => y ? B === "Y" ? "N" : "Y" : B === "N" ? "Y" : B === "Y" ? null : "N", [y]), N = De(() => {
      u || d || n(k(t));
    }, [u, d, n, k, t]), T = De((B) => {
      (B.key === " " || B.key === "Enter") && (B.preventDefault(), !u && !d && n(k(t)));
    }, [u, d, n, k, t]), M = () => t === "Y" ? "Y" : t === "N" ? "N" : "??", C = () => t === "Y" ? "true" : t === "N" ? "false" : "mixed", D = (B) => B === "Y" ? "Yes" : B === "N" ? "No" : "Value is not defined (empty or null)", A = d || u, E = `${e ? `${e}: ` : ""}${D(t)}`, R = /* @__PURE__ */ p(
      "div",
      {
        className: m(
          r ? "flex flex-col-reverse justify-evenly" : "flex items-center gap-2"
        ),
        children: [
          /* @__PURE__ */ p(
            "button",
            {
              ref: x,
              id: w,
              type: "button",
              role: "checkbox",
              "aria-checked": C(),
              "aria-readonly": u,
              "aria-disabled": A,
              "aria-label": e || `Checkbox state: ${D(t)}`,
              onClick: N,
              onKeyDown: T,
              disabled: A,
              tabIndex: A ? -1 : 0,
              className: m(
                "h-6 w-6 shrink-0 font-sentric-alt rounded border-stroke-heavy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action-primary flex items-center justify-center",
                {
                  "bg-action-secondary text-ink-primary": t === "Y",
                  "bg-action-primary text-ink-primary": t === "N",
                  "bg-layer-raised text-ink-primary": t === null
                },
                A && "opacity-50 cursor-not-allowed",
                a
              ),
              ...v,
              children: [
                /* @__PURE__ */ i("span", { className: "font-bold select-none text-md", "aria-hidden": "true", children: M() }),
                /* @__PURE__ */ p("span", { className: "sr-only", children: [
                  e ? `${e}: ` : "",
                  D(t),
                  u ? " (read-only)" : ""
                ] })
              ]
            }
          ),
          e && /* @__PURE__ */ i(
            "label",
            {
              htmlFor: w,
              onClick: A ? void 0 : N,
              className: m(
                "whitespace-nowrap text-ink-primary font-sentric-alt",
                s ? "text-xs" : "text-sm",
                A ? "cursor-not-allowed opacity-50" : "hover:cursor-pointer active:cursor-pointer",
                o,
                c && "text-red-800 font-semibold dark:text-red-500"
              ),
              children: e
            }
          )
        ]
      }
    );
    return h ? /* @__PURE__ */ i(_t, { children: /* @__PURE__ */ p(Ot, { children: [
      /* @__PURE__ */ i($t, { asChild: !0, children: R }),
      /* @__PURE__ */ i(
        xt,
        {
          sideOffset: g,
          className: f,
          children: /* @__PURE__ */ i("p", { children: E })
        }
      )
    ] }) }) : R;
  }
);
sy.displayName = "TriStateCheckbox";
export {
  Cy as Accordion,
  Jc as AccordionContent,
  Zc as AccordionItem,
  Qc as AccordionItemNumber,
  qc as AccordionTrigger,
  $o as Alert,
  yr as AlertDescription,
  gr as AlertTitle,
  Py as Badge,
  M0 as Breadcrumb,
  R0 as BreadcrumbEllipsis,
  I0 as BreadcrumbItem,
  A0 as BreadcrumbLink,
  D0 as BreadcrumbList,
  V0 as BreadcrumbPage,
  E0 as BreadcrumbSeparator,
  $ as Button,
  L0 as ButtonGroup,
  F0 as ButtonGroupSeparator,
  B0 as ButtonGroupText,
  Rt as Calendar,
  Td as CancelButton,
  Ld as ChartContainer,
  j0 as ChartLegend,
  zd as ChartLegendContent,
  Bd as ChartStyle,
  z0 as ChartTooltip,
  Fd as ChartTooltipContent,
  ds as ChunkedUploadPlugin,
  _d as CodedInput,
  U0 as Combobox,
  Qo as Command,
  O0 as CommandDialog,
  Xd as CommandEmpty,
  Yn as CommandGroup,
  Gd as CommandInput,
  Zn as CommandItem,
  Kd as CommandList,
  $0 as CommandSeparator,
  H0 as CommandShortcut,
  Sd as ConfirmButton,
  Yd as Container,
  _y as DarkModeIcon,
  W0 as DatePicker,
  G0 as DateRangePicker,
  Dd as DeleteButton,
  Zo as Dialog,
  _0 as DialogClose,
  Kr as DialogContent,
  Jo as DialogDescription,
  Wd as DialogFooter,
  Xr as DialogHeader,
  qo as DialogOverlay,
  Ud as DialogPortal,
  Yr as DialogTitle,
  Hd as DialogTrigger,
  Zd as DropdownMenu,
  Qd as DropdownMenuCheckboxItem,
  na as DropdownMenuContent,
  K0 as DropdownMenuGroup,
  Ln as DropdownMenuItem,
  tu as DropdownMenuLabel,
  X0 as DropdownMenuPortal,
  Y0 as DropdownMenuRadioGroup,
  eu as DropdownMenuRadioItem,
  nu as DropdownMenuSeparator,
  ru as DropdownMenuShortcut,
  Jd as DropdownMenuSub,
  ta as DropdownMenuSubContent,
  ea as DropdownMenuSubTrigger,
  qd as DropdownMenuTrigger,
  nd as ErrorContainer,
  lu as FileDropzone,
  Z0 as Form,
  xr as FormCheckbox,
  hu as FormControl,
  fu as FormDescription,
  q0 as FormField,
  vu as FormInput,
  du as FormItem,
  uu as FormLabel,
  mu as FormMessage,
  xu as FormMultipleInput,
  wu as FormNumberInput,
  ku as FormTextarea,
  Oo as Heading,
  Ry as IconAccounting,
  Dy as IconAccounts,
  Ey as IconAcknowledgements,
  n0 as IconAlert,
  bd as IconAllUsers,
  s0 as IconArchive,
  k0 as IconBan,
  Go as IconBin,
  x0 as IconCW,
  Et as IconChevronDown,
  Ur as IconChevronLeft,
  Wr as IconChevronRight,
  Ho as IconChevronUp,
  g0 as IconCircleAlert,
  p0 as IconCircleCheckBig,
  Qy as IconCircleDashed,
  Iy as IconClientSetup,
  m0 as IconClock,
  Wo as IconClose,
  Fy as IconCompanySettings,
  u0 as IconCopy,
  kd as IconCopyTableMeta,
  Zy as IconCreate,
  Uo as IconCross,
  Wy as IconDownloadFile,
  pd as IconEdit,
  xd as IconEllipsis,
  gd as IconExpand,
  r0 as IconEyes,
  v0 as IconFileText,
  ud as IconFileX,
  md as IconFilter,
  N0 as IconGigs,
  Uy as IconHamburger,
  wd as IconInfo,
  My as IconInputFile,
  cd as IconInputSearch,
  Gy as IconLine,
  h0 as IconLock,
  c0 as IconMapMinus,
  l0 as IconMapPinMinus,
  a0 as IconMapPinPlus,
  o0 as IconMapPlus,
  P0 as IconMatch,
  d0 as IconModernisation,
  Ky as IconPagePrev,
  yd as IconPlus,
  hd as IconPrimaryButtonArrow,
  Ly as IconPublishers,
  fd as IconRefresh,
  w0 as IconRefreshCWOff,
  Vy as IconRegistration,
  t0 as IconRestartList,
  C0 as IconSave,
  dd as IconSearchX,
  b0 as IconSend,
  $y as IconSideBarClose,
  Hy as IconSideBarOpen,
  Ay as IconSongManagement,
  e0 as IconSpotify,
  i0 as IconSquarePen,
  zy as IconSystemConfig,
  od as IconTablePageEnd,
  ad as IconTablePageNext,
  ld as IconTablePagePrev,
  sd as IconTablePageStart,
  jy as IconTestFeatures,
  nt as IconTick,
  f0 as IconUnlock,
  S0 as IconUpdateStatus,
  y0 as IconUpload,
  vd as IconUser,
  qy as IconUserEdit,
  By as IconUserManagement,
  Xy as IconValidationErrors,
  Yy as IconValidationErrorsCrossed,
  T0 as IconViewDetails,
  Jy as IconWandSparkles,
  P as IconWrapper,
  ia as Label,
  Oy as LightModeIcon,
  J0 as LoadingOverlay,
  u1 as MusicCardSkeleton,
  Cd as NextButton,
  Ze as OverlaySkeleton,
  Q0 as ParentBoundedLoadingOverlay,
  Zr as Popover,
  Rn as PopoverContent,
  qr as PopoverTrigger,
  Pd as PreviousButton,
  r1 as RadioGroup,
  i1 as RadioGroupItem,
  Md as SaveButton,
  Gr as ScrollArea,
  Cn as ScrollBar,
  s1 as ScrollableListContainer,
  da as Select,
  Qr as SelectContent,
  o1 as SelectGroup,
  ei as SelectItem,
  Eu as SelectLabel,
  fa as SelectScrollDownButton,
  ha as SelectScrollUpButton,
  Ru as SelectSeparator,
  Jr as SelectTrigger,
  ua as SelectValue,
  e1 as SentricLogo,
  ca as SentricLogoLoader,
  a1 as Sheet,
  c1 as SheetClose,
  Fu as SheetContent,
  Ou as SheetDescription,
  ju as SheetFooter,
  zu as SheetHeader,
  ma as SheetOverlay,
  Lu as SheetPortal,
  _u as SheetTitle,
  l1 as SheetTrigger,
  Xu as SidebarFooter,
  d1 as SidebarProvider,
  Gu as SidebarRail,
  Ku as SidebarToggleButton,
  Yu as Skeleton,
  h1 as Spinner,
  f1 as Switch,
  p1 as Table,
  y1 as TableActionsDropdown,
  qg as TableActionsSubMenu,
  g1 as TableActionsSubMenuItem,
  v1 as TableExpandChevron,
  Rg as TableFiltersContainer,
  Lg as TableFiltersMain,
  Fg as TableFiltersReveal,
  Mo as TablePagination,
  b1 as TableRowSubComponent,
  x1 as Tabs,
  ty as TabsContent,
  Qg as TabsList,
  ey as TabsTrigger,
  W as Text,
  w1 as Toaster,
  k1 as Toggle,
  Ot as Tooltip,
  xt as TooltipContent,
  _t as TooltipProvider,
  $t as TooltipTrigger,
  sy as TriStateCheckbox,
  n1 as Wizard,
  Du as WizardNavigation,
  Vu as WizardProgress,
  rd as badgeVariants,
  Id as buttonGroupVariants,
  vr as buttonVariants,
  m as cn,
  t1 as createWizardStore,
  Bn as useFormField,
  $d as useScrollIndicators,
  ya as useSidebar,
  j as useThemeStore
};
//# sourceMappingURL=index.js.map
